// Simple i18n for Leo AI Acting Coach (PL default, EN)
export const LANGS = ["pl", "en", "ja"];

const T = {
  pl: {
    // Nav / general
    "nav.scenes": "Sceny / Self-tape",
    "nav.plans": "Plany",
    "nav.logout": "Wyloguj",
    "nav.language": "Język",
    "brand.tagline": "The Actor's Career System",
    "brand.name": "LEO — The Actor's Career System",
    "action.cancel": "Anuluj",
    "action.save": "Zapisz",
    "action.close": "Zamknij",
    "action.change": "Zmień",

    // Splash
    "splash.eyebrow": "LEO — The Actor's Career System",
    "splash.title1": "Leo — Scene",
    "splash.title2": "Ready.",
    "splash.tagline": "You create the art. Leo helps you prepare.",
    "splash.body": "Twój partner w drodze do prawdy aktorskiej. Wgraj scenę, przejdź przez głęboką analizę Celu, Przeszkód i Podtekstów z Kodeksu Potrzeb. Matryca Odzwierciedlenia pomoże Ci szybko połączyć tekst z Twoim wewnętrznym paliwem. Dzięki interaktywnej próbie tekstowej wejdziesz na casting lub plan z pełną sprawczością i gotowością. Leo wspiera Twoje przygotowanie, Ty stwórz sztukę.",
    "splash.enter": "Wejdź do studia",
    "splash.start": "Zacznij pracę",
    "splash.login": "Zaloguj się",
    "splash.pricing": "Zobacz plany",
    "splash.voices": "Głosy z sali prób",

    // Auth
    "auth.entry": "Wejście do studia",
    "auth.login": "Zaloguj się",
    "auth.new": "Nowe konto",
    "auth.private": "Twoja historia scen zapisuje się prywatnie na Twoim koncie.",
    "auth.google": "Zaloguj przez Google",
    "auth.or_email": "LUB E-MAIL",
    "auth.name": "Imię",
    "auth.email": "E-mail",
    "auth.password": "Hasło",
    "auth.password_hint": "min. 6 znaków",
    "auth.enter_btn": "Wejdź",
    "auth.create_btn": "Załóż konto",
    "auth.wait": "Chwila…",
    "auth.forgot_password": "Nie pamiętasz hasła?",
    "auth.forgot_need_email": "Podaj najpierw swój adres email w polu powyżej.",
    "auth.forgot_sent": "Jeśli konto istnieje, wysłaliśmy link do zmiany hasła.",
    "auth.reset_title": "Ustaw nowe hasło",
    "auth.reset_hint": "Wpisz nowe hasło do swojego konta.",
    "auth.new_password": "Nowe hasło",
    "auth.reset_submit": "Zapisz nowe hasło",
    "auth.reset_bad_token": "Link jest nieprawidłowy lub wygasł.",
    "auth.reset_fail": "Nie udało się zmienić hasła. Spróbuj wygenerować nowy link.",
    "auth.reset_done": "Hasło zmienione. Możesz się zalogować.",
    "auth.back_to_login": "← Wróć do logowania",
    "auth.new_here": "Nowy tutaj?",
    "auth.create_link": "Załóż konto",
    "auth.have_account": "Masz już konto?",
    "auth.login_link": "Zaloguj się",
    "auth.back": "← Wróć na scenę główną",

    // Dashboard
    "dash.rehearsal_room": "Sala prób / Self-tape",
    "dash.welcome": "Witaj",
    "dash.subtitle": "Wybierz scenę z Twojego archiwum albo wgraj nową — tekst lub PDF. Leo czeka.",
    "dash.manifesto_headline": "Nie czekaj na casting.\nBuduj swoją karierę.",
    "dash.manifesto_body": "LEO to kompletny system zarządzania karierą aktora. Pomaga Ci planować kolejne kroki, odkrywać nowe możliwości, rozwijać relacje z branżą, śledzić castingi i spotkania oraz przygotowywać się do castingów i ról.",
    "dash.manifesto_imagine": "Wyobraź sobie, gdzie możesz być za rok, jeśli zaczniesz teraz.",
    "dash.manifesto_cta": "Chodźmy po tę wspaniałą przygodę!",
    "dash.manifesto_credits_prefix": "Marcin Zarzeczny",
    "dash.manifesto_credits_films": "(The Agency, Out There, Supernova)",
    "splash.point1_title": "BUDUJ RELACJE",
    "splash.point1_body": "Organizuj kontakty z agentami, reżyserami, reżyserami obsady i innymi osobami z branży. Zapisuj historię kontaktu, notatki i follow-upy.",
    "splash.point2_title": "ZAPLANUJ SWOJĄ KARIERĘ",
    "splash.point2_body": "Wybierz Ścieżkę Kariery lub określ własny cel. Zamień go w konkretne działania i małe kroki, które możesz realizować każdego tygodnia.",
    "splash.point3_title": "PRZYGOTUJ SIĘ DO CASTINGU I ROLI",
    "splash.point3_body": "Analizuj sceny, pracuj nad interpretacją, ucz się tekstu i przygotowuj się do castingu, self-tape’u lub dnia na planie.",
    "splash.tagline_below_points": "Wszystko w jednym miejscu — żeby zamiast czekać na to, co wydarzy się w Twojej karierze, świadomie ją budować.",
    "splash.credibility_line": "Stworzone przez zawodowego aktora grającego w międzynarodowych produkcjach",
    "dash.q_today": "Co dziś zrobisz dla swojej kariery?",
    "dash.body": "Przygotuj scenę, zadbaj o relacje z reżyserami castingu i innymi ludźmi z branży lub zrób kolejny krok w swojej karierze.",
    "dash.q_start": "Od czego zaczynamy?",
    "dash.new_scene": "Nowa scena",
    "dash.tile.upload.title": "Przygotuj scenę / Self-tape",
    "dash.tile.upload.subtitle": "Przeanalizuj scenę albo od razu przejdź do próby / nagrania self-tape'u z AI Readerem.",
    "dash.tile.upload.cta": "Wgraj scenę",
    "dash.tile.upload.my_scenes": "Moje sceny",
    "dash.free_first_title": "Pierwsza scena — darmowa",
    "dash.free_first_body": "Przygotuj pierwszą scenę z Leo. Bezpłatnie.",
    "dash.your_scenes": "Twoje sceny",
    "dash.loading": "wczytuję archiwum…",
    "dash.empty_title": "Kurtyna jeszcze nie poszła w górę.",
    "dash.empty_body": "Wgraj pierwszy tekst, żeby zacząć.",
    "dash.upload_first": "Wgraj pierwszą scenę",
    "dash.scene_analyzed": "Zanalizowane",
    "dash.scene_pending": "Do analizy",
    "dash.confirm_delete": "Usunąć tę scenę bezpowrotnie?",
    "dash.deleted": "Scena usunięta.",
    "dash.delete_failed": "Nie udało się usunąć.",

    // New Scene
    "new.eyebrow": "Etap 1 · Wgraj scenę",
    "new.title": "Nowa scena",
    "new.subtitle": "Wklej tekst lub upuść PDF. Dodaj brief projektu i wskaż postać, którą grasz.",
    "new.scene_title": "Tytuł sceny / projektu",
    "new.scene_title_ph": "np. „Zimowa Wojna” — sc. 14",
    "new.my_character": "Moja postać (kogo gram)",
    "new.my_character_ph": "np. Marta, 34 lata, matka",
    "new.brief": "Brief projektu (reżyser, świat, gatunek)",
    "new.brief_ph": "Reżyser prosi o subtelność. Świat: chłodna zima 1985. Postać ma tajemnicę z dzieciństwa.",
    "new.scene_text_label": "Tekst sceny",
    "new.upload_pdf": "Wgraj plik",
    "new.upload_formats": "PDF, JPG, PNG",
    "new.reading": "Odczytuję…",
    "new.chars": "znaków",
    "new.save_run": "Zapisz i uruchom Leo",
    "new.save_go_rehearsal": "Zapisz i przejdź do Próby / Self-tape",
    "new.scene_language": "Język sceny",
    "new.saving": "Zapisuję…",
    "new.short_text": "Tekst sceny jest za krótki.",
    "new.pdf_ok": "Tekst wyciągnięty z PDF.",
    "new.pdf_fail": "Nie udało się odczytać PDF.",
    "new.saved": "Scena zapisana. Uruchamiam Mózg Leo…",
    "new.paywall_msg": "Wykorzystałeś darmową scenę. Wybierz plan.",
    "new.save_fail": "Nie udało się zapisać sceny.",

    // Scene detail tabs (append after decompression PL)
    "tab.analysis": "Analiza",
    "tab.mirror": "Odzwierciedlenie w Tobie",
    "tab.map": "Mapa emocjonalna",
    "tab.zapalnik": "Zapalnik",
    "tab.eight": "8 pytań",
    "tab.vagus": "Nerw błędny",
    "tab.rehearsal": "Próba / Self-tape",
    "tab.ask": "Zapytaj Leo",
    "tab.notebook": "Notatnik",
    "tab.history": "Historia",
    "tab.decompression": "Uziemienie",

    // Emotional map
    "map.eyebrow": "Odzwierciedlenie · Mapa emocjonalna",
    "map.title": "Mapa emocjonalna. Elementy sceny → Twoja personalizacja.",
    "map.subtitle": "Leo mapuje sceniczne elementy na Twoją personalizację — postać po postaci, symbol po symbolu. Możesz edytować każdą pozycję.",
    "map.generate": "Wygeneruj mapę",
    "map.regenerate": "Wygeneruj od nowa",
    "map.generating": "Leo mapuje…",
    "map.in_scene": "W scenie",
    "map.in_your_life": "W Twojej wyobraźni",
    "map.add_row": "Dodaj pozycję",
    "map.save": "Zapisz mapę",
    "map.saved": "Mapa zapisana.",
    "map.need_mirror": "Najpierw wypełnij Odzwierciedlenie w Tobie.",
    "map.empty": "Naciśnij „Wygeneruj mapę”, żeby Leo zaproponował mapowanie.",

    // Zapalnik
    "zap.eyebrow": "Zapalnik · Tuż przed sceną",
    "zap.title": "Leo rozgrzewa Cię do wejścia w scenę.",
    "zap.subtitle": "Prywatna mowa, osadzona w Twoim Odzwierciedleniu i Celu. Nie do publikacji — dla Ciebie.",
    "zap.generate": "Wygeneruj Zapalnik",
    "zap.regenerate": "Wygeneruj od nowa",
    "zap.generating": "Leo pisze zapalnik…",
    "zap.empty": "Naciśnij „Wygeneruj Zapalnik”, żeby Leo napisał Ci prywatne wprowadzenie tuż przed sceną.",
    "zap.saved": "Zapalnik zapisany.",
    "zap.need_map": "Najpierw wygeneruj Mapę emocjonalną — Leo będzie miał z czego czerpać.",

    // 8 questions
    "eight.eyebrow": "Craft & Truth · 8 pytań",
    "eight.title": "Osadź się w scenie zanim wejdziesz w próbę.",
    "eight.subtitle": "Osiem pytań, którymi wchodzi w Ciebie postać. Leo wypełnia — Ty edytujesz, dopóki nie stanie się prawdą.",
    "eight.generate": "Wygeneruj odpowiedzi",
    "eight.regenerate": "Wygeneruj od nowa",
    "eight.generating": "Leo wypełnia…",
    "eight.save": "Zapisz pytania",
    "eight.saved": "Zapisane.",
    "eight.answer_ph": "— odpowiedź w pierwszej osobie…",
    "eight.empty": "Naciśnij „Wygeneruj odpowiedzi”, żeby Leo wypełnił 8 pytań na start.",

    // Vagus nerve
    "vag.eyebrow": "Nerw błędny · Przed próbą",
    "vag.title": "Wycisz się przed wejściem w Craft & Truth.",
    "vag.subtitle": "Krótkie ćwiczenia oddechowe i cielesne — 3-6 minut. Bez oceniania, bez pośpiechu. Nie zastępują opieki medycznej.",
    "vag.start": "Start",
    "vag.next": "Dalej",
    "vag.done": "Gotowe",
    "vag.step": "Ćwiczenie",

    // Ask Leo
    "ask.eyebrow": "Chat · Prywatnie z Leo",
    "ask.title": "Zapytaj Leo o cokolwiek w tej scenie.",
    "ask.subtitle": "Nie prowadzi próby. Jest coachem. Odpowiada bez oceniania — daje opcje, nie werdykty.",
    "ask.input_ph": "np. „Boję się, że będę za bardzo agresywna. Jak to rozegrać?”",
    "ask.reset": "Reset",
    "ask.confirm_reset": "Skasować całą rozmowę z Leo?",
    "ask.empty": "Napisz pierwsze pytanie do Leo — o postać, o kwestię, o wybór, o wątpliwość.",
    "ask.leo": "Leo",
    "ask.you": "Ty",
    "scene.back": "Powrót",
    "scene.eyebrow": "Scena · Studio pracy",
    "scene.your_character": "Twoja postać",
    "scene.export_pdf": "Eksportuj PDF",

    // Analysis
    "an.wait_title": "Mózg Leo czeka na start.",
    "an.wait_body": "Analiza wskaże Cel z Kodeksu Potrzeb, Przeszkody i Zadania Aktorskie.",
    "an.run": "Uruchom analizę",
    "an.thinking": "Leo myśli…",
    "an.rerun": "Uruchom analizę jeszcze raz",
    "an.rerunning": "Analizuję…",
    "an.goal": "Cel postaci · Kodeks Potrzeb",
    "an.addressee": "Adresat",
    "an.obstacles": "Przeszkody",
    "an.tasks": "Zadania aktorskie",
    "an.leo_note": "Notatka Leo",
    "an.task": "ZADANIE",
    "an.change_goal": "Zmień Cel w scenie",
    "an.list_needs": "Lista potrzeb",
    "an.manually_set": "cel ustawiony ręcznie",
    "an.done": "Mózg Leo zakończył analizę.",
    "an.fail": "Analiza nieudana.",
    "an.relacja": "Relacja",
    "an.rel_source": "Źródło Celu — z Relacji",
    "an.rel_needs": "Potrzeby partnera (ludzki poziom)",
    "an.rel_fears": "Czego partner się boi",
    "an.rel_dynamic": "Relacja",
    "an.subtext": "Podtekst",
    "an.subtext_intro": "Momenty, w których słowa mogą ukrywać prawdziwą potrzebę.",
    "an.subtext_surface": "Powierzchnia",
    "an.subtext_real": "Prawdziwa potrzeba",
    "an.missing_extras": "Ta analiza jest ze starszej wersji — uruchom analizę jeszcze raz, żeby zobaczyć Relację i Podtekst.",

    // Change goal / Needs list dialog
    "goal.dialog_title": "Zmień Cel w scenie",
    "goal.dialog_desc": "Wybierz nową Potrzebę z Twardego Kodeksu lub wpisz WŁASNY Cel. Leo napisze analizę od nowa pod wybrany Cel.",
    "goal.search_ph": "Szukaj po polsku lub angielsku…",
    "goal.confirm": "Zapisz nowy Cel",
    "goal.saved": "Nowy Cel zapisany.",
    "goal.regenerating": "Leo przepisuje analizę…",
    "goal.fail": "Nie udało się zmienić Celu.",
    "goal.selected": "Wybrano",
    "goal.custom_toggle": "Wpisz własny Cel",
    "goal.leo_toggle": "Zaproponuj Cel z Leo",
    "goal.leo_intro": "Leo zaproponuje Cel wynikający z tej sceny — możesz go zaakceptować, edytować, poprosić o inny albo odrzucić i wpisać własny.",
    "goal.leo_thinking": "Leo myśli o scenie…",
    "goal.leo_ask": "Zaproponuj Cel z Leo",
    "goal.leo_again": "Zaproponuj inny",
    "goal.leo_accept": "Użyj tego Celu",
    "goal.leo_reject": "Odrzuć i wpisz własny",
    "goal.leo_fail": "Leo nie mógł teraz zaproponować Celu.",
    "goal.leo_reason": "Dlaczego ten Cel:",
    "goal.custom_ph": "np. „Chcę cię obudzić z twojego kłamstwa”",
    "goal.custom_hint": "Własny Cel może wyjść poza Kodeks. Leo Cię nie oceni — przepisze przeszkody i zadania pod ten Cel.",
    "goal.save_to_library": "Zapisz ten cel w mojej bibliotece",
    "goal.save_to_library_hint": "Pojawi się w Twoich celach przy każdej scenie.",
    "needs.your_library": "Moja biblioteka celów",
    "needs.your_library_empty": "Twoje własne cele pojawią się tutaj po pierwszym zapisaniu.",
    "needs.delete_own": "Usuń z biblioteki",
    "needs.dialog_title": "Twardy Kodeks Potrzeb",
    "needs.dialog_desc": "Pełna lista potrzeb, spośród których Leo wybiera Cel postaci. Możesz przeszukiwać po polsku lub angielsku.",
    "needs.copy": "Skopiuj listę",
    "needs.copied": "Skopiowano do schowka",

    // Mirroring
    "mir.privacy_title": "Twoje zapisy są tutaj bezpieczne",
    "mir.privacy_body": "Wszystkie zapisy są szyfrowane. Leo pracuje wyłącznie na wyobraźni, archetypach i świecie sceny — nigdy nie prosi o prawdziwe osoby ani prywatne wspomnienia. Wpisuj tylko wyobrażonych partnerów, fikcyjne postaci albo etykiety (np. Szef, Rywal, Mentor).",
    "mir.craft_care_title": "Craft & Care — Jak zbudować intencję?",
    "mir.craft_care_body": "Aktorstwo to sztuka wyobraźni. Wykorzystaj swoją kreatywność do stworzenia warunków, które najlepiej napędzą cel Twojego bohatera i wyzwolą w Tobie autentyczną determinację do działania. Zamknij oczy. Pomyśl o tym, do czego Twoja postać dąży w tej scenie. Wyobraź sobie idealne okoliczności i stwórz w głowie obraz postaci, wobec której ta walka ma dla Ciebie największy sens. Skup się na energii w ciele – na chęci działania, ruchu i wewnętrznej sile. Daj się poprowadzić tej determinacji. Kiedy poczujesz ten impuls, nadaj swojej wizji konkretny kształt, aby Leo mógł stać się Twoim idealnym partnerem w tej próbie.",
    "mir.eyebrow": "Wywiad · Twój partner",
    "mir.q1_title": "Etykieta lub Imię",
    "mir.q1_body": "Nazwij postać, którą masz przed oczami. Może to być imię bohatera ze scenariusza, archetyp, postać fikcyjna lub po prostu etykieta, która w Twojej wyobraźni reprezentuje tę energię (np. Szef, Rywal, Mentor, Aleks, Postać X):",
    "mir.q1_ph": "np. Szef, Rywal, Mentor, Aleks, Postać X",
    "mir.q2_label": "Miejsce rozmowy",
    "mir.q2_title": "Gdzie fizycznie rozgrywa się ta scena według scenariusza?",
    "mir.q2_body": "Wyobraź sobie to konkretne miejsce (np. biuro, kawiarnia, samochód). Aby Twoje ciało uwierzyło w tę sytuację, nadaj tej przestrzeni realne, fizyczne właściwości:\n\n• Jaka temperatura panuje w tym miejscu? (np. lodowaty powiew klimatyzacji, duszne i gęste powietrze)\n• Jaki zapach unosi się w powietrzu? (np. zapach parzonej kawy, skórzane fotele, zapach deszczu)\n• Jaki dźwięk słyszysz w tle? (np. szum ulicy, tykanie zegara, cisza)",
    "mir.q2_ph": "np. biuro reżysera. Chłodna klimatyzacja, zapach kawy, w tle tykanie zegara.",
    "mir.notes": "Notatki dodatkowe",
    "mir.notes_ph": "(opcjonalnie) — co jeszcze chcesz zabrać ze sobą?",
    "mir.save": "Zapisz Odzwierciedlenie",
    "mir.saving": "Zapisuję…",
    "mir.saved": "Odzwierciedlenie zapisane. Leo będzie tego partnera grał.",
    "mir.fail": "Nie udało się zapisać.",
    "osadz.eyebrow": "Osadzenie w ciele i miejscu",
    "osadz.title": "Leo prowadzi Cię do potrzeby, zanim wejdziesz w scenę.",
    "osadz.generate": "Wygeneruj Osadzenie",
    "osadz.regenerate": "Wygeneruj od nowa",
    "osadz.generating": "Leo prowadzi…",
    "osadz.empty": "Zapisz Odzwierciedlenie i naciśnij „Wygeneruj Osadzenie”.",
    "takt.eyebrow": "Taktyka aktorska — Sprawczość",
    "takt.title": "Nie graj ofiary. Wywalcz swój cel sercem.",
    "takt.generate": "Wygeneruj Taktykę",
    "takt.regenerate": "Wygeneruj od nowa",
    "takt.generating": "Leo pisze…",
    "takt.empty": "Zapisz Odzwierciedlenie i naciśnij „Wygeneruj Taktykę”.",

    // Rehearsal
    "reh.need_mirror_title": "Najpierw Odzwierciedlenie w Tobie.",
    "reh.need_mirror_body": "Wypełnij Wywiad partnera, żeby Leo miał kogo dla Ciebie zagrać.",
    "reh.script": "Tekst sceny",
    "reh.readonly": "tylko do wglądu",
    "reh.title": "Próba / Self-tape z Leo",
    "reh.subtitle": "Bez oceniania. Tylko prawda.",
    "reh.reset": "Reset",
    "reh.confirm_reset": "Zaczynamy próbę od początku?",
    "reh.reset_fail": "Błąd resetu.",
    "reh.you": "Ty",
    "reh.leo": "Partner",
    "reh.my_line": "Moja kwestia",
    "reh.send_fail": "Nie udało się kontynuować próby.",
    "reh.parse_cta": "Rozpocznij próbę",
    "reh.parse_hint": "Leo najpierw sparsuje scenę: rozpozna postacie, dialog i ustali, kto zaczyna. Potem prowadzi próbę automatycznie — Twoim jedynym zadaniem jest wypowiedzieć swoją kwestię i nacisnąć \"Moja kwestia\".",
    "reh.parsing": "Parsuję scenę…",
    "reh.parse_fail": "Nie udało się sparsować sceny.",
    "reh.your_turn": "Twoja kolej — powiedz swoją kwestię, a potem naciśnij:",
    "reh.your_turn_first": "Zaczynasz Ty. Powiedz swoją kwestię i naciśnij:",
    "reh.you_speaking": "Ty (Twoja postać)",
    "reh.done_title": "Koniec sceny.",
    "reh.done_body": "Możesz przejść do Uziemienia albo zresetować i zagrać jeszcze raz.",
    "reh.reparse": "Przeanalizuj scenę ponownie",
    "reh.starts_actor": "Twoja postać zaczyna scenę.",
    "reh.starts_other": "Partner zaczyna scenę.",
    "reh.progress": "Kwestia",
    "reh.waiting": "Partner mówi…",
    "reh.full_scene": "Pełna scena",
    "reh.full_scene_hint": "Cały skrypt. Twoje aktualne miejsce w scenie jest podświetlone.",
    "reh.close": "Zamknij",
    "reh.current_marker": "Tu jesteś",
    "reh.no_script_yet": "Sparsuj scenę, aby zobaczyć podświetlone kwestie. Poniżej surowy tekst.",
    "reh.ai_reader_title": "AI Reader (hands-free)",
    "reh.ai_reader_hint": "LEO odpowiada, gdy rozpozna końcówkę Twojej kwestii. Nie zmieniaj ostatnich słów tekstu — możesz grać po swojemu, ale końcówkę wypowiedz zgodnie ze sceną.",
    "reh.ai_reader_prepping": "Przygotowuję głosy…",
    "reh.ai_reader_ready": "Audio Ready ✓",
    "reh.ai_reader_scene_done": "Scena zakończona",
    "reh.ai_reader_reconnecting": "Łączenie ponownie…",
    "reh.ai_reader_limit_reached": "Wykorzystałeś limit czasu AI Readera w swoim planie.",
    "reh.ai_reader_voice": "Głos",

    // Section navigation (bottom-of-section CTAs)
    "nav.to_mirror": "Idź do Odzwierciedlenia w Tobie",
    "nav.to_map": "Idź do Mapy emocjonalnej",
    "nav.to_zapalnik": "Idź do zapalnika",
    "nav.to_eight": "Idź do 8 pytań",
    "nav.to_vagus": "Idź do Nerwu błędnego",
    "nav.to_rehearsal": "Rozpocznij próbę / self-tape",
    "nav.to_reflection": "Idź do Refleksji Leo",
    "nav.save_notes": "Zapisz notatki",

    // Reflection (post-rehearsal)
    "reflect.tab": "Refleksje Leo",
    "reflect.title": "Refleksje Leo po próbie",
    "reflect.subtitle": "Krótkie zejście z roli. Odpowiedz na pytania Leo, a potem zobacz 3 warianty tej samej sceny.",
    "reflect.q1": "Jak Ci było w tej próbie?",
    "reflect.q2": "Co czułeś podczas grania?",
    "reflect.q3": "Czy czułeś motywację postaci?",
    "reflect.q4": "Co Cię zaskoczyło?",
    "reflect.answer_ph": "Napisz swobodnie…",
    "reflect.gen": "Wygeneruj 3 warianty od Leo",
    "reflect.regen": "Wygeneruj ponownie",
    "reflect.generating": "Leo szuka wariantów…",
    "reflect.variants_title": "3 warianty tej samej sceny",
    "reflect.variants_hint": "Warianty zmieniają WEWNĘTRZNE wybory (energia, intencja, relacja, tempo, sposób działania). Historia sceny się nie zmienia.",
    "reflect.saved_to_notes": "Zapisano refleksję w Notatniku.",
    "reflect.no_variants_yet": "Kliknij powyżej, aby Leo zaproponował trzy warianty aktorskie.",
    "reflect.focus.energy": "energia",
    "reflect.focus.intention": "intencja",
    "reflect.focus.relationship": "relacja",
    "reflect.focus.tempo": "tempo",
    "reflect.focus.mode": "sposób działania",
    "reflect.rehearse_again": "Powtórz próbę",
    "reflect.go_grounding": "Idź do uziemienia",

    // Notebook
    "note.title": "Notatnik aktorski",
    "note.subtitle": "Odkrycia, próby interpretacji, pytania dla reżysera. Prywatne, tylko Twoje.",
    "note.ph": "— dziś zauważyłam, że postać się nie broni…",
    "note.save": "Zapisz notatnik",
    "note.saved": "Notatnik zapisany.",
    "note.fail": "Nie udało się zapisać.",

    // Decompression
    "dec.eyebrow": "Uziemienie · Po próbie",
    "dec.title": "Zejdź z roli. Wróć do siebie.",
    "dec.body": "Praca aktorska zostawia ślad w ciele. Zrób te cztery kroki spokojnie, bez pośpiechu.",
    "dec.step": "Krok",

    // Pricing
    "pr.eyebrow": "CENNIK",
    "pr.title": "PAMIĘTASZ TEN MOMENT?",
    "pr.subtitle": "Kiedy pierwszy raz pomyślałeś: „Chcę być aktorem.” To Twoja Iskra. Nie zgub jej.",
    "pr.expand_details": "Rozwiń szczegóły",
    "pr.collapse_details": "Zwiń szczegóły",
    "pr.recommended": "Polecane",
    "pr.launch_badge": "Cena premierowa",
    "pr.best_value": "Najlepsza wartość",
    "pr.includes": "W planie:",
    "pr.does_not_include": "Nie odblokowuje:",
    "pr.current_section_title": "TWOJA OBECNA SUBSKRYPCJA",
    "pr.current_plan_label": "Twój obecny plan",
    "pr.current_expires": "Wygasa",
    "pr.current_next_renewal": "Następne odnowienie",
    "pr.current_valid_until": "Ważny do",
    "pr.current_days_left": "Pozostało",
    "pr.current_days_word": "dni",
    "pr.current_active": "Aktywny",
    "pr.select": "Wybierz",
    "pr.opening": "Otwieram Stripe…",
    "pr.card_hint": "Bezpieczna płatność przez Stripe. Twoje dane karty nie są przechowywane w aplikacji. Ceny zawierają VAT.",
    "pr.fail": "Nie udało się utworzyć płatności.",

    // Payment
    "pay.confirming": "Potwierdzam płatność u Stripe…",
    "pay.wait": "MOMENT",
    "pay.done": "Zapłacone. Kurtyna w górę.",
    "pay.done_body": "Twój plan jest już aktywny.",
    "pay.to_dash": "Zaczynamy!",
    "pay.new_scene": "Nowa scena",
    "pay.fail": "Coś poszło nie tak.",
    "pay.retry": "Spróbuj ponownie za chwilę.",
    "pay.choose": "Wybierz plan",

    // Profile
    "prof.title": "Profil",
    "prof.email": "E-mail",
    "prof.created": "Konto założone",
    "prof.provider": "Sposób logowania",
    "prof.plan_limits": "Plan i limity",
    "prof.change_plan": "Zmień plan",
    "prof.manage_sub": "Zarządzaj subskrypcją",
    "prof.manage_sub_hint": "Faktury, metoda płatności, anulowanie",
    "prof.manage_sub_fail": "Nie udało się otworzyć panelu Stripe.",
    "prof.manage_sub_opening": "Otwieram panel Stripe…",
    "prof.used": "Darmowe sceny wykorzystane",
    "prof.credits": "Kredyty",
    "prof.expires": "Ważny do",
    "prof.language": "Język aplikacji i Leo",
    "prof.reminders_title": "Przypomnienia e-mail",
    "prof.reminders_hint": "Otrzymuj krótki e-mail, gdy pojawi się rzeczywisty powód: follow-up z CRM, termin Kroku lub Zadania. Maksymalnie jeden e-mail dziennie. W każdej chwili możesz wyłączyć.",
    "prof.reminders_on": "Włączone",
    "prof.reminders_off": "Wyłączone",
    "prof.reminders_saved": "Zapisano",
    "prof.reminders_fail": "Nie udało się zapisać.",

    // Header status
    "hdr.plan": "Plan",
    "hdr.free_scenes": "Darmowe sceny",
    "hdr.credits": "Kredyty",
    "hdr.expires": "Ważny do",

    // Common
    "toast.welcome": "Dobrze cię widzieć.",
    "toast.login_fail": "Nie udało się zalogować.",
    "toast.google_fail": "Logowanie Google nie powiodło się.",
    "loading.stage": "ZASŁONA W GÓRĘ…",
    "loading.scene": "wczytuję scenę…",
    "loading.callback": "USTAWIAM ŚWIATŁO…",
    "quote.list": "GŁOSY Z SALI PRÓB",

    // CRM — Career Path
    "crm.dash_tile_eyebrow": "Workflow & CRM",
    "crm.dash_tile_title": "Workflow & CRM · Twoje kontakty zawodowe i castingi",
    "crm.dash_tile_body": "Buduj i rozwijaj relacje z reżyserami castingu, reżyserami i producentami. Zapisuj castingi i feedbacki, a Leo pomoże Ci wykorzystać je przy kolejnych okazjach.",
    "crm.open": "Otwórz Workflow & CRM",
    "crm.page_title": "Workflow & CRM",
    "crm.page_subtitle": "Twoje kontakty zawodowe i castingi.",
    "crm.page_tagline": "Buduj i rozwijaj relacje z reżyserami castingu, reżyserami i producentami. Zapisuj castingi i feedbacki, a Leo pomoże Ci wykorzystać je przy kolejnych okazjach.",
    "crm.section.contacts": "Kontakty",
    "crm.section.auditions": "Castingi",
    "crm.tab.all": "Ogólne",
    "crm.tab.casting_director": "Reżyserzy castingu",
    "crm.tab.director": "Reżyserzy",
    "crm.tab.producer": "Producenci",
    "crm.tab.casting_assistant": "Asystenci castingu",
    "crm.tab.screenwriter": "Scenarzyści",
    "crm.tab.agent": "Agenci",
    "crm.tab.agent_uk": "Agenci UK",
    "crm.tab.other": "Inni",
    "crm.type.casting_director": "Reżyser castingu",
    "crm.type.director": "Reżyser",
    "crm.type.producer": "Producent",
    "crm.type.casting_assistant": "Asystent castingu",
    "crm.type.screenwriter": "Scenarzysta",
    "crm.type.agent": "Agent",
    "crm.type.agent_uk": "Agent UK",
    "crm.type.other": "Inny",
    "crm.dash.today": "Do kontaktu dzisiaj / Zaległe",
    "crm.dash.upcoming": "Nadchodzące (7 dni)",
    "crm.dash.later": "Później",
    "crm.dash.empty": "Brak kontaktów w tej sekcji.",
    "crm.col.person": "Osoba",
    "crm.col.type": "Typ",
    "crm.col.project": "Projekt / kontekst",
    "crm.col.email_phone": "Email / Telefon",
    "crm.col.last": "Ostatni kontakt",
    "crm.col.followup": "Follow-up",
    "crm.col.countdown": "Odliczanie",
    "crm.col.status": "Status",
    "crm.col.action": "Akcja",
    "crm.action.confirm": "Potwierdź kontakt",
    "crm.action.new": "Nowy kontakt",
    "crm.action.edit": "Edytuj",
    "crm.action.delete": "Usuń",
    "crm.action.back": "Wróć do CRM",
    "crm.status.today": "Dzisiaj / Zaległy",
    "crm.status.soon": "Zbliża się",
    "crm.status.active": "Aktywny",
    "crm.countdown.days_left": "za {n} dni",
    "crm.countdown.today": "dzisiaj",
    "crm.countdown.overdue": "{n} dni po",
    "crm.no_contacts": "Brak kontaktów. Dodaj pierwszą osobę, aby zacząć budować swoją sieć.",
    "crm.confirm.delete": "Usunąć ten kontakt bezpowrotnie?",
    "crm.deleted": "Kontakt usunięty.",
    "crm.delete_fail": "Nie udało się usunąć.",

    // CRM — Form
    "crm.form.title_new": "Nowy kontakt",
    "crm.form.title_edit": "Edytuj kontakt",
    "crm.form.first_name": "Imię",
    "crm.form.last_name": "Nazwisko",
    "crm.form.type": "Typ kontaktu",
    "crm.form.company": "Firma / agencja",
    "crm.form.email": "Email",
    "crm.form.phone": "Telefon",
    "crm.form.project": "Projekt / kontekst",
    "crm.form.project_ph": "np. „Zimowa Wojna” — casting główny",
    "crm.form.notes": "Notatki / Feedback",
    "crm.form.notes_ph": "Krótka charakterystyka, o czym rozmawialiście, na co zwrócić uwagę…",
    "crm.form.last_contact": "Data ostatniego kontaktu",
    "crm.form.followup_period": "Okres follow-up",
    "crm.form.days30": "30 dni",
    "crm.form.days60": "60 dni",
    "crm.form.days90": "90 dni (domyślnie)",
    "crm.form.days120": "120 dni",
    "crm.form.days180": "180 dni",
    "crm.form.custom_date": "Własna data",
    "crm.form.save": "Zapisz kontakt",
    "crm.form.saving": "Zapisuję…",
    "crm.form.saved": "Kontakt zapisany.",
    "crm.form.fail": "Nie udało się zapisać kontaktu.",
    "crm.form.required": "Imię i typ kontaktu są wymagane.",

    // CRM — Confirm modal
    "crm.confirm.title": "Potwierdź kontakt",
    "crm.confirm.subtitle": "Wybierz rodzaj interakcji. Dopiero po potwierdzeniu system zapisze dzisiejszą datę i wyliczy nowy termin follow-upu.",
    "crm.confirm.kind.email": "Email",
    "crm.confirm.kind.phone": "Telefon",
    "crm.confirm.kind.message": "Wiadomość",
    "crm.confirm.kind.meeting": "Spotkanie",
    "crm.confirm.kind.casting": "Casting",
    "crm.confirm.kind.materials": "Materiały",
    "crm.confirm.note": "Notatka do interakcji (opcjonalnie)",
    "crm.confirm.note_ph": "Krótko: o czym była rozmowa / jaki był efekt.",
    "crm.confirm.new_followup": "Następny follow-up za",
    "crm.confirm.yes": "Tak, potwierdzam",
    "crm.confirm.ok": "Kontakt potwierdzony. Licznik zresetowany.",
    "crm.confirm.fail": "Nie udało się potwierdzić kontaktu.",

    // CRM — Profile
    "crm.profile.overview": "Dane kontaktu",
    "crm.profile.history": "Historia potwierdzonych kontaktów",
    "crm.profile.no_history": "Brak potwierdzonych kontaktów. Kliknij „Potwierdź kontakt”, aby dodać pierwszą interakcję.",
    "crm.profile.created": "Dodany",
    "crm.profile.auditions": "Historia castingów",
    "crm.profile.no_auditions": "Brak castingów powiązanych z tą osobą.",

    // Auditions
    "aud.list_title": "Castingi",
    "aud.new": "Nowy casting",
    "aud.empty": "Brak castingów. Dodaj pierwszy, aby rozpocząć.",
    "aud.col.project": "Projekt",
    "aud.col.role": "Rola",
    "aud.col.type": "Rodzaj",
    "aud.col.cd": "Reżyser castingu",
    "aud.col.next_date": "Najbliższy termin",
    "aud.col.status": "Status",
    "aud.no_next_date": "—",
    "aud.form.title_new": "Nowy casting",
    "aud.form.title_edit": "Edytuj casting",
    "aud.form.project": "Nazwa projektu *",
    "aud.form.role": "Rola",
    "aud.form.production_type": "Typ produkcji",
    "aud.form.production_ph": "np. film fabularny, serial, reklama, teatr",
    "aud.form.cd": "Reżyser castingu *",
    "aud.form.cd_choose": "Wybierz z kontaktów…",
    "aud.form.cd_hint": "Casting musi być powiązany z istniejącym kontaktem typu Reżyser castingu.",
    "aud.form.cd_none": "Nie masz jeszcze reżyserów castingu w kontaktach.",
    "aud.form.cd_add": "Dodaj kontakt",
    "aud.form.source": "Źródło castingu",
    "aud.form.source_ph": "np. Casting.pl, agent, bezpośrednie zaproszenie",
    "aud.form.audition_type": "Rodzaj castingu",
    "aud.form.status": "Status",
    "aud.form.notes": "Notatki",
    "aud.form.notes_ph": "Kontekst, oczekiwania reżysera, ton…",
    "aud.form.feedback": "Feedback",
    "aud.form.feedback_ph": "Informacje zwrotne z castingu.",
    "aud.form.save": "Zapisz casting",
    "aud.form.saved": "Casting zapisany.",
    "aud.form.fail": "Nie udało się zapisać.",
    "aud.form.required": "Projekt i reżyser castingu są wymagane.",
    "aud.form.no_cd_msg": "Aby dodać casting, najpierw dodaj przynajmniej jednego reżysera castingu w zakładce Kontakty.",

    "aud.type.in_person": "In person",
    "aud.type.self_tape": "Self-tape",
    "aud.type.online_live": "Online / Live",
    "aud.type.callback_in_person": "Callback — In person",
    "aud.type.callback_online": "Callback — Online",
    "aud.type.chemistry_read": "Chemistry Read",
    "aud.type.screen_test": "Screen Test",
    "aud.type.final_audition": "Final Audition",
    "aud.type.other": "Inny",

    "aud.status.new": "Nowy",
    "aud.status.in_preparation": "W przygotowaniu",
    "aud.status.sent": "Wysłany",
    "aud.status.callback": "Callback",
    "aud.status.booked": "Zabukowany",
    "aud.status.not_booked": "Nie zabukowany",

    // Stages
    "stage.title": "Etapy castingu",
    "stage.subtitle": "Casting może mieć wiele etapów. „Najbliższy termin” w tabeli głównej pobierany jest z tej listy.",
    "stage.add": "Dodaj etap",
    "stage.edit": "Edytuj etap",
    "stage.empty": "Brak etapów. Dodaj pierwszy, aby zapisać termin.",
    "stage.kind": "Rodzaj etapu",
    "stage.date": "Data i godzina",
    "stage.deadline": "Deadline przesłania",
    "stage.place": "Miejsce",
    "stage.address": "Adres",
    "stage.studio": "Studio / sala",
    "stage.link": "Link",
    "stage.platform": "Platforma",
    "stage.instructions": "Instrukcje",
    "stage.notes": "Notatki – Feedback",
    "stage.status": "Status etapu",
    "stage.saved": "Etap zapisany.",
    "stage.save_fail": "Nie udało się zapisać etapu.",
    "stage.confirm_delete": "Usunąć ten etap?",
    "stage.deleted": "Etap usunięty.",

    // Scenes (audition)
    "asc.title": "Sceny do przygotowania",
    "asc.add": "Dodaj kolejną scenę",
    "asc.add_first": "Dodaj pierwszą scenę",
    "asc.empty": "Nie dodano jeszcze żadnych scen do tego castingu.",
    "asc.name": "Nazwa sceny",
    "asc.description": "Opis sceny",
    "asc.description_ph": "Kontekst, kim jest postać, o co chodzi w scenie…",
    "asc.text": "Tekst sceny",
    "asc.text_ph": "Wklej dialog / opis sceny. Zostanie automatycznie przekazany do Leo.",
    "asc.file": "Plik sceny (PDF)",
    "asc.file_uploaded": "Plik załadowany:",
    "asc.status": "Status sceny",
    "asc.status.to_prepare": "Do przygotowania",
    "asc.status.in_progress": "W trakcie",
    "asc.status.ready": "Gotowa",
    "asc.saved": "Scena zapisana.",
    "asc.save_fail": "Nie udało się zapisać sceny.",
    "asc.confirm_delete": "Usunąć tę scenę?",
    "asc.deleted": "Scena usunięta.",
    "asc.work_with_leo": "🤖 Idź do pracy nad sceną z Leo",
    "asc.open_leo_scene": "Otwórz w Leo",
    "asc.leo_linked": "Powiązano z Leo",

    // Activity
    "act.title": "Historia aktywności",
    "act.empty": "Brak zapisanej aktywności.",
    "act.kind.created": "Casting utworzony",
    "act.kind.status_changed": "Zmiana statusu",
    "act.kind.stage_added": "Dodano etap",
    "act.kind.scene_added": "Dodano scenę",
    "act.kind.scene_status": "Status sceny",
    "act.kind.feedback_added": "Dodano feedback",
    "act.kind.leo_started": "Praca z Leo rozpoczęta",

    // Briefing
    "brief.title": "Casting zapisany! 🎬",
    "brief.subtitle": "Zanim zaczniesz, zobacz, co warto pamiętać o tym reżyserze castingu:",
    "brief.prev": "Twoje poprzednie podejścia u: {name}",
    "brief.first": "To Twój pierwszy zarejestrowany casting z {name}. Czysta karta. Leo pomoże Ci przygotować scenę i podejść do niej świadomie.",
    "brief.cta_leo": "🤖 Idź do Leo AI — Przygotuj scenę",
    "brief.cta_back": "Wróć do castingów",
    "brief.no_scenes": "Dodaj przynajmniej jedną scenę, aby przejść z nią do Leo.",

    // Follow-up reminder
    "fu.reminder": "Czas na follow-up z {name}.",

    // Detail page
    "aud.back": "Wróć do castingów",
    "aud.next_date_label": "Najbliższy termin",
    "aud.next_date_none": "brak zaplanowanych terminów",
    "aud.confirm_delete": "Usunąć ten casting bezpowrotnie?",
    "aud.deleted": "Casting usunięty.",
    "aud.delete_fail": "Nie udało się usunąć.",

    "aud.section.before": "PRZED CASTINGIEM",
    "aud.section.after": "PO CASTINGU",
    "aud.pre.save": "Zapisz przygotowanie",
    "aud.pre.q1": "Czy czuję, że pasuję do tej roli? Dlaczego?",
    "aud.pre.q2": "Jakie mam przeczucie co do wyniku tego castingu?",
    "aud.pre.q3": "Co jest moim wyzwaniem na ten casting?",
    "aud.pre.q4": "Co chcę trenować na tym castingu?",
    "aud.pre.q5": "Przez co chcę przejść / z czym chcę się zmierzyć na tym castingu?",
    "aud.mm.start": "Rozpocznij MASTERMIND",
    "aud.mm.view": "Zobacz pełny MASTERMIND",
    "aud.mm.edit": "Edytuj MASTERMIND",

    "mm.title": "MASTERMIND: CASTING WYGRANY / NIEWYGRANY?",
    "mm.subtitle": "Przeżyj to jak zawodowiec",
    "mm.description": "Casting wygrany czy niewygrany — oba są częścią Twojej drogi.\nBądź zawodowcem. Wróć do tego momentu, zobacz, co naprawdę wydarzyło się podczas castingu, doceń to, co zrobiłeś dobrze, i zauważ to, co chcesz zrobić inaczej.\nWyciągnij lekcje, rozpoznaj swoje wzorce zachowania, nazwij swoje wyzwania i zdecyduj, co chcesz trenować na kolejnym castingu.\nNie oceniaj swojej pracy wyłącznie po wyniku.",

    "mm.select.title": "Wybierz casting, do którego chcesz wrócić",
    "mm.select.add_new": "+ Dodaj nowy casting",

    "mm.step1.title": "Zatrzymaj się",
    "mm.step1.body": "Nie analizuj jeszcze wyniku. Najpierw wróć do tego, co wydarzyło się z Tobą podczas castingu.",
    "mm.step1.question": "Co teraz czujesz, kiedy myślisz o tym castingu?",

    "mm.step2.title": "Wróć do sali albo do self-tape'u",
    "mm.step2.body": "Usiądź wygodnie. Jeśli chcesz, zamknij oczy.\nDaj sobie chwilę i wróć w wyobraźni do sali castingowej albo do momentu nagrywania self-tape'u.\nNie próbuj teraz ustalić, dlaczego dostałeś albo nie dostałeś roli.\nPo prostu zobacz siebie w tamtym momencie.\nCo działo się w Twoim ciele?\nCo czułeś?\nO czym myślałeś?\nGdzie była Twoja uwaga?\nWyobraź sobie, że możesz stanąć obok tamtego siebie.\nNie musisz niczego poprawiać.\nNie musisz niczego sobie udowadniać.\nMożesz położyć sobie dłoń na ramieniu, objąć siebie albo po prostu przez chwilę przy sobie zostać.\nSpójrz na siebie bez oceniania.",
    "mm.step2.question": "Co zauważyłeś?",

    "mm.step3.title": "Obejrzyj self-tape, jeśli go masz",
    "mm.step3.body": "Jeśli masz nagranie, obejrzyj je jeszcze raz — jak zawodnik oglądający zapis meczu.\nNie po to, żeby się krytykować.\nPo to, żeby zebrać informacje.\nNajpierw obejrzyj całość bez zatrzymywania i bez robienia notatek.\nPotem obejrzyj jeszcze raz i przyjrzyj się swojej pracy.",
    "mm.step3.q1": "Jak pamiętałem / czułem ten casting?",
    "mm.step3.q2": "Co widzę teraz na nagraniu?",
    "mm.step3.q3": "Co mnie zaskoczyło?",
    "mm.step3.skip": "Pomiń — nie mam nagrania",

    "mm.step4.title": "Co zrobiłem dobrze?",
    "mm.step4.support": "Wskaż przynajmniej dwie konkretne rzeczy, które chcesz zachować.",

    "mm.step5.title": "Co chcę zrobić inaczej?",
    "mm.step5.question": "Co nie zadziałało tak, jak chciałeś? Co następnym razem chcesz zrobić inaczej?",

    "mm.step6.title": "Czego nauczył mnie ten casting?",
    "mm.step6.support": "Nie musisz na siłę znajdować lekcji. Czasami uczciwy wniosek brzmi:\n„Byłem przygotowany. Zrobiłem pracę, którą chciałem zrobić. Nie dostałem roli. Nie mam tutaj niczego do naprawienia.”",

    "mm.step7.title": "Wzorzec zachowania",
    "mm.step7.explanation": "Wzorzec zachowania to sposób reagowania, który może powtarzać się u Ciebie w podobnych sytuacjach lub pod presją.\nJedna sytuacja nie musi jeszcze oznaczać wzorca.",
    "mm.step7.example1": "„Kiedy bardzo zależy mi na roli, próbuję zrobić wrażenie zamiast być w scenie.”",
    "mm.step7.example2": "„Pod presją zaczynam obserwować siebie.”",
    "mm.step7.example3": "„Próbuję zgadnąć, czego chce reżyser, zamiast zaufać swojej interpretacji.”",
    "mm.step7.example4": "„Kiedy się stresuję, przestaję naprawdę słuchać partnera.”",
    "mm.step7.q1": "Czy rozpoznajesz u siebie jakiś wzorzec zachowania? Jeśli tak, jaki?",
    "mm.step7.q2": "Czy znasz ten wzorzec z wcześniejszych castingów lub innych sytuacji aktorskich?",

    "mm.step8.title": "Moje wyzwanie",
    "mm.step8.question": "Co jest teraz moim najważniejszym wyzwaniem?",

    "mm.step9.title": "Następny casting",
    "mm.step9.question": "Co chcę trenować podczas następnego castingu?",
    "mm.step9.support": "Następny casting nie musi być tylko kolejną próbą zdobycia roli.\nMoże być również kolejnym powtórzeniem czegoś, nad czym świadomie pracujesz.",
    "mm.step9.empty_pre_casting": "Nie wypełniłeś sekcji PRZED CASTINGIEM dla tego projektu. Pamiętaj o niej następnym razem, aby móc porównać swoje oczekiwania z efektami.",

    "mm.step10.title": "Zamknij casting",
    "mm.step10.question": "Co zostawiasz w tym castingu?",
    "mm.step10.close_btn": "ZAMKNIJ CASTING",

    "mm.final.line1": "Ten casting jest zakończony.",
    "mm.final.line2": "Wiesz, co zrobiłeś dobrze.",
    "mm.final.line3": "Wiesz, czego się nauczyłeś.",
    "mm.final.line4": "Wiesz, co jest Twoim wyzwaniem.",
    "mm.final.line5": "Wiesz, co chcesz trenować następnym razem.",
    "mm.final.next": "NEXT.",

    "mm.summary.did_well": "Co zrobiłem dobrze",
    "mm.summary.differently": "Co chcę zrobić inaczej",
    "mm.summary.learned": "Czego się nauczyłem",
    "mm.summary.pattern": "Wzorzec zachowania",
    "mm.summary.challenge": "Moje wyzwanie",
    "mm.summary.next": "Na następnym castingu chcę trenować",
    "mm.summary.leaving": "Co zostawiam w tym castingu",
    "mm.summary.view_full": "Zobacz pełny MASTERMIND",
    "mm.summary.edit_full": "Edytuj MASTERMIND",

    "mm.nav.next": "Dalej",
    "mm.nav.back": "Wstecz",
    "mm.nav.save": "Zapisz",
    "mm.nav.cancel": "Anuluj",

    // ===== ŚCIEŻKA KARIERY (Career Path) =====
    "path.dash_tile_eyebrow": "Ścieżka kariery",
    "path.dash_tile_title": "Cele i zadania",
    "path.dash_tile_body": "Wybierz ważny cel, zobacz prosty następny krok, wykonaj go. Bez przytłoczenia, z konkretną sprawczością.",
    "path.open": "Otwórz Ścieżkę kariery",

    "tasks.dash_tile_eyebrow": "Zadania operacyjne",
    "tasks.dash_tile_title": "Bieżące zadania",
    "tasks.dash_tile_body": "Follow-upy, selftape'y, materiały, networking. Jedno miejsce na wszystko, co masz teraz do zrobienia.",
    "tasks.open": "Otwórz zadania",

    "path.title": "Ścieżka kariery",
    "path.subtitle": "Cele i zadania",
    "path.pick_ops": "Zadania operacyjne",
    "path.pick_ops_body": "np. follow-up z reżyserem castingu po wysłaniu selftape'a.",
    "path.pick_plan": "Plan kariery",
    "path.pick_plan_body": "Jak chcesz rozwijać swoją karierę?",
    "actor_profile.tile_title": "Mój profil aktorski",
    "actor_profile.tile_body": "Określ, kim jesteś jako aktor, w jakich rolach widzi Cię świat, jakie role Ty chcesz grać i jakie wartości chcesz wnosić do pracy.",
    "actor_profile.section_identity": "TOŻSAMOŚĆ",
    "actor_profile.section_identity_sub": "Kim jestem jako aktor?",
    "actor_profile.section_direction": "KIERUNEK",
    "actor_profile.section_direction_sub": "Dokąd idę?",
    "actor_profile.section_work_standard": "STANDARD",
    "actor_profile.section_work_standard_sub": "Jak chcę pracować?",
    "actor_profile.section_alignment": "SPÓJNOŚĆ",
    "actor_profile.section_alignment_sub": "Czy to, co robię, jest z tym zgodne?",
    "actor_profile.alignment_hint": "Wracaj tu od czasu do czasu. Co w Twojej obecnej karierze jest zgodne z tym, kim jesteś, dokąd chcesz iść i jak chcesz pracować? Gdzie widzisz rozjazd?",
    "actor_profile.q_identity_1": "Co najbardziej lubisz w sobie jako aktorze?",
    "actor_profile.q_identity_2": "Co przychodzi Ci naturalnie jako aktorowi? Co nie wymaga od Ciebie udawania ani forsowania?",
    "actor_profile.q_identity_3": "W jakich rolach lub postaciach czujesz się szczególnie dobrze i wiarygodnie?",
    "actor_profile.q_identity_4": "Co jest charakterystyczne dla Twojej obecności na ekranie lub scenie?",
    "actor_profile.q_identity_5": "Co najczęściej słyszysz o sobie od innych — reżyserów, casting directorów, agentów, pedagogów, aktorów?",
    "actor_profile.q_identity_6": "Do jakich ról najczęściej jesteś zapraszany? Jakie role już grałeś? Czy widzisz coś, co się powtarza?",
    "actor_profile.q_identity_7": "Co jeszcze Cię wyróżnia? Pomyśl o głosie, wyglądzie, energii, sposobie bycia, językach, akcentach, umiejętnościach, doświadczeniach i rzeczach, których nie widać na headshocie.",
    "actor_profile.q_direction_1": "Jakie tematy są dziś dla Ciebie ważne? Na przykład: Za czym tęsknisz? Czego Ci brakuje? Co Cię porusza, boli, fascynuje albo nie daje spokoju? Co przeżywasz lub próbujesz dziś zrozumieć?",
    "actor_profile.q_direction_2": "Jakie postaci najbardziej Cię przyciągają?",
    "actor_profile.q_direction_3": "Jakich historii chcesz być częścią?",
    "actor_profile.q_direction_4": "Czego chcesz więcej w swojej karierze — filmu, serialu, teatru, a może czegoś jeszcze?",
    "actor_profile.q_direction_5": "Czy są konkretne filmy, seriale, spektakle albo role, przy których myślisz: „Chcę robić takie rzeczy”?",
    "actor_profile.q_direction_6": "Z jakimi reżyserami lub innymi twórcami chciałbyś pracować?",
    "actor_profile.q_direction_7": "Czego chciałbyś spróbować, mimo że rynek jeszcze może Cię tak nie widzieć?",
    "actor_profile.q_direction_8": "Z czego chciałbyś być znany jako aktor?",
    "actor_profile.q_work_1": "Po co idziesz na plan albo na scenę? Co chcesz tam zrobić — poza tym, żeby dobrze wypaść?",
    "actor_profile.q_work_2": "Co dla Ciebie oznacza dobrze wykonana praca?",
    "actor_profile.q_work_3": "Po czym poznasz, że miałeś dobry dzień pracy, nawet jeśli nikt Cię nie pochwali?",
    "actor_profile.q_work_4": "Jak chcesz traktować swoich partnerów i ludzi z ekipy?",
    "actor_profile.q_work_5": "Jak chcesz, żeby ludzie czuli się, pracując z Tobą?",
    "actor_profile.q_work_6": "Jak sam chcesz być traktowany przez ludzi, z którymi pracujesz?",
    "actor_profile.q_work_7": "Co Ty musisz dawać innym, żeby współtworzyć właśnie takie relacje i takie miejsce pracy?",
    "actor_profile.q_work_8": "Jakim aktorem chcesz być, kiedy pojawia się stres, zmęczenie, presja albo coś nie idzie po Twojej myśli?",
    "actor_profile.q_work_9": "Jak chcesz być pamiętany po zakończeniu wspólnej pracy?",
    "actor_profile.answer_ph": "Twoja odpowiedź…",
    "actor_profile.btn_back": "Wstecz",
    "actor_profile.btn_next": "Dalej",
    "actor_profile.btn_generate": "Stwórz mój profil",
    "actor_profile.btn_edit": "Edytuj",
    "actor_profile.btn_save": "Zapisz",
    "actor_profile.btn_cancel": "Anuluj",
    "actor_profile.creators_title": "Twórcy, których warto poznać",
    "actor_profile.creators_intro": "Poznaj ich pracę, znajdź właściwe profesjonalne kontakty, dodaj istotne osoby do CRM LEO i świadomie buduj relacje.",
    "actor_profile.creators_empty": "Na razie nie ma wystarczającej podstawy do konkretnych nazwisk. Uzupełnij Kierunek i wygeneruj profil ponownie.",
    "actor_profile.generating": "Tworzę Twój profil…",
    "actor_profile.generating_slow": "Generowanie trwa dłużej niż zwykle…",
    "actor_profile.btn_cancel_generation": "Anuluj / Spróbuj ponownie",
    "actor_profile.gen_error": "Nie udało się stworzyć profilu. Spróbuj ponownie.",
    "actor_profile.save_error": "Nie udało się zapisać. Spróbuj ponownie.",
    "actor_profile.load_error": "Nie udało się załadować profilu.",
    "actor_profile.empty_body": "Uzupełnij workbook w 3 sekcjach. Odpowiedzi mogą być puste — LEO wygeneruje profil na podstawie tego, co napiszesz.",
    "actor_profile.wizard_progress": "Sekcja {n} z 3",
    "actor_profile.paywall_title": "Odblokuj pełny Profil Aktorski",
    "actor_profile.paywall_subtitle": "Dokończ swój profil, określ kierunek i standard pracy oraz zobacz analizę LEO. Pełny Profil Aktorski jest dostępny w planach LEO START, LEO MONTHLY i LEO ANNUAL.",
    "actor_profile.btn_edit_answers": "EDYTUJ ODPOWIEDZI",
    "actor_profile.btn_update": "ZAKTUALIZUJ MÓJ PROFIL",
    "actor_profile.btn_cancel_editing": "ANULUJ EDYCJĘ",
    "actor_profile.north_star_line1": "Wiesz już, co jest Twoją Gwiazdą Polarną.",
    "actor_profile.north_star_line2": "Stwórz ścieżkę kariery.",
    "actor_profile.go_to_paths": "IDŹ DO ŚCIEŻEK KARIERY",
    "actor_profile.next_step_title": "TWÓJ NASTĘPNY KROK",
    "actor_profile.create_this_path": "STWÓRZ TĘ ŚCIEŻKĘ",
    "actor_profile.enter_own_path": "WPISZ SWOJĄ ŚCIEŻKĘ",
    "actor_profile.path_name_uk_agent": "Znaleźć agenta w UK",
    "actor_profile.path_name_get_more_auditions": "Zwiększyć liczbę castingów w UK",
    "actor_profile.path_name_more_castings_pl": "Zwiększyć liczbę castingów w Polsce",
    "actor_profile.path_name_casting_directors_pl": "Zbudować bazę polskich reżyserów castingu",
    "path.uk_agent_eyebrow": "Gotowa ścieżka",
    "path.uk_agent_title": "Znajdź agenta w UK",
    "path.uk_agent_body": "10-krokowa ścieżka: profil, pakiet, lista agencji, kontakt, follow-up, spotkanie i podpisanie umowy.",
    "path.uk_agent_locked_note": "Dostępne w planach LEO START, MONTHLY i ANNUAL",
    "path.gma_eyebrow": "Gotowa ścieżka",
    "path.gma_title": "Zwiększ liczbę castingów w UK",
    "path.gma_body": "10-krokowa ścieżka: audyt lejka castingowego, castability, Spotlight, zgłoszenia, rozmowa z agentem i porównanie po 30 dniach.",
    "path.paid_lock_badge": "LEO START / MONTHLY / ANNUAL",
    "path.paid_locked_note": "Dostępne w planach LEO START, MONTHLY i ANNUAL",

    "plan.top_note": "Stwórz sobie sprzyjającą atmosferę do planowania: włącz relaksującą muzykę, zapal świeczkę, przywołaj rozluźniający rytuał.",
    "plan.intro": "Planowanie dużych celów może być przytłaczające, ale rozbicie ich na małe, konkretne kroki pozwala spojrzeć na ich realizację w bardziej realistyczny sposób. Zamiast próbować zrobić wszystko naraz, warto skupić się np. na dwóch najważniejszych zadaniach w danym tygodniu — dzięki temu duży, odległy cel zaczyna zamieniać się w serię małych, wykonalnych działań. Jakie cele są dla Ciebie dziś najważniejsze i mogą stać się kolejnymi kamieniami milowymi w Twojej karierze?",
    "plan.add_goal": "Dodaj nowy cel",
    "plan.suggestions_title": "Podpowiedzi Leo",
    "plan.custom_goal": "Wpisz własny cel",
    "plan.custom_goal_ph": "np. Zbudować bazę polskich reżyserów castingu",
    "plan.next": "Dalej",

    "goal.q1": "Po czym poznaję, że realizuję ten cel?",
    "goal.q1_hint": "Co konkretnie dzieje się w Twojej karierze? Po czym widzisz, że ten rezultat staje się rzeczywistością?",
    "goal.q2": "Co będzie możliwe dzięki realizacji tego celu? Po co tego chcę?",
    "goal.q3": "Do kiedy chcę to osiągnąć?",
    "goal.q4": "Ile czasu w ciągu tygodnia na to przeznaczę? (w godzinach)",
    "goal.q_creating": "Co tworzę?",
    "goal.q_creating_hint": "Opisz rezultat, który tworzysz w swojej karierze — nie pierwszy krok ani zadanie.",
    "goal.q_possibilities": "Co jest możliwe dzięki realizacji tego celu?",
    "goal.q_possibilities_hint": "Pomyśl, jakie nowe możliwości otwiera przed Tobą osiągnięcie tego rezultatu.",
    "goal.q_have": "Co już mam, co pomaga mi to osiągnąć?",
    "goal.q_have_hint": "Pomyśl o doświadczeniu, umiejętnościach, materiałach, kontaktach, reprezentacji, językach, wiedzy i innych zasobach, które już działają na Twoją korzyść.",
    "goal.q_missing": "Czego jeszcze mi brakuje, żeby to osiągnąć?",
    "goal.q_missing_hint": "Czego potrzebujesz się nauczyć, zdobyć, poprawić lub zbudować?",
    "goal.q_stops": "Co najbardziej powstrzymuje mnie dzisiaj przed działaniem?",
    "goal.q_stops_hint": "Pomyśl, co naprawdę Cię zatrzymuje: strach przed odrzuceniem, brak planu, odkładanie działania, brak czasu, niepewność albo coś innego.",
    "goal.q_lose": "Co tracę, jeśli nic się nie zmienia?",
    "goal.q_lose_hint": "Pomyśl o cenie pozostania dokładnie w tym samym miejscu.",
    "goal.q4_hint": "Leo wykorzysta tę liczbę, żeby nie zaplanować Ci więcej pracy niż realnie możesz udźwignąć.",
    "goal.q5": "Jak realizacja tego celu i osiągnięcie efektów wpływa na inne obszary mojego życia?",
    "goal.q5_hint": "Pomyśl nie tylko o karierze, ale też o finansach, relacjach, miejscu życia, poczuciu bezpieczeństwa, wolności lub satysfakcji.",
    "goal.why_title": "Dlaczego to robię",
    "goal.why_more_title": "Wszystkie odpowiedzi z workbooka",
    "goal.why_hint": "Twoje pozostałe odpowiedzi z Mini workbooka.",
    "goal.why_empty": "Brak zapisanych odpowiedzi.",
    "goal.why_q4_unit": "godz./tydzień",
    "goal.q_answer_ph": "Napisz swobodnie — Twoimi słowami.",
    "goal.save": "Zapisz cel",
    "goal.saving": "Zapisuję…",
    "goal.saved": "Cel zapisany.",
    "goal.save_fail": "Nie udało się zapisać celu.",

    "planpath.title": "Jak chcesz stworzyć plan?",
    "planpath.own": "Stworzę plan sam",
    "planpath.leo": "Poproszę Leo o pomoc",

    "step.list_title": "Wszystkie kroki",
    "step.next_hero": "Twój następny krok",
    "step.add": "+ Dodaj krok",
    "step.name_ph": "np. Napisz do 3 agentów",
    "step.time_min": "min",
    "step.time_est": "szac. czas",
    "step.due": "termin",
    "step.mark_done": "Wykonane",
    "step.mark_undone": "Cofnij",
    "step.delete": "Usuń krok",
    "step.confirm_delete": "Usunąć ten krok?",
    "step.saved": "Krok zapisany.",
    "step.save_fail": "Nie udało się zapisać kroku.",
    "step.done": "Zrobione",
    "step.progress": "Postęp celu",
    "step.leo_generate": "Poproś Leo o plan",
    "step.leo_generating": "Leo planuje…",
    "step.reward_title": "Nagroda za miesiąc",
    "step.reward_ph": "Jak chcesz uczcić to, że zrobiłeś/zrobiłaś to, co sobie obiecałeś/obiecałaś?",
    "step.reward_save": "Zapisz nagrodę",
    "step.reward_saved": "Nagroda zapisana.",
    "step.leo_ask_hours_title": "Ile czasu tygodniowo możesz realnie poświęcić na ten cel?",
    "step.leo_ask_hours_ph": "np. 3",
    "step.leo_ask_hours_unit": "godzin/tydzień",
    "step.leo_confirm": "Wygeneruj plan z Leo",
    "step.leo_update": "Poproś Leo o aktualizację planu",
    "step.leo_generating_wait": "Leo planuje… może to zająć 10–20 sekund.",
    "step.leo_banner": "Plan przygotowany przez Leo \u2726",
    "step.leo_banner_n_one": "Leo rozłożył ten cel na 1 krok, uwzględniając Twój dostępny czas.",
    "step.leo_banner_n_few": "Leo rozłożył ten cel na {n} kroki, uwzględniając Twój dostępny czas.",
    "step.leo_banner_n_many": "Leo rozłożył ten cel na {n} kroków, uwzględniając Twój dostępny czas.",
    "step.leo_fail": "Leo nie mógł teraz wygenerować planu. Spróbuj ponownie.",
    "step.postpone.title": "Przełóż krok",
    "step.edit.title": "Edytuj krok",

    "goal.no_next_step": "Wszystkie kroki wykonane. Gratulacje!",
    "goal.no_steps_yet_title": "Nie masz jeszcze wyznaczonych kroków.",
    "goal.no_steps_yet_body": "Ustal poszczególne etapy realizacji celu samodzielnie lub poproś Leo o wytyczenie ich z realistycznym harmonogramem.",
    "goal.plan_myself": "Stworzę plan sam",
    "goal.plan_leo": "Poproszę Leo o pomoc",
    "goal.delete": "Usuń cel",
    "goal.confirm_delete": "Usunąć ten cel razem ze wszystkimi krokami?",
    "goal.deleted": "Cel usunięty.",
    "goal.back": "Wróć do planu",
    "goal.no_goals": "Nie masz jeszcze żadnych celów. Dodaj pierwszy.",

    "review.title": "Przegląd tygodnia",
    "review.subtitle": "Krótki, spokojny podsumowujący widok.",
    "review.done_n": "{n} zadania wykonane",
    "review.in_progress_n": "{n} w toku",
    "review.postponed_n": "{n} przełożone",
    "review.next": "Następny krok:",
    "review.q": "Czy chcesz coś zmienić w planie na kolejny tydzień?",

    // ===== ZADANIA OPERACYJNE =====
    "ops.title": "Zadania operacyjne",
    "ops.subtitle": "Bieżące rzeczy do zrobienia — follow-upy, selftape'y, materiały, networking.",
    "ops.new": "+ Nowe zadanie",
    "ops.empty": "Brak zadań. Dodaj pierwsze.",
    "ops.form.title_new": "Nowe zadanie",
    "ops.form.title_edit": "Edytuj zadanie",
    "ops.form.name": "Tytuł zadania *",
    "ops.form.name_ph": "np. Follow-up z Martą Cartą",
    "ops.form.category": "Kategoria",
    "ops.form.due": "Termin",
    "ops.form.contact": "Powiązany kontakt",
    "ops.form.contact_none": "— brak powiązania —",
    "ops.form.notes": "Notatki",
    "ops.form.save": "Zapisz zadanie",
    "ops.form.saved": "Zadanie zapisane.",
    "ops.form.fail": "Nie udało się zapisać.",

    "ops.cat.contact": "Kontakt",
    "ops.cat.followup": "Follow-up",
    "ops.cat.selftape": "Selftape",
    "ops.cat.materials": "Przygotowanie materiałów",
    "ops.cat.networking": "Networking",
    "ops.cat.research": "Research",
    "ops.cat.meeting": "Spotkanie",
    "ops.cat.other": "Inne",

    "ops.status.todo": "Do zrobienia",
    "ops.status.in_progress": "W toku",
    "ops.status.done": "Zrobione",
    "ops.status.postponed": "Przełożone",

    "ops.action.complete": "✓ Zakończ zadanie",
    "ops.action.postpone": "Przełóż",
    "ops.action.delete": "Usuń zadanie",
    "ops.action.edit": "Edytuj",
    "ops.confirm_delete": "Usunąć to zadanie?",
    "ops.deleted": "Zadanie usunięte.",

    "ops.postpone.title": "Przełóż zadanie",
    "ops.postpone.q": "Kiedy realnie chcesz się tym zająć?",
    "ops.postpone.still_important": "Czy to zadanie nadal jest ważne dla celu?",
    "ops.postpone.remove": "Usuń zadanie z planu",
    "ops.postpone.save": "Przełóż",
    "ops.postpone.saved": "Zadanie przełożone.",
    "ops.postpone.repeated_note": "Widzę, że kilka razy przekładasz to zadanie. Chcesz ustalić mniejszy krok, zmienić termin, czy zdecydować, że nie jest już ważne?",

    "ops.complete.title": "Zadanie zakończone",
    "ops.complete.contact_line": "Kontakt z: {name}",
    "ops.complete.last_set": "Ostatni kontakt zostanie ustawiony na: {date}",
    "ops.complete.next_q": "Kiedy chcesz skontaktować się ponownie?",
    "ops.complete.save": "Zapisz",
    "ops.complete.no_next": "Nie planuję kolejnego kontaktu",
    "ops.complete.no_next_q": "Dlaczego nie planujesz kolejnego kontaktu?",
    "ops.complete.saved": "Zadanie zakończone i CRM zaktualizowany.",
    "ops.complete.simple": "Zadanie zakończone.",

    // Dashboard summary cards (Command Center)
    "cc.goal_title": "Twój aktualny cel",
    "cc.no_active_goal": "Nie masz jeszcze aktywnego celu.",
    "cc.no_active_goal_cta": "Dodaj cel w Ścieżce Kariery.",
    "cc.next_step_label": "Twój następny krok:",
    "cc.open": "Otwórz",
    "cc.tasks_title": "Zadania operacyjne",
    "cc.next_task_label": "Twój najbliższy termin:",
    "cc.no_open_tasks": "Brak otwartych zadań.",
    "cc.tasks_pending_one": "1 zadanie oczekuje",
    "cc.tasks_pending_n": "{n} zadania oczekują",
    "cc.tasks_pending_many": "{n} zadań oczekuje",
    "cc.see_all": "Zobacz wszystkie",
    "cc.command_center": "Twoje centrum dowodzenia",

    // Task sections + LED dots
    "ops.sec.today": "Do kontaktu dzisiaj / Zaległe",
    "ops.sec.upcoming": "Nadchodzące (7 dni)",
    "ops.sec.later": "Później",
    "ops.sec.done": "Zrobione",
    "ops.sec.empty": "—",

    // Gentle Reminders
    "gr.title": "Delikatne przypomnienia",
    "gr.tagline": "Zacznij dzień od jednego konkretnego kroku.",
    "gr.status_on": "Włączone",
    "gr.status_off": "Wyłączone",
    "gr.explainer": "Każdego tygodnia wybierzemy dla Ciebie najważniejszy następny krok i delikatnie przypomnimy Ci o nim rano.",
    "gr.disable": "Zrezygnuj z przypomnień",
    "gr.enable": "Włącz ponownie",
    "gr.preview_title": "Jutro rano otrzymasz:",
    "gr.preview_next_step": "🎬 Twój następny krok",
    "gr.preview_why": "Dlaczego właśnie to?",
    "gr.preview_your_goal": "Twój cel:",
    "gr.preview_your_why": "Dlaczego tego chcesz:",
    "gr.no_active_prev": "Brak aktywnego celu z niewykonanym krokiem — poranny email nie zostanie wysłany, dopóki nie dodasz kroku do celu.",
    "gr.why_pick.first_step": "To pierwszy niewykonany krok prowadzący do Twojego celu \u201E{goal}\u201D.",
    "gr.why_pick.overdue": "Ten krok ma zaległy termin — dobrze mieć go z głowy.",
    "gr.why_pick.due_today": "Ten krok jest zaplanowany na dziś.",
    "gr.why_pick.next_after": "To kolejny krok po ukończeniu poprzednich.",
    "gr.gentle_note": "Nie musisz zrobić dziś całej kariery. Zrób jeden krok.",
    "gr.toast_on": "Włączyłeś Delikatne przypomnienia.",
    "gr.toast_off": "Wyłączyłeś Delikatne przypomnienia.",
  },

  en: {
    "nav.scenes": "Scenes / Self-tape",
    "nav.plans": "Plans",
    "nav.logout": "Log out",
    "nav.language": "Language",
    "brand.tagline": "The Actor's Career System",
    "brand.name": "LEO — The Actor's Career System",
    "action.cancel": "Cancel",
    "action.save": "Save",
    "action.close": "Close",
    "action.change": "Change",

    "splash.eyebrow": "LEO — The Actor's Career System",
    "splash.title1": "Leo — Scene",
    "splash.title2": "Ready.",
    "splash.tagline": "You create the art. Leo helps you prepare.",
    "splash.body": "Your partner on the way to acting truth. Upload a scene and move through a deep analysis of Goal, Obstacles and Subtext from the Needs Codex. The Mirroring Matrix helps you quickly connect the text with your inner fuel. With the interactive text rehearsal, you'll walk into any casting or set fully in charge and ready. Leo supports your preparation — you create the art.",
    "splash.enter": "Enter the studio",
    "splash.start": "Start working",
    "splash.login": "Log in",
    "splash.pricing": "See plans",
    "splash.voices": "Voices from the rehearsal room",

    "auth.entry": "Enter the studio",
    "auth.login": "Log in",
    "auth.new": "New account",
    "auth.private": "Your scene history is saved privately to your account.",
    "auth.google": "Continue with Google",
    "auth.or_email": "OR EMAIL",
    "auth.name": "Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.password_hint": "min. 6 characters",
    "auth.enter_btn": "Enter",
    "auth.create_btn": "Create account",
    "auth.wait": "One moment…",
    "auth.forgot_password": "Forgot your password?",
    "auth.forgot_need_email": "Enter your email in the field above first.",
    "auth.forgot_sent": "If that account exists, we've sent a reset link.",
    "auth.reset_title": "Set a new password",
    "auth.reset_hint": "Enter the new password for your account.",
    "auth.new_password": "New password",
    "auth.reset_submit": "Save new password",
    "auth.reset_bad_token": "The link is invalid or has expired.",
    "auth.reset_fail": "Could not reset the password. Try requesting a new link.",
    "auth.reset_done": "Password updated. You can log in now.",
    "auth.back_to_login": "← Back to login",
    "auth.new_here": "New here?",
    "auth.create_link": "Create account",
    "auth.have_account": "Already have an account?",
    "auth.login_link": "Log in",
    "auth.back": "← Back to the main stage",

    "dash.rehearsal_room": "Rehearsal / Self-tape room",
    "dash.welcome": "Welcome",
    "dash.subtitle": "Choose a scene from your archive or upload a new one — text or PDF. Leo is waiting.",
    "dash.manifesto_headline": "Don’t wait for the next audition.\nBuild your career.",
    "dash.manifesto_body": "LEO is a complete career management system for actors. It helps you plan your next steps, discover new opportunities, build industry relationships, keep track of auditions and meetings, and prepare for auditions and roles.",
    "dash.manifesto_imagine": "Imagine where you could be a year from now if you start today.",
    "dash.manifesto_cta": "Let's make it one hell of a journey!",
    "dash.manifesto_credits_prefix": "Marcin Zarzeczny",
    "dash.manifesto_credits_films": "(The Agency, Out There, Supernova)",
    "splash.point1_title": "BUILD RELATIONSHIPS",
    "splash.point1_body": "Organise your contacts with agents, directors, casting directors and other industry professionals. Keep track of your communication history, notes and follow-ups.",
    "splash.point2_title": "PLAN YOUR CAREER",
    "splash.point2_body": "Choose a Career Path or define your own goal. Turn it into concrete actions and manageable steps you can work on each week.",
    "splash.point3_title": "PREPARE FOR AUDITIONS AND ROLES",
    "splash.point3_body": "Analyse scenes, develop your interpretation, learn your lines and prepare for auditions, self-tapes or a day on set.",
    "splash.tagline_below_points": "Everything in one place — so instead of waiting to see what happens in your career, you can actively build it.",
    "splash.credibility_line": "Created by a professional actor working in international productions",
    "dash.q_today": "What will you do for your career today?",
    "dash.body": "Prepare a scene, nurture your relationships with casting directors and other industry professionals, or take the next step in your career.",
    "dash.q_start": "Where do we start?",
    "dash.new_scene": "New scene",
    "dash.tile.upload.title": "Prepare a Scene / Self-tape",
    "dash.tile.upload.subtitle": "Analyse your scene or go straight to rehearsal / recording your self-tape with the AI Reader.",
    "dash.tile.upload.cta": "Upload a Scene",
    "dash.tile.upload.my_scenes": "My scenes",
    "dash.free_first_title": "First scene — free",
    "dash.free_first_body": "Prepare your first scene with Leo. Free.",
    "dash.your_scenes": "Your scenes",
    "dash.loading": "loading archive…",
    "dash.empty_title": "The curtain has not risen yet.",
    "dash.empty_body": "Upload your first text to begin.",
    "dash.upload_first": "Upload your first scene",
    "dash.scene_analyzed": "Analyzed",
    "dash.scene_pending": "To analyze",
    "dash.confirm_delete": "Delete this scene permanently?",
    "dash.deleted": "Scene deleted.",
    "dash.delete_failed": "Could not delete.",

    "new.eyebrow": "Step 1 · Upload the scene",
    "new.title": "New scene",
    "new.subtitle": "Paste the text or drop a PDF. Add a project brief and note the character you play.",
    "new.scene_title": "Scene / project title",
    "new.scene_title_ph": "e.g. \”Winter War\” — sc. 14",
    "new.my_character": "My character",
    "new.my_character_ph": "e.g. Martha, 34, a mother",
    "new.brief": "Project brief (director, world, genre)",
    "new.brief_ph": "Director wants subtlety. World: cold winter 1985. The character has a childhood secret.",
    "new.scene_text_label": "Scene text",
    "new.upload_pdf": "Upload file",
    "new.upload_formats": "PDF, JPG, PNG",
    "new.reading": "Reading…",
    "new.chars": "chars",
    "new.save_run": "Save and run Leo",
    "new.save_go_rehearsal": "Save & Go to Rehearsal / Self-Tape",
    "new.scene_language": "Scene language",
    "new.saving": "Saving…",
    "new.short_text": "The scene text is too short.",
    "new.pdf_ok": "Text extracted from the PDF.",
    "new.pdf_fail": "Could not read the PDF.",
    "new.saved": "Scene saved. Starting Leo's Brain…",
    "new.paywall_msg": "You've used your free scene. Choose a plan.",
    "new.save_fail": "Could not save the scene.",

    "tab.analysis": "Analysis",
    "tab.mirror": "Mirroring in you",
    "tab.map": "Emotional map",
    "tab.zapalnik": "Trigger",
    "tab.eight": "8 questions",
    "tab.vagus": "Vagus nerve",
    "tab.rehearsal": "Rehearsal / Self-tape",
    "tab.ask": "Ask Leo",
    "tab.notebook": "Notebook",
    "tab.history": "History",
    "tab.decompression": "Grounding",

    "map.eyebrow": "Mirroring · Emotional map",
    "map.title": "Emotional map. Scene elements → Your personalization.",
    "map.subtitle": "Leo maps scenic elements to your personalization — character by character, symbol by symbol. You can edit each item.",
    "map.generate": "Generate map",
    "map.regenerate": "Regenerate",
    "map.generating": "Leo is mapping…",
    "map.in_scene": "In the scene",
    "map.in_your_life": "In your imagination",
    "map.add_row": "Add row",
    "map.save": "Save map",
    "map.saved": "Map saved.",
    "map.need_mirror": "Do the Mirroring first.",
    "map.empty": "Press \”Generate map\” so Leo can propose a mapping.",

    "zap.eyebrow": "Trigger · Right before the scene",
    "zap.title": "Leo warms you up for the scene.",
    "zap.subtitle": "A private speech grounded in your Mirroring and Goal. Not for publication — for you.",
    "zap.generate": "Generate Trigger",
    "zap.regenerate": "Regenerate",
    "zap.generating": "Leo is writing…",
    "zap.empty": "Press \”Generate Trigger\” so Leo writes your private opening right before the scene.",
    "zap.saved": "Trigger saved.",
    "zap.need_map": "Generate the Emotional Map first — Leo will have material to draw from.",

    "eight.eyebrow": "Craft & Truth · 8 questions",
    "eight.title": "Land in the scene before the rehearsal.",
    "eight.subtitle": "Eight questions the character asks through you. Leo drafts — you edit until it becomes truth.",
    "eight.generate": "Generate answers",
    "eight.regenerate": "Regenerate",
    "eight.generating": "Leo is drafting…",
    "eight.save": "Save answers",
    "eight.saved": "Saved.",
    "eight.answer_ph": "— answer in the first person…",
    "eight.empty": "Press \”Generate answers\” so Leo drafts the 8 questions to start.",

    "vag.eyebrow": "Vagus nerve · Before rehearsal",
    "vag.title": "Settle before Craft & Truth.",
    "vag.subtitle": "Short breathing and body exercises — 3-6 minutes. No judgment, no rush. Not a substitute for medical care.",
    "vag.start": "Start",
    "vag.next": "Next",
    "vag.done": "Done",
    "vag.step": "Exercise",

    "ask.eyebrow": "Chat · Privately with Leo",
    "ask.title": "Ask Leo anything about this scene.",
    "ask.subtitle": "He does not run the rehearsal here. He coaches. Answers without judgment — options, not verdicts.",
    "ask.input_ph": "e.g. \”I'm afraid I'll be too aggressive. How do I play this?\”",
    "ask.reset": "Reset",
    "ask.confirm_reset": "Clear the whole conversation with Leo?",
    "ask.empty": "Write your first question — about the character, a line, a choice, a doubt.",
    "ask.leo": "Leo",
    "ask.you": "You",
    "scene.back": "Back",
    "scene.eyebrow": "Scene · Working studio",
    "scene.your_character": "Your character",
    "scene.export_pdf": "Export PDF",

    "an.wait_title": "Leo's Brain is ready to start.",
    "an.wait_body": "The analysis will surface the Goal from the Needs Codex, Obstacles and Actor's Tasks.",
    "an.run": "Run analysis",
    "an.thinking": "Leo is thinking…",
    "an.rerun": "Run the analysis again",
    "an.rerunning": "Analyzing…",
    "an.goal": "Character's goal · Needs Codex",
    "an.addressee": "Directed to",
    "an.obstacles": "Obstacles",
    "an.tasks": "Actor's tasks",
    "an.leo_note": "Leo's note",
    "an.task": "TASK",
    "an.change_goal": "Change scene goal",
    "an.list_needs": "Needs list",
    "an.manually_set": "manually set",
    "an.done": "Leo finished the analysis.",
    "an.fail": "Analysis failed.",
    "an.relacja": "Relationship",
    "an.rel_source": "Source of the goal — from the relationship",
    "an.rel_needs": "Partner's needs (human level)",
    "an.rel_fears": "What the partner fears",
    "an.rel_dynamic": "Relationship",
    "an.subtext": "Subtext",
    "an.subtext_intro": "Moments where words may hide the real need.",
    "an.subtext_surface": "Surface",
    "an.subtext_real": "Real need",
    "an.missing_extras": "This analysis is from an older version — run the analysis again to see Relationship and Subtext.",

    "goal.dialog_title": "Change scene goal",
    "goal.dialog_desc": "Pick a new Need from the strict Codex or enter YOUR OWN goal. Leo will rewrite the analysis around the chosen goal.",
    "goal.search_ph": "Search in Polish or English…",
    "goal.confirm": "Save new goal",
    "goal.saved": "New goal saved.",
    "goal.regenerating": "Leo is rewriting the analysis…",
    "goal.fail": "Could not change the goal.",
    "goal.selected": "Selected",
    "goal.custom_toggle": "Write your own Objective",
    "goal.leo_toggle": "Suggest an Objective with Leo",
    "goal.leo_intro": "Leo will propose an Objective rooted in this scene — you can accept, edit, request another one, or reject it and write your own.",
    "goal.leo_thinking": "Leo is reading the scene…",
    "goal.leo_ask": "Suggest an Objective with Leo",
    "goal.leo_again": "Suggest another",
    "goal.leo_accept": "Use this Objective",
    "goal.leo_reject": "Reject and write my own",
    "goal.leo_fail": "Leo couldn't propose an Objective right now.",
    "goal.leo_reason": "Why this Objective:",
    "goal.custom_ph": "e.g. \"I want to wake you from your lie\"",
    "goal.custom_hint": "A custom goal can go outside the Codex. Leo will not judge — he will rewrite the obstacles and tasks around that goal.",
    "goal.save_to_library": "Save this goal to my library",
    "goal.save_to_library_hint": "It will appear in your goals in every scene.",
    "needs.your_library": "My goal library",
    "needs.your_library_empty": "Your own goals will appear here once you save one.",
    "needs.delete_own": "Remove from library",
    "needs.dialog_title": "Needs Codex",
    "needs.dialog_desc": "The full list of needs Leo chooses the goal from. You can search in Polish or English.",
    "needs.copy": "Copy list",
    "needs.copied": "Copied to clipboard",

    "mir.privacy_title": "Your entries are safe here",
    "mir.privacy_body": "All entries are encrypted. Leo works exclusively with imagination, archetypes and the world of the scene — Leo never asks for real people or private memories. Enter only imagined partners, fictional characters or labels (e.g. Boss, Rival, Mentor).",
    "mir.craft_care_title": "Craft & Care — How to build intention?",
    "mir.craft_care_body": "Acting is the art of imagination. Use your creativity to create the conditions that will best drive your character's goal and trigger an authentic determination for action within you. Close your eyes. Think about what your character is striving for in this scene. Imagine the ideal circumstances and create an image in your head of the character against whom this struggle makes the most sense to you. Focus on the energy in your body – the urge for action, movement, and inner strength. Let yourself be led by this determination. When you feel that impulse, give your vision a concrete form so that Leo can become your ideal partner in this rehearsal.",
    "mir.eyebrow": "Interview · Your partner",
    "mir.q1_title": "Label or Name",
    "mir.q1_body": "Name the character you see in your mind. It could be the character's name from the script, an archetype, a fictional character, or simply a label that represents this energy in your imagination (e.g. Boss, Rival, Mentor, Alex, Character X):",
    "mir.q1_ph": "e.g. Boss, Rival, Mentor, Alex, Character X",
    "mir.q2_label": "Conversation Place",
    "mir.q2_title": "Where is this scene physically taking place according to the script?",
    "mir.q2_body": "Imagine this specific place (e.g. office, cafe, car). To make your body believe in this situation, give this space real, physical properties:\n\n• What is the temperature in this place? (e.g. the icy draft of air conditioning, stifling and heavy air)\n• What scent is in the air? (e.g. the smell of freshly brewed coffee, leather seats, the scent of rain)\n• What sound do you hear in the background? (e.g. street noise, a ticking clock, silence)",
    "mir.q2_ph": "e.g. director's office. Cool AC draft, smell of coffee, ticking clock in the background.",
    "mir.notes": "Extra notes",
    "mir.notes_ph": "(optional) — what else do you want to bring with you?",
    "mir.save": "Save Mirroring",
    "mir.saving": "Saving…",
    "mir.saved": "Mirroring saved. Leo will play this partner.",
    "mir.fail": "Could not save.",
    "osadz.eyebrow": "Body & place embodiment",
    "osadz.title": "Leo guides you into the need, before you enter the scene.",
    "osadz.generate": "Generate Embodiment",
    "osadz.regenerate": "Regenerate",
    "osadz.generating": "Leo is guiding…",
    "osadz.empty": "Save Mirroring, then press \"Generate Embodiment\".",
    "takt.eyebrow": "Actor's tactic — Agency",
    "takt.title": "Don't play the victim. Fight for the goal with heart.",
    "takt.generate": "Generate Tactic",
    "takt.regenerate": "Regenerate",
    "takt.generating": "Leo is writing…",
    "takt.empty": "Save Mirroring, then press \"Generate Tactic\".",

    "reh.need_mirror_title": "Do the Mirroring first.",
    "reh.need_mirror_body": "Fill in the Partner Interview so Leo has someone to play for you.",
    "reh.script": "Scene text",
    "reh.readonly": "read-only",
    "reh.title": "Rehearsal / Self-tape with Leo",
    "reh.subtitle": "No judgment. Only truth.",
    "reh.reset": "Reset",
    "reh.confirm_reset": "Start the rehearsal over?",
    "reh.reset_fail": "Reset failed.",
    "reh.you": "You",
    "reh.leo": "Partner",
    "reh.my_line": "My line",
    "reh.send_fail": "Could not continue the rehearsal.",
    "reh.parse_cta": "Start rehearsal",
    "reh.parse_hint": "Leo will first parse the scene: identify the characters, the dialogue and who speaks first. Then the rehearsal runs itself — your only job is to say your line and press \"My line\".",
    "reh.parsing": "Parsing the scene…",
    "reh.parse_fail": "Could not parse the scene.",
    "reh.your_turn": "Your turn — say your line, then press:",
    "reh.your_turn_first": "You start. Say your line and press:",
    "reh.you_speaking": "You (your character)",
    "reh.done_title": "End of scene.",
    "reh.done_body": "You can head to Grounding or reset and play it again.",
    "reh.reparse": "Re-parse the scene",
    "reh.starts_actor": "Your character starts the scene.",
    "reh.starts_other": "The partner starts the scene.",
    "reh.progress": "Line",
    "reh.waiting": "Partner is speaking…",
    "reh.full_scene": "Full scene",
    "reh.full_scene_hint": "The entire script. Your current spot in the scene is highlighted.",
    "reh.close": "Close",
    "reh.current_marker": "You are here",
    "reh.no_script_yet": "Parse the scene to see highlighted lines. Below is the raw text.",
    "reh.ai_reader_title": "AI Reader (hands-free)",
    "reh.ai_reader_hint": "LEO responds when it recognizes the end of your line. Don't change the final words — you can make the line your own, but say the ending exactly as written.",
    "reh.ai_reader_prepping": "Preparing voices…",
    "reh.ai_reader_ready": "Audio Ready ✓",
    "reh.ai_reader_scene_done": "Scene complete",
    "reh.ai_reader_reconnecting": "Reconnecting…",
    "reh.ai_reader_limit_reached": "You have used up your AI Reader time limit on your plan.",
    "reh.ai_reader_voice": "Voice",

    // Section navigation
    "nav.to_mirror": "Go to Mirroring in You",
    "nav.to_map": "Go to Emotional Map",
    "nav.to_zapalnik": "Go to the Trigger",
    "nav.to_eight": "Go to the 8 Questions",
    "nav.to_vagus": "Go to Vagus Nerve",
    "nav.to_rehearsal": "Start rehearsal / self-tape",
    "nav.to_reflection": "Go to Leo's Reflections",
    "nav.save_notes": "Save notes",

    // Reflection
    "reflect.tab": "Leo's Reflections",
    "reflect.title": "Leo's Reflections after the rehearsal",
    "reflect.subtitle": "A short landing after playing. Answer Leo's questions and see 3 alternative takes on the same scene.",
    "reflect.q1": "How did the rehearsal feel?",
    "reflect.q2": "What did you feel while playing?",
    "reflect.q3": "Did you feel the character's motivation?",
    "reflect.q4": "What surprised you?",
    "reflect.answer_ph": "Write freely…",
    "reflect.gen": "Ask Leo for 3 variants",
    "reflect.regen": "Regenerate",
    "reflect.generating": "Leo is finding variants…",
    "reflect.variants_title": "3 takes on the same scene",
    "reflect.variants_hint": "The variants change INTERNAL choices (energy, intention, relationship, tempo, mode of action). The scene's story stays the same.",
    "reflect.saved_to_notes": "Reflection saved to Notebook.",
    "reflect.no_variants_yet": "Press the button above and Leo will propose three acting takes.",
    "reflect.focus.energy": "energy",
    "reflect.focus.intention": "intention",
    "reflect.focus.relationship": "relationship",
    "reflect.focus.tempo": "tempo",
    "reflect.focus.mode": "mode of action",
    "reflect.rehearse_again": "Rehearse again",
    "reflect.go_grounding": "Go to Grounding",

    "note.title": "Actor's notebook",
    "note.subtitle": "Discoveries, interpretive attempts, questions for the director. Private, yours only.",
    "note.ph": "— today I noticed the character does not defend herself…",
    "note.save": "Save notebook",
    "note.saved": "Notebook saved.",
    "note.fail": "Could not save.",

    "dec.eyebrow": "Grounding · After the rehearsal",
    "dec.title": "Come out of the role. Return to yourself.",
    "dec.body": "Acting leaves a trace in the body. Take these four steps calmly, without rushing.",
    "dec.step": "Step",

    "pr.eyebrow": "PRICING",
    "pr.title": "DO YOU REMEMBER THAT MOMENT?",
    "pr.subtitle": "When you first thought: \"I want to be an actor.\" That's your Spark. Don't lose it.",
    "pr.expand_details": "View all features",
    "pr.collapse_details": "Hide details",
    "pr.recommended": "Recommended",
    "pr.launch_badge": "Launch price",
    "pr.best_value": "Best value",
    "pr.includes": "Includes:",
    "pr.does_not_include": "Does not include:",
    "pr.current_section_title": "YOUR CURRENT SUBSCRIPTION",
    "pr.current_plan_label": "Your current plan",
    "pr.current_expires": "Expires",
    "pr.current_next_renewal": "Next renewal",
    "pr.current_valid_until": "Valid until",
    "pr.current_days_left": "left",
    "pr.current_days_word": "days",
    "pr.current_active": "Active",
    "pr.select": "Select",
    "pr.opening": "Opening Stripe…",
    "pr.card_hint": "Secure payment via Stripe. Your card details are never stored in the app. Tax included.",
    "pr.fail": "Could not create payment.",

    "pay.confirming": "Confirming payment with Stripe…",
    "pay.wait": "ONE MOMENT",
    "pay.done": "Paid. Curtain up.",
    "pay.done_body": "Your plan is active.",
    "pay.to_dash": "Let's go!",
    "pay.new_scene": "New scene",
    "pay.fail": "Something went wrong.",
    "pay.retry": "Try again in a moment.",
    "pay.choose": "Choose a plan",

    "prof.title": "Profile",
    "prof.email": "Email",
    "prof.created": "Account created",
    "prof.provider": "Login method",
    "prof.plan_limits": "Plan and limits",
    "prof.change_plan": "Change plan",
    "prof.manage_sub": "Manage subscription",
    "prof.manage_sub_hint": "Invoices, payment method, cancel",
    "prof.manage_sub_fail": "Could not open the Stripe portal.",
    "prof.manage_sub_opening": "Opening Stripe portal…",
    "prof.used": "Free scenes used",
    "prof.credits": "Credits",
    "prof.expires": "Valid until",
    "prof.language": "App and Leo language",
    "prof.reminders_title": "Email reminders",
    "prof.reminders_hint": "Get a short email only when there's a real reason: a CRM follow-up, a Step or Task due. Maximum one email per day. You can turn this off any time.",
    "prof.reminders_on": "On",
    "prof.reminders_off": "Off",
    "prof.reminders_saved": "Saved",
    "prof.reminders_fail": "Could not save.",

    "hdr.plan": "Plan",
    "hdr.free_scenes": "Free scenes",
    "hdr.credits": "Credits",
    "hdr.expires": "Valid until",

    "toast.welcome": "Good to see you.",
    "toast.login_fail": "Could not log in.",
    "toast.google_fail": "Google login failed.",
    "loading.stage": "CURTAIN UP…",
    "loading.scene": "loading scene…",
    "loading.callback": "SETTING THE LIGHTS…",
    "quote.list": "VOICES FROM THE REHEARSAL ROOM",

    // CRM — Career Path
    "crm.dash_tile_eyebrow": "Workflow & CRM",
    "crm.dash_tile_title": "Workflow & CRM · Your professional contacts and auditions",
    "crm.dash_tile_body": "Build and develop relationships with casting directors, directors, and producers. Save auditions and feedback, and Leo will help you leverage them for future opportunities.",
    "crm.open": "Open Workflow & CRM",
    "crm.page_title": "Workflow & CRM",
    "crm.page_subtitle": "Your professional contacts and auditions.",
    "crm.page_tagline": "Build and develop relationships with casting directors, directors, and producers. Save auditions and feedback, and Leo will help you leverage them for future opportunities.",
    "crm.section.contacts": "Contacts",
    "crm.section.auditions": "Auditions",
    "crm.tab.all": "All",
    "crm.tab.casting_director": "Casting directors",
    "crm.tab.director": "Directors",
    "crm.tab.producer": "Producers",
    "crm.tab.casting_assistant": "Casting assistants",
    "crm.tab.screenwriter": "Screenwriters",
    "crm.tab.agent": "Agents",
    "crm.tab.agent_uk": "UK Agents",
    "crm.tab.other": "Others",
    "crm.type.casting_director": "Casting Director",
    "crm.type.director": "Director",
    "crm.type.producer": "Producer",
    "crm.type.casting_assistant": "Casting Assistant",
    "crm.type.screenwriter": "Screenwriter",
    "crm.type.agent": "Agent",
    "crm.type.agent_uk": "UK Agent",
    "crm.type.other": "Other",
    "crm.dash.today": "Follow-up today / Overdue",
    "crm.dash.upcoming": "Upcoming (7 days)",
    "crm.dash.later": "Later",
    "crm.dash.empty": "No contacts in this section.",
    "crm.col.person": "Person",
    "crm.col.type": "Type",
    "crm.col.project": "Project / context",
    "crm.col.email_phone": "Email / Phone",
    "crm.col.last": "Last contact",
    "crm.col.followup": "Follow-up",
    "crm.col.countdown": "Countdown",
    "crm.col.status": "Status",
    "crm.col.action": "Action",
    "crm.action.confirm": "Confirm Contact",
    "crm.action.new": "New contact",
    "crm.action.edit": "Edit",
    "crm.action.delete": "Delete",
    "crm.action.back": "Back to CRM",
    "crm.status.today": "Today / Overdue",
    "crm.status.soon": "Soon",
    "crm.status.active": "Active",
    "crm.countdown.days_left": "in {n} days",
    "crm.countdown.today": "today",
    "crm.countdown.overdue": "{n} days overdue",
    "crm.no_contacts": "No contacts yet. Add your first person to start building your network.",
    "crm.confirm.delete": "Delete this contact permanently?",
    "crm.deleted": "Contact deleted.",
    "crm.delete_fail": "Could not delete.",

    // CRM — Form
    "crm.form.title_new": "New contact",
    "crm.form.title_edit": "Edit contact",
    "crm.form.first_name": "First name",
    "crm.form.last_name": "Last name",
    "crm.form.type": "Contact type",
    "crm.form.company": "Company / agency",
    "crm.form.email": "Email",
    "crm.form.phone": "Phone",
    "crm.form.project": "Project / context",
    "crm.form.project_ph": "e.g. \"Winter War\" — main casting",
    "crm.form.notes": "Notes / Feedback",
    "crm.form.notes_ph": "Short profile, what you talked about, what to remember…",
    "crm.form.last_contact": "Last contact date",
    "crm.form.followup_period": "Follow-up period",
    "crm.form.days30": "30 days",
    "crm.form.days60": "60 days",
    "crm.form.days90": "90 days (default)",
    "crm.form.days120": "120 days",
    "crm.form.days180": "180 days",
    "crm.form.custom_date": "Custom date",
    "crm.form.save": "Save contact",
    "crm.form.saving": "Saving…",
    "crm.form.saved": "Contact saved.",
    "crm.form.fail": "Could not save contact.",
    "crm.form.required": "First name and type are required.",

    // CRM — Confirm modal
    "crm.confirm.title": "Confirm contact",
    "crm.confirm.subtitle": "Pick the type of interaction. Only after confirming will the system save today's date and recompute the next follow-up.",
    "crm.confirm.kind.email": "Email",
    "crm.confirm.kind.phone": "Phone",
    "crm.confirm.kind.message": "Message",
    "crm.confirm.kind.meeting": "Meeting",
    "crm.confirm.kind.casting": "Casting",
    "crm.confirm.kind.materials": "Materials",
    "crm.confirm.note": "Note about the interaction (optional)",
    "crm.confirm.note_ph": "Briefly: what was discussed / the outcome.",
    "crm.confirm.new_followup": "Next follow-up in",
    "crm.confirm.yes": "Yes, confirm",
    "crm.confirm.ok": "Contact confirmed. Timer reset.",
    "crm.confirm.fail": "Could not confirm the contact.",

    // CRM — Profile
    "crm.profile.overview": "Contact details",
    "crm.profile.history": "History of confirmed contacts",
    "crm.profile.no_history": "No confirmed contacts yet. Click \"Confirm Contact\" to log the first interaction.",
    "crm.profile.created": "Added",
    "crm.profile.auditions": "Audition History",
    "crm.profile.no_auditions": "No auditions linked to this person yet.",

    // Auditions
    "aud.list_title": "Auditions",
    "aud.new": "New audition",
    "aud.empty": "No auditions yet. Add your first one to start.",
    "aud.col.project": "Project",
    "aud.col.role": "Role",
    "aud.col.type": "Type",
    "aud.col.cd": "Casting Director",
    "aud.col.next_date": "Next Date",
    "aud.col.status": "Status",
    "aud.no_next_date": "—",
    "aud.form.title_new": "New audition",
    "aud.form.title_edit": "Edit audition",
    "aud.form.project": "Project name *",
    "aud.form.role": "Role",
    "aud.form.production_type": "Production type",
    "aud.form.production_ph": "e.g. feature film, series, commercial, theatre",
    "aud.form.cd": "Casting Director *",
    "aud.form.cd_choose": "Choose from contacts…",
    "aud.form.cd_hint": "An audition must be linked to an existing Casting Director contact.",
    "aud.form.cd_none": "You don't have any Casting Directors in your contacts yet.",
    "aud.form.cd_add": "Add a contact",
    "aud.form.source": "Casting source",
    "aud.form.source_ph": "e.g. Casting portal, agent, direct invitation",
    "aud.form.audition_type": "Audition type",
    "aud.form.status": "Status",
    "aud.form.notes": "Notes",
    "aud.form.notes_ph": "Context, director's expectations, tone…",
    "aud.form.feedback": "Feedback",
    "aud.form.feedback_ph": "Post-audition feedback.",
    "aud.form.save": "Save audition",
    "aud.form.saved": "Audition saved.",
    "aud.form.fail": "Could not save.",
    "aud.form.required": "Project and Casting Director are required.",
    "aud.form.no_cd_msg": "To add an audition, first add at least one Casting Director in the Contacts tab.",

    "aud.type.in_person": "In person",
    "aud.type.self_tape": "Self-tape",
    "aud.type.online_live": "Online / Live",
    "aud.type.callback_in_person": "Callback — In person",
    "aud.type.callback_online": "Callback — Online",
    "aud.type.chemistry_read": "Chemistry Read",
    "aud.type.screen_test": "Screen Test",
    "aud.type.final_audition": "Final Audition",
    "aud.type.other": "Other",

    "aud.status.new": "New",
    "aud.status.in_preparation": "In Preparation",
    "aud.status.sent": "Sent",
    "aud.status.callback": "Callback",
    "aud.status.booked": "Booked",
    "aud.status.not_booked": "Not Booked",

    // Stages
    "stage.title": "Audition stages",
    "stage.subtitle": "An audition can have multiple stages. The \"Next Date\" in the main table is pulled from this list.",
    "stage.add": "Add stage",
    "stage.edit": "Edit stage",
    "stage.empty": "No stages yet. Add the first one to schedule a date.",
    "stage.kind": "Stage type",
    "stage.date": "Date & time",
    "stage.deadline": "Submission deadline",
    "stage.place": "Place",
    "stage.address": "Address",
    "stage.studio": "Studio / room",
    "stage.link": "Link",
    "stage.platform": "Platform",
    "stage.instructions": "Instructions",
    "stage.notes": "Notes – Feedback",
    "stage.status": "Stage status",
    "stage.saved": "Stage saved.",
    "stage.save_fail": "Could not save the stage.",
    "stage.confirm_delete": "Delete this stage?",
    "stage.deleted": "Stage deleted.",

    // Scenes (audition)
    "asc.title": "Scenes to Prepare",
    "asc.add": "Add Another Scene",
    "asc.add_first": "Add first scene",
    "asc.empty": "No scenes added yet for this audition.",
    "asc.name": "Scene name",
    "asc.description": "Scene description",
    "asc.description_ph": "Context, who the character is, what the scene is about…",
    "asc.text": "Scene text",
    "asc.text_ph": "Paste the dialogue / scene description. It will be passed to Leo automatically.",
    "asc.file": "Scene file (PDF)",
    "asc.file_uploaded": "File uploaded:",
    "asc.status": "Scene status",
    "asc.status.to_prepare": "To Prepare",
    "asc.status.in_progress": "In Progress",
    "asc.status.ready": "Ready",
    "asc.saved": "Scene saved.",
    "asc.save_fail": "Could not save the scene.",
    "asc.confirm_delete": "Delete this scene?",
    "asc.deleted": "Scene deleted.",
    "asc.work_with_leo": "🤖 Work on the Scene with Leo",
    "asc.open_leo_scene": "Open in Leo",
    "asc.leo_linked": "Linked to Leo",

    // Activity
    "act.title": "Activity History",
    "act.empty": "No activity recorded.",
    "act.kind.created": "Audition created",
    "act.kind.status_changed": "Status changed",
    "act.kind.stage_added": "Stage added",
    "act.kind.scene_added": "Scene added",
    "act.kind.scene_status": "Scene status",
    "act.kind.feedback_added": "Feedback added",
    "act.kind.leo_started": "Leo session started",

    // Briefing
    "brief.title": "Audition Saved! 🎬",
    "brief.subtitle": "Before you start, here is what you should remember about this Casting Director:",
    "brief.prev": "Your previous auditions with {name}",
    "brief.first": "This is your first recorded audition with {name}. A clean slate. Leo will help you prepare the scene and approach it with intention.",
    "brief.cta_leo": "🤖 Go to Leo AI — Prepare Scene",
    "brief.cta_back": "Back to auditions",
    "brief.no_scenes": "Add at least one scene to open it in Leo.",

    // Follow-up reminder
    "fu.reminder": "Time for a follow-up with {name}.",

    // Detail page
    "aud.back": "Back to auditions",
    "aud.next_date_label": "Next date",
    "aud.next_date_none": "no scheduled dates",
    "aud.confirm_delete": "Delete this audition permanently?",
    "aud.deleted": "Audition deleted.",
    "aud.delete_fail": "Could not delete.",

    "aud.section.before": "BEFORE THE AUDITION",
    "aud.section.after": "AFTER THE AUDITION",
    "aud.pre.save": "Save Preparation",
    "aud.pre.q1": "Do I feel like I'm right for this role? Why?",
    "aud.pre.q2": "What's my gut feeling about how this audition will turn out?",
    "aud.pre.q3": "What's my challenge for this audition?",
    "aud.pre.q4": "What do I want to work on in this audition?",
    "aud.pre.q5": "What do I want to face or work through in this audition?",
    "aud.mm.start": "Start MASTERMIND",
    "aud.mm.view": "View Full MASTERMIND",
    "aud.mm.edit": "Edit MASTERMIND",

    "mm.title": "MASTERMIND: BOOKED IT / DIDN'T BOOK IT?",
    "mm.subtitle": "Handle It Like a Pro",
    "mm.description": "Whether you booked it or didn't, every audition is part of your journey.\nApproach it like a pro. Go back to the moment, look at what actually happened in the room or on tape, recognize what you did well, and notice what you want to do differently.\nTake the lessons with you, recognize your behavior patterns, name your challenges, and decide what you want to work on in your next audition.\nDon't judge the quality of your work by the outcome alone.",

    "mm.select.title": "Choose the audition you want to review",
    "mm.select.add_new": "+ Add New Audition",

    "mm.step1.title": "Pause",
    "mm.step1.body": "Don't analyze the outcome yet. First, go back to what was happening with you during the audition.",
    "mm.step1.question": "What are you feeling right now when you think about this audition?",

    "mm.step2.title": "Go Back to the Room or Your Self-Tape",
    "mm.step2.body": "Sit comfortably. If you'd like, close your eyes.\nGive yourself a moment and return in your mind to the audition room or to the moment you recorded your self-tape.\nDon't try to figure out why you did or didn't book the role.\nJust notice yourself in that moment.\nWhat was happening in your body?\nWhat were you feeling?\nWhat were you thinking about?\nWhere was your attention?\nImagine that you could stand beside the version of yourself who was there.\nYou don't need to fix anything.\nYou don't need to prove anything.\nYou can put a hand on your shoulder, give yourself a hug, or simply stay there with yourself for a moment.\nObserve yourself without judgment.",
    "mm.step2.question": "What did you notice?",

    "mm.step3.title": "Watch Your Self-Tape, If You Have It",
    "mm.step3.body": "If you have the recording, watch it again — like an athlete reviewing game footage.\nNot to criticize yourself.\nTo gather information.\nFirst, watch the whole tape without stopping or taking notes.\nThen watch it again and pay attention to your work.",
    "mm.step3.q1": "How did I remember or experience this audition?",
    "mm.step3.q2": "What do I see now when I watch the tape?",
    "mm.step3.q3": "What surprised me?",
    "mm.step3.skip": "Skip — I don't have a recording",

    "mm.step4.title": "What Did I Do Well?",
    "mm.step4.support": "Name at least two specific things you did that you want to keep.",

    "mm.step5.title": "What Do I Want to Do Differently?",
    "mm.step5.question": "What didn't work the way you wanted it to? What would you like to do differently next time?",

    "mm.step6.title": "What Did This Audition Teach Me?",
    "mm.step6.support": "You don't have to force a lesson out of every audition. Sometimes the honest conclusion is:\n\u201CI was prepared. I did the work I wanted to do. I didn't book the role. There's nothing here I need to fix.\u201D",

    "mm.step7.title": "Behavior Pattern",
    "mm.step7.explanation": "A behavior pattern is a way you tend to respond in similar situations or under pressure.\nOne audition doesn't necessarily make it a pattern.",
    "mm.step7.example1": "\u201CWhen I really want the role, I start trying to impress people instead of staying in the scene.\u201D",
    "mm.step7.example2": "\u201CUnder pressure, I start monitoring myself.\u201D",
    "mm.step7.example3": "\u201CI try to guess what the director wants instead of trusting my own interpretation.\u201D",
    "mm.step7.example4": "\u201CWhen I get nervous, I stop really listening to my scene partner.\u201D",
    "mm.step7.q1": "Do you recognize a behavior pattern in yourself? If so, what is it?",
    "mm.step7.q2": "Have you noticed this pattern in previous auditions or other acting situations?",

    "mm.step8.title": "My Challenge",
    "mm.step8.question": "What's my biggest challenge right now?",

    "mm.step9.title": "The Next Audition",
    "mm.step9.question": "What do I want to work on in my next audition?",
    "mm.step9.support": "Your next audition doesn't have to be only another chance to book a role.\nIt can also be another rep — another chance to practice something you're consciously working on.",
    "mm.step9.empty_pre_casting": "You didn't fill out the BEFORE THE AUDITION section for this project. Remember to do it next time so you can compare your expectations with what actually happened.",

    "mm.step10.title": "Close the Audition",
    "mm.step10.question": "What are you leaving behind with this audition?",
    "mm.step10.close_btn": "CLOSE THE AUDITION",

    "mm.final.line1": "This audition is complete.",
    "mm.final.line2": "You know what you did well.",
    "mm.final.line3": "You know what you learned.",
    "mm.final.line4": "You know what your challenge is.",
    "mm.final.line5": "You know what you want to work on next time.",
    "mm.final.next": "NEXT.",

    "mm.summary.did_well": "What I Did Well",
    "mm.summary.differently": "What I Want to Do Differently",
    "mm.summary.learned": "What I Learned",
    "mm.summary.pattern": "Behavior Pattern",
    "mm.summary.challenge": "My Challenge",
    "mm.summary.next": "What I Want to Work On in My Next Audition",
    "mm.summary.leaving": "What I'm Leaving Behind",
    "mm.summary.view_full": "View Full MASTERMIND",
    "mm.summary.edit_full": "Edit MASTERMIND",

    "mm.nav.next": "Next",
    "mm.nav.back": "Back",
    "mm.nav.save": "Save",
    "mm.nav.cancel": "Cancel",

    // ===== CAREER PATH =====
    "path.dash_tile_eyebrow": "Career Path",
    "path.dash_tile_title": "Goals & Tasks",
    "path.dash_tile_body": "Pick one important goal, see one simple next step, take it. No overwhelm — just quiet agency.",
    "path.open": "Open Career Path",

    "tasks.dash_tile_eyebrow": "Operational Tasks",
    "tasks.dash_tile_title": "Day-to-day tasks",
    "tasks.dash_tile_body": "Follow-ups, self-tapes, materials, networking. One place for everything you have to do right now.",
    "tasks.open": "Open tasks",

    "path.title": "Career Path",
    "path.subtitle": "Goals & Tasks",
    "path.pick_ops": "Operational Tasks",
    "path.pick_ops_body": "e.g. follow-up with a casting director after sending a self-tape.",
    "path.pick_plan": "Career plan",
    "path.pick_plan_body": "How do you want to grow your career?",
    "actor_profile.tile_title": "My Actor Profile",
    "actor_profile.tile_body": "Define who you are as an actor, the roles others see you in, the roles you want to play, and the values you want to bring to your work.",
    "actor_profile.section_identity": "IDENTITY",
    "actor_profile.section_identity_sub": "Who am I as an actor?",
    "actor_profile.section_direction": "DIRECTION",
    "actor_profile.section_direction_sub": "Where am I going?",
    "actor_profile.section_work_standard": "WORK STANDARD",
    "actor_profile.section_work_standard_sub": "How do I want to work?",
    "actor_profile.section_alignment": "ALIGNMENT",
    "actor_profile.section_alignment_sub": "Does what I'm doing actually align with this?",
    "actor_profile.alignment_hint": "Come back to this from time to time. What in your career currently aligns with who you are, where you want to go, and how you want to work? Where do you notice a disconnect?",
    "actor_profile.q_identity_1": "What do you value most about yourself as an actor?",
    "actor_profile.q_identity_2": "What comes naturally to you as an actor? What feels truthful without having to push or manufacture it?",
    "actor_profile.q_identity_3": "What kinds of roles or characters do you feel especially at home playing?",
    "actor_profile.q_identity_4": "What feels distinctive about your presence on screen or on stage?",
    "actor_profile.q_identity_5": "What do you hear most often about yourself from directors, casting directors, reps, teachers, or fellow actors?",
    "actor_profile.q_identity_6": "What kinds of roles do you tend to get called in for? What have you played so far? Do you notice any patterns?",
    "actor_profile.q_identity_7": "What else sets you apart? Think about your voice, look, energy, presence, languages, accents, skills, life experience, or anything valuable that wouldn't necessarily show up in a headshot.",
    "actor_profile.q_direction_1": "What matters to you right now? For example: What do you long for? What are you missing? What moves you, hurts, fascinates you, or keeps coming back to you? What are you going through or trying to understand right now?",
    "actor_profile.q_direction_2": "What kinds of characters are you most drawn to?",
    "actor_profile.q_direction_3": "What kinds of stories do you want to be part of?",
    "actor_profile.q_direction_4": "What do you want more of in your career — film, television, theater, or something else?",
    "actor_profile.q_direction_5": "Are there specific films, shows, plays, or roles that make you think, \"That's the kind of work I want to be doing\"?",
    "actor_profile.q_direction_6": "Which directors or other creators would you love to work with?",
    "actor_profile.q_direction_7": "What would you love to explore even if the industry doesn't see you that way yet?",
    "actor_profile.q_direction_8": "What would you like to be known for as an actor?",
    "actor_profile.q_work_1": "When you walk onto a set or into a theater, what are you there to do — beyond simply doing a good job?",
    "actor_profile.q_work_2": "What does doing good work actually mean to you?",
    "actor_profile.q_work_3": "How will you know you had a good day at work even if no one praises your performance?",
    "actor_profile.q_work_4": "How do you want to treat your scene partners and the crew?",
    "actor_profile.q_work_5": "How do you want people to feel when they work with you?",
    "actor_profile.q_work_6": "How do you want to be treated by the people you work with?",
    "actor_profile.q_work_7": "What do you need to bring to the table to help create those kinds of relationships and that kind of working environment?",
    "actor_profile.q_work_8": "What kind of actor do you want to be when you're under pressure, tired, stressed, or things aren't going your way?",
    "actor_profile.q_work_9": "How do you want people to remember working with you?",
    "actor_profile.answer_ph": "Your answer…",
    "actor_profile.btn_back": "Back",
    "actor_profile.btn_next": "Next",
    "actor_profile.btn_generate": "Create my profile",
    "actor_profile.btn_edit": "Edit",
    "actor_profile.btn_save": "Save",
    "actor_profile.btn_cancel": "Cancel",
    "actor_profile.creators_title": "Creators worth knowing",
    "actor_profile.creators_intro": "Learn their work, find the right professional contacts yourself, add the important people to LEO CRM, and build the relationships consciously.",
    "actor_profile.creators_empty": "Not enough basis yet for specific names. Fill in Direction and regenerate the profile.",
    "actor_profile.generating": "Creating your profile…",
    "actor_profile.generating_slow": "This is taking longer than usual…",
    "actor_profile.btn_cancel_generation": "Cancel / Try again",
    "actor_profile.gen_error": "Couldn't create the profile. Please try again.",
    "actor_profile.save_error": "Couldn't save. Please try again.",
    "actor_profile.load_error": "Couldn't load the profile.",
    "actor_profile.empty_body": "Fill in the 3-section workbook. Answers can be blank — LEO synthesises the profile from what you write.",
    "actor_profile.wizard_progress": "Section {n} of 3",
    "actor_profile.paywall_title": "Unlock your full Actor Profile",
    "actor_profile.paywall_subtitle": "Complete your profile, define your direction and work standard, and see LEO's analysis. The full Actor Profile is available with LEO START, LEO MONTHLY, and LEO ANNUAL.",
    "actor_profile.btn_edit_answers": "EDIT MY ANSWERS",
    "actor_profile.btn_update": "UPDATE MY PROFILE",
    "actor_profile.btn_cancel_editing": "CANCEL EDITING",
    "actor_profile.north_star_line1": "You know your North Star.",
    "actor_profile.north_star_line2": "Now build your career path.",
    "actor_profile.go_to_paths": "GO TO CAREER PATHS",
    "actor_profile.next_step_title": "YOUR NEXT STEP",
    "actor_profile.create_this_path": "CREATE THIS PATH",
    "actor_profile.enter_own_path": "ENTER YOUR OWN PATH",
    "actor_profile.path_name_uk_agent": "Find a UK agent",
    "actor_profile.path_name_get_more_auditions": "Get more auditions in the UK",
    "actor_profile.path_name_more_castings_pl": "Get more auditions on the Polish market",
    "actor_profile.path_name_casting_directors_pl": "Build a base of Polish casting directors",
    "path.uk_agent_eyebrow": "Ready-made path",
    "path.uk_agent_title": "Find an Agent in the UK",
    "path.uk_agent_body": "A 10-step path: profile, package, agency list, outreach, follow-up, meeting and signing.",
    "path.uk_agent_locked_note": "Available with LEO START, MONTHLY and ANNUAL",
    "path.gma_eyebrow": "Ready-made path",
    "path.gma_title": "Get More Auditions in the UK",
    "path.gma_body": "A 10-step path: audit your casting funnel, castability, Spotlight, submissions, agent talk and a 30-day review.",
    "path.paid_lock_badge": "LEO START / MONTHLY / ANNUAL",
    "path.paid_locked_note": "Available with LEO START, MONTHLY and ANNUAL",

    "plan.top_note": "Create a supportive atmosphere for planning: put on some calm music, light a candle, take one deep breath.",
    "plan.intro": "Big goals can feel overwhelming, but breaking them into small, concrete steps helps you see them realistically. Instead of trying to do everything at once, focus on the two most important actions for this week — that's how a distant, huge goal turns into a series of small, doable moves. Which goals matter most to you today and could become the next milestones in your career?",
    "plan.add_goal": "Add a new goal",
    "plan.suggestions_title": "Leo's suggestions",
    "plan.custom_goal": "Write your own goal",
    "plan.custom_goal_ph": "e.g. Build a casting director network in London",
    "plan.next": "Next",

    "goal.q1": "How do I recognize I'm achieving this goal?",
    "goal.q1_hint": "What specifically is happening in your career? How do you see this result becoming reality?",
    "goal.q2": "What becomes possible when I reach it? Why do I want this?",
    "goal.q3": "By when do I want to achieve it?",
    "goal.q4": "How many hours per week can I devote to it?",
    "goal.q_creating": "What am I creating?",
    "goal.q_creating_hint": "Describe the result you are creating in your career — not the first step or task.",
    "goal.q_possibilities": "What becomes possible when I achieve this goal?",
    "goal.q_possibilities_hint": "Think about the new opportunities that reaching this result opens up for you.",
    "goal.q_have": "What do I already have that helps me achieve this?",
    "goal.q_have_hint": "Think about the experience, skills, materials, contacts, representation, languages, knowledge and other resources already working in your favour.",
    "goal.q_missing": "What am I still missing to achieve this?",
    "goal.q_missing_hint": "What do you need to learn, acquire, improve or build?",
    "goal.q_stops": "What holds me back the most from acting today?",
    "goal.q_stops_hint": "Think about what truly stops you: fear of rejection, lack of a plan, procrastination, no time, uncertainty, or something else.",
    "goal.q_lose": "What do I lose if nothing changes?",
    "goal.q_lose_hint": "Think about the cost of staying exactly where you are.",
    "goal.q4_hint": "Leo will use this so he never plans more than you can realistically carry.",
    "goal.q5": "How does achieving this goal and its effects impact other areas of my life?",
    "goal.q5_hint": "Think not only about career, but also finances, relationships, where you live, safety, freedom or satisfaction.",
    "goal.why_title": "Why I'm doing this",
    "goal.why_more_title": "All workbook answers",
    "goal.why_hint": "Your remaining Mini workbook answers.",
    "goal.why_empty": "No answers saved.",
    "goal.why_q4_unit": "hrs/week",
    "goal.q_answer_ph": "Write freely — in your own words.",
    "goal.save": "Save goal",
    "goal.saving": "Saving…",
    "goal.saved": "Goal saved.",
    "goal.save_fail": "Could not save the goal.",

    "planpath.title": "How would you like to build the plan?",
    "planpath.own": "I'll plan it myself",
    "planpath.leo": "Ask Leo for help",

    "step.list_title": "All steps",
    "step.next_hero": "Your next step",
    "step.add": "+ Add step",
    "step.name_ph": "e.g. Reach out to 3 agents",
    "step.time_min": "min",
    "step.time_est": "est. time",
    "step.due": "due",
    "step.mark_done": "Done",
    "step.mark_undone": "Undo",
    "step.delete": "Delete step",
    "step.confirm_delete": "Delete this step?",
    "step.saved": "Step saved.",
    "step.save_fail": "Could not save the step.",
    "step.done": "Done",
    "step.progress": "Goal progress",
    "step.leo_generate": "Ask Leo for a plan",
    "step.leo_generating": "Leo is planning…",
    "step.reward_title": "Monthly reward",
    "step.reward_ph": "How do you want to celebrate keeping the promise you made to yourself?",
    "step.reward_save": "Save reward",
    "step.reward_saved": "Reward saved.",
    "step.leo_ask_hours_title": "How many hours per week can you realistically devote to this goal?",
    "step.leo_ask_hours_ph": "e.g. 3",
    "step.leo_ask_hours_unit": "hours/week",
    "step.leo_confirm": "Generate plan with Leo",
    "step.leo_update": "Ask Leo to update the plan",
    "step.leo_generating_wait": "Leo is planning… this may take 10–20 seconds.",
    "step.leo_banner": "Plan prepared by Leo \u2726",
    "step.leo_banner_n_one": "Leo broke this goal into 1 step, based on your available time.",
    "step.leo_banner_n_few": "Leo broke this goal into {n} steps, based on your available time.",
    "step.leo_banner_n_many": "Leo broke this goal into {n} steps, based on your available time.",
    "step.leo_fail": "Leo couldn't generate a plan right now. Please try again.",
    "step.postpone.title": "Postpone step",
    "step.edit.title": "Edit step",

    "goal.no_next_step": "All steps completed. Congratulations!",
    "goal.no_steps_yet_title": "You don't have any steps yet.",
    "goal.no_steps_yet_body": "Set the stages of this goal yourself, or ask Leo to lay them out with a realistic schedule.",
    "goal.plan_myself": "I'll plan it myself",
    "goal.plan_leo": "Ask Leo for help",
    "goal.delete": "Delete goal",
    "goal.confirm_delete": "Delete this goal and all its steps?",
    "goal.deleted": "Goal deleted.",
    "goal.back": "Back to plan",
    "goal.no_goals": "No goals yet. Add your first one.",

    "review.title": "Weekly review",
    "review.subtitle": "A short, calm summary.",
    "review.done_n": "{n} tasks completed",
    "review.in_progress_n": "{n} in progress",
    "review.postponed_n": "{n} postponed",
    "review.next": "Next step:",
    "review.q": "Anything you'd like to change in next week's plan?",

    // ===== OPERATIONAL TASKS =====
    "ops.title": "Operational Tasks",
    "ops.subtitle": "The everyday things — follow-ups, self-tapes, materials, networking.",
    "ops.new": "+ New task",
    "ops.empty": "No tasks yet. Add your first one.",
    "ops.form.title_new": "New task",
    "ops.form.title_edit": "Edit task",
    "ops.form.name": "Task title *",
    "ops.form.name_ph": "e.g. Follow up with Martha Carter",
    "ops.form.category": "Category",
    "ops.form.due": "Due date",
    "ops.form.contact": "Linked contact",
    "ops.form.contact_none": "— no link —",
    "ops.form.notes": "Notes",
    "ops.form.save": "Save task",
    "ops.form.saved": "Task saved.",
    "ops.form.fail": "Could not save.",

    "ops.cat.contact": "Contact",
    "ops.cat.followup": "Follow-up",
    "ops.cat.selftape": "Self-tape",
    "ops.cat.materials": "Materials",
    "ops.cat.networking": "Networking",
    "ops.cat.research": "Research",
    "ops.cat.meeting": "Meeting",
    "ops.cat.other": "Other",

    "ops.status.todo": "To do",
    "ops.status.in_progress": "In progress",
    "ops.status.done": "Done",
    "ops.status.postponed": "Postponed",

    "ops.action.complete": "✓ Complete task",
    "ops.action.postpone": "Postpone",
    "ops.action.delete": "Delete task",
    "ops.action.edit": "Edit",
    "ops.confirm_delete": "Delete this task?",
    "ops.deleted": "Task deleted.",

    "ops.postpone.title": "Postpone task",
    "ops.postpone.q": "When do you realistically want to take care of this?",
    "ops.postpone.still_important": "Is this task still important for the goal?",
    "ops.postpone.remove": "Remove task from the plan",
    "ops.postpone.save": "Postpone",
    "ops.postpone.saved": "Task postponed.",
    "ops.postpone.repeated_note": "I see you've postponed this task a few times. Do you want to break it into a smaller step, move the date, or decide it's no longer important?",

    "ops.complete.title": "Task completed",
    "ops.complete.contact_line": "Contact with: {name}",
    "ops.complete.last_set": "Last contact will be set to: {date}",
    "ops.complete.next_q": "When do you want to reach out again?",
    "ops.complete.save": "Save",
    "ops.complete.no_next": "No further contact planned",
    "ops.complete.no_next_q": "Why aren't you planning another contact?",
    "ops.complete.saved": "Task completed and CRM updated.",
    "ops.complete.simple": "Task completed.",

    // Dashboard summary cards (Command Center)
    "cc.goal_title": "Your current goal",
    "cc.no_active_goal": "No active goal yet.",
    "cc.no_active_goal_cta": "Add a goal in Career Path.",
    "cc.next_step_label": "Your next step:",
    "cc.open": "Open",
    "cc.tasks_title": "Operational Tasks",
    "cc.next_task_label": "Your nearest due:",
    "cc.no_open_tasks": "No open tasks.",
    "cc.tasks_pending_one": "1 task pending",
    "cc.tasks_pending_n": "{n} tasks pending",
    "cc.tasks_pending_many": "{n} tasks pending",
    "cc.see_all": "See all",
    "cc.command_center": "Your command center",

    // Task sections + LED dots
    "ops.sec.today": "Follow-up today / Overdue",
    "ops.sec.upcoming": "Upcoming (7 days)",
    "ops.sec.later": "Later",
    "ops.sec.done": "Done",
    "ops.sec.empty": "—",

    // Gentle Reminders
    "gr.title": "Gentle reminders",
    "gr.tagline": "Start your day with one concrete step.",
    "gr.status_on": "Enabled",
    "gr.status_off": "Disabled",
    "gr.explainer": "Each week we'll pick your single most important next step and gently remind you in the morning.",
    "gr.disable": "Turn off reminders",
    "gr.enable": "Turn on again",
    "gr.preview_title": "Tomorrow morning you'll receive:",
    "gr.preview_next_step": "🎬 Your next step",
    "gr.preview_why": "Why this one?",
    "gr.preview_your_goal": "Your goal:",
    "gr.preview_your_why": "Why you want it:",
    "gr.no_active_prev": "No active goal with an open step — the morning email won't be sent until you add a step to a goal.",
    "gr.why_pick.first_step": "It's the first open step leading to your goal \"{goal}\".",
    "gr.why_pick.overdue": "This step is overdue — good to get it off your plate.",
    "gr.why_pick.due_today": "This step is scheduled for today.",
    "gr.why_pick.next_after": "It's the next step after the ones you've already done.",
    "gr.gentle_note": "You don't have to finish your whole career today. Just take one step.",
    "gr.toast_on": "Gentle reminders turned on.",
    "gr.toast_off": "Gentle reminders turned off.",
  },

  ja: {
    "nav.scenes": "シーン／セルフテープ",
    "nav.plans": "プラン",
    "nav.logout": "ログアウト",
    "nav.language": "言語",
    "action.cancel": "キャンセル",
    "action.save": "保存",
    "action.close": "閉じる",
    "action.change": "変更",
    "nav.to_mirror": "ミラーリングへ",
    "nav.to_map": "感情マップへ",
    "nav.to_zapalnik": "トリガーへ",
    "nav.to_eight": "8つの質問へ",
    "nav.to_vagus": "迷走神経エクササイズへ",
    "nav.to_rehearsal": "リハーサル／セルフテープを始める",
    "nav.to_reflection": "LEOの振り返りへ",
    "nav.save_notes": "メモを保存",
    "splash.eyebrow": "LEO — 俳優のためのキャリアシステム",
    "splash.title1": "LEO — シーン",
    "splash.title2": "準備完了。",
    "splash.tagline": "表現するのは、あなた。LEOはその準備を支えます。",
    "splash.body": "演技の真実に近づくためのパートナー。シーンをアップロードすると、LEOが「目的」「障害」「サブテキスト」を深く読み解きます。ミラーリングではテキストと自分の想像力を結び、リハーサルでは実際に演じながら準備を整えます。キャスティングでも現場でも、自分の選択を持って入れるように。LEOは準備を支え、表現するのはあなたです。",
    "splash.enter": "スタジオへ",
    "splash.start": "始める",
    "splash.login": "ログイン",
    "splash.pricing": "プランを見る",
    "splash.voices": "リハーサルルームから届いた声",
    "dash.rehearsal_room": "リハーサル／セルフテープ・ルーム",
    "dash.welcome": "ようこそ",
    "dash.subtitle": "アーカイブからシーンを選ぶか、新しいシーンをアップロードしてください。テキストでもPDFでもOKです。LEOが待っています。",
    "dash.manifesto_headline": "次のオーディションを待つだけじゃない。\\n自分のキャリアをつくっていく。",
    "dash.manifesto_body": "LEOは俳優のキャリアを一か所で動かすためのシステムです。次の一歩を計画し、新しい機会を見つけ、業界の人との関係を育て、オーディションやミーティングを管理し、役やシーンの準備まで進められます。",
    "dash.manifesto_imagine": "今日始めたら、1年後の自分はどこにいるでしょう。",
    "dash.manifesto_cta": "最高の旅にしていきましょう。",
    "splash.point1_title": "人とのつながりを育てる",
    "splash.point1_body": "エージェント、監督、キャスティングディレクターなど、業界の大切な人とのつながりを整理。やり取りの履歴、メモ、次のフォローアップまで管理できます。",
    "splash.point2_title": "キャリアを設計する",
    "splash.point2_body": "用意されたキャリアパスを選ぶか、自分の目標を設定。毎週動ける具体的なアクションと小さなステップに変えていきます。",
    "splash.point3_title": "オーディションと役に備える",
    "splash.point3_body": "シーンを分析し、解釈を深め、セリフを覚え、オーディション、セルフテープ、撮影日に向けて準備できます。",
    "splash.tagline_below_points": "全部を一か所に。キャリアで何かが起きるのを待つのではなく、自分から動かしていくために。",
    "splash.credibility_line": "国際作品で活動する現役俳優が開発",
    "dash.q_today": "今日、自分のキャリアのために何をしますか？",
    "dash.body": "シーンを準備する。キャスティングディレクターや業界の人との関係を育てる。あるいは、キャリアの次の一歩を進める。",
    "dash.q_start": "今日はどこから始めますか？",
    "dash.new_scene": "新しいシーン",
    "dash.tile.upload.title": "シーン／セルフテープを準備する",
    "dash.tile.upload.subtitle": "シーンをじっくり分析することも、AIリーダーですぐにリハーサルやセルフテープの準備を始めることもできます。",
    "dash.tile.upload.cta": "シーンをアップロード",
    "dash.free_first_title": "最初の1シーンは無料",
    "dash.free_first_body": "LEOで最初のシーンを準備しましょう。無料で使えます。",
    "dash.your_scenes": "あなたのシーン",
    "dash.loading": "アーカイブを読み込み中…",
    "dash.empty_title": "まだ幕は上がっていません。",
    "dash.empty_body": "最初のシーンをアップロードして始めましょう。",
    "dash.upload_first": "最初のシーンをアップロード",
    "dash.scene_analyzed": "分析済み",
    "dash.scene_pending": "未分析",
    "dash.confirm_delete": "このシーンを完全に削除しますか？",
    "dash.deleted": "シーンを削除しました。",
    "dash.delete_failed": "削除できませんでした。",
    "new.eyebrow": "ステップ1・シーンをアップロード",
    "new.title": "新しいシーン",
    "new.subtitle": "テキストを貼り付けるかPDFを追加してください。作品の概要と、自分が演じる役も入力します。",
    "new.scene_title": "シーン／作品タイトル",
    "new.scene_title_ph": "例：「Winter War」— シーン14",
    "new.my_character": "自分の役",
    "new.my_character_ph": "例：Martha、34歳、母親",
    "new.brief": "作品メモ（監督、世界観、ジャンル）",
    "new.brief_ph": "例：監督は繊細なトーンを求めている。舞台は1985年の寒い冬。役には幼少期の秘密がある。",
    "new.scene_text_label": "シーン本文",
    "new.upload_pdf": "ファイルをアップロード",
    "new.upload_formats": "PDF, JPG, PNG",
    "new.reading": "読み込み中…",
    "new.chars": "文字",
    "new.save_run": "保存してLEOを開始",
    "new.save_go_rehearsal": "保存してリハーサル／セルフテープへ",
    "new.scene_language": "シーンの言語",
    "new.saving": "保存中…",
    "new.short_text": "シーン本文が短すぎます。",
    "new.pdf_ok": "PDFからテキストを読み込みました。",
    "new.pdf_fail": "PDFを読み込めませんでした。",
    "new.saved": "シーンを保存しました。LEOが分析を始めます…",
    "new.paywall_msg": "無料シーンを使い切りました。プランを選んでください。",
    "new.save_fail": "シーンを保存できませんでした。",
    "scene.back": "戻る",
    "scene.eyebrow": "シーン・ワークスタジオ",
    "scene.your_character": "あなたの役",
    "scene.export_pdf": "PDFを書き出す",
    "mir.privacy_title": "ここに入力した内容は安全に扱われます",
    "mir.privacy_body": "入力内容は暗号化されます。LEOが扱うのは想像力、アーキタイプ、そしてシーンの世界だけです。実在の人物や個人的な記憶を入力する必要はありません。想像上の相手、架空の人物、あるいは「上司」「ライバル」「メンター」のようなラベルを使ってください。",
    "mir.craft_care_title": "Craft & Care — どうやって意図を立ち上げる？",
    "mir.craft_care_body": "演技は想像力の仕事です。役の目的を最も強く動かし、自分の中に「行動したい」という衝動が生まれる条件を想像してみてください。目を閉じ、このシーンで役が何を求めているのかを考えます。そして、その闘いが最も意味を持つ相手を心の中に立ち上げます。身体のエネルギー、動きたい感覚、内側から出てくる力に注意を向けてください。その衝動を感じたら、イメージに具体的な形を与えます。そうすることで、LEOはこのリハーサルであなたにとって意味のある相手役になれます。",
    "mir.eyebrow": "インタビュー・相手役",
    "mir.q1_title": "ラベル／名前",
    "mir.q1_body": "頭の中に浮かぶ相手に名前をつけてください。脚本の人物名でも、アーキタイプでも、架空の人物でも、このエネルギーを表す単純なラベルでも構いません（例：上司、ライバル、メンター、Alex、人物X）。",
    "mir.q1_ph": "例：上司、ライバル、メンター、Alex、人物X",
    "mir.q2_label": "シーンの場所",
    "mir.q2_title": "脚本上、このシーンは実際にどこで起きていますか？",
    "mir.q2_body": "脚本に書かれた具体的な場所（例：オフィス、カフェ、車内）を想像してください。身体がその状況を信じられるように、空間に具体的な感覚を与えます。\\n\\n• 温度は？（例：冷房の冷たい風、蒸し暑く重い空気）\\n• どんな匂いがする？（例：淹れたてのコーヒー、革のシート、雨の匂い）\\n• 背景にはどんな音がある？（例：街のざわめき、時計の音、静けさ）",
    "mir.q2_ph": "例：監督のオフィス。冷房の冷たい風、コーヒーの匂い、背景で時計が鳴っている。",
    "mir.notes": "追加メモ",
    "mir.notes_ph": "（任意）ほかに、このシーンへ持ち込みたいものは？",
    "mir.save": "ミラーリングを保存",
    "mir.saving": "保存中…",
    "mir.saved": "ミラーリングを保存しました。LEOはこの相手役として応答します。",
    "mir.fail": "保存できませんでした。",
    "reflect.tab": "LEOの振り返り",
    "reflect.title": "リハーサル後のLEOの振り返り",
    "reflect.subtitle": "演じたあと、少しだけ着地する時間です。LEOの質問に答え、同じシーンを3つの別アプローチで見てみましょう。",
    "reflect.q1": "リハーサルを終えて、どんな感覚が残っていますか？",
    "reflect.q2": "演じている間、何を感じていましたか？",
    "reflect.q3": "役の動機を身体で感じられましたか？",
    "reflect.q4": "自分でも意外だったことは何ですか？",
    "reflect.answer_ph": "自由に書いてください…",
    "reflect.gen": "LEOに3つの別案を出してもらう",
    "reflect.regen": "もう一度生成",
    "reflect.generating": "LEOが別のアプローチを考えています…",
    "reflect.variants_title": "同じシーンを3つのアプローチで",
    "reflect.variants_hint": "変わるのはシーン内部の選択（エネルギー、意図、関係性、テンポ、行動の仕方）です。物語そのものは変わりません。",
    "reflect.saved_to_notes": "振り返りをノートに保存しました。",
    "reflect.no_variants_yet": "上のボタンを押すと、LEOが3つの演技アプローチを提案します。",
    "reflect.focus.energy": "エネルギー",
    "reflect.focus.intention": "意図",
    "reflect.focus.relationship": "関係性",
    "reflect.focus.tempo": "テンポ",
    "reflect.focus.mode": "行動の仕方",
    "reflect.rehearse_again": "もう一度リハーサルする",
    "reflect.go_grounding": "グラウンディングへ",
    "reh.need_mirror_title": "まずミラーリングを行ってください。",
    "reh.need_mirror_body": "相手役インタビューを入力すると、LEOがあなたの相手役として動けるようになります。",
    "reh.script": "シーン本文",
    "reh.readonly": "閲覧のみ",
    "reh.title": "LEOとリハーサル／セルフテープ",
    "reh.subtitle": "評価しない。ただ、真実を探す。",
    "reh.reset": "リセット",
    "reh.confirm_reset": "リハーサルを最初からやり直しますか？",
    "reh.reset_fail": "リセットできませんでした。",
    "reh.you": "あなた",
    "reh.leo": "相手役",
    "reh.my_line": "自分のセリフ",
    "reh.send_fail": "リハーサルを続行できませんでした。",
    "reh.parse_cta": "リハーサルを始める",
    "reh.parse_hint": "まずLEOがシーンを読み取り、登場人物、セリフ、誰から始まるかを整理します。その後は流れに沿ってリハーサルできます。あなたは自分のセリフを言い、「自分のセリフ」を押すだけです。",
    "reh.parsing": "シーンを読み取っています…",
    "reh.parse_fail": "シーンを解析できませんでした。",
    "reh.your_turn": "あなたの番です。セリフを言ったら、次を押してください：",
    "reh.your_turn_first": "あなたから始まります。セリフを言ったら、次を押してください：",
    "reh.you_speaking": "あなた（自分の役）",
    "reh.done_title": "シーン終了。",
    "reh.done_body": "グラウンディングへ進むか、リセットしてもう一度演じられます。",
    "reh.reparse": "シーンを再解析",
    "reh.starts_actor": "あなたの役からシーンが始まります。",
    "reh.starts_other": "相手役からシーンが始まります。",
    "reh.progress": "セリフ",
    "reh.waiting": "相手役が話しています…",
    "reh.full_scene": "シーン全文",
    "reh.full_scene_hint": "シーン全文です。現在位置がハイライトされています。",
    "reh.close": "閉じる",
    "reh.current_marker": "現在位置",
    "reh.no_script_yet": "シーンを解析するとセリフがハイライト表示されます。下には元のテキストを表示しています。",
    "reh.ai_reader_title": "AIリーダー（ハンズフリー）",
    "reh.ai_reader_hint": "LEOはあなたのセリフの終わりを認識すると相手役のセリフを返します。最後の言葉は変えないでください。途中は自分らしく演じて構いませんが、語尾は台本どおりに言ってください。",
    "reh.ai_reader_prepping": "音声を準備中…",
    "reh.ai_reader_ready": "音声準備完了 ✓",
    "reh.ai_reader_scene_done": "シーン終了",
    "reh.ai_reader_voice": "声",
    "goal.dialog_title": "シーンの目的を変更",
    "goal.dialog_desc": "ニーズ・コーデックスから別のニーズを選ぶか、自分自身の目的を入力してください。選んだ目的に合わせてLEOが分析を書き直します。",
    "goal.search_ph": "ポーランド語または英語で検索…",
    "goal.confirm": "新しい目的を保存",
    "goal.saved": "目標を保存しました。",
    "goal.regenerating": "LEOが分析を書き直しています…",
    "goal.fail": "目的を変更できませんでした。",
    "goal.selected": "選択中",
    "goal.custom_toggle": "自分で目的を書く",
    "goal.leo_toggle": "LEOに目的を提案してもらう",
    "goal.leo_intro": "LEOがこのシーンから演じられる「目的」を提案します。そのまま使う、編集する、別案を出してもらう、却下して自分で書く、のどれでも選べます。",
    "goal.leo_thinking": "LEOがシーンを読んでいます…",
    "goal.leo_ask": "LEOに目的を提案してもらう",
    "goal.leo_again": "別の案を見る",
    "goal.leo_accept": "この目的を使う",
    "goal.leo_reject": "この案を使わず自分で書く",
    "goal.leo_fail": "今はLEOが目的を提案できませんでした。",
    "goal.leo_reason": "この目的を提案した理由：",
    "goal.custom_ph": "例：「あなたをその嘘から目覚めさせたい」",
    "goal.custom_hint": "自分で書く目的はコーデックスの外でも構いません。LEOは評価せず、その目的に合わせて障害と俳優の課題を書き直します。",
    "goal.save_to_library": "この目的を自分のライブラリに保存",
    "goal.save_to_library_hint": "保存すると、どのシーンからでも自分の目的として使えます。",
    "path.dash_tile_eyebrow": "キャリアパス",
    "path.dash_tile_title": "目標とタスク",
    "path.dash_tile_body": "今いちばん大切な目標をひとつ決め、次の一歩を明確にして動く。焦らず、自分のペースで進めます。",
    "path.open": "キャリアパスを開く",
    "tasks.dash_tile_eyebrow": "実務タスク",
    "tasks.dash_tile_title": "日々のタスク",
    "path.title": "キャリアパス",
    "path.subtitle": "目標とタスク",
    "path.pick_ops": "実務タスク",
    "path.pick_ops_body": "例：セルフテープ送付後、キャスティングディレクターにフォローアップする。",
    "path.pick_plan": "キャリアプラン",
    "path.pick_plan_body": "これから、どんなキャリアを築いていきたいですか？",
    "path.uk_agent_eyebrow": "用意されたキャリアパス",
    "path.uk_agent_title": "英国でエージェントを探す",
    "path.uk_agent_body": "10ステップで進めます：プロフィール、応募資料、エージェンシー候補、アプローチ、フォローアップ、面談、契約。",
    "path.uk_agent_locked_note": "LEO START／MONTHLY／ANNUALで利用できます",
    "path.gma_eyebrow": "用意されたキャリアパス",
    "path.gma_title": "英国でオーディション機会を増やす",
    "path.gma_body": "10ステップで、応募導線、キャスティング上の見え方、Spotlight、応募、エージェントとの相談、30日後の見直しまで整理します。",
    "path.paid_locked_note": "LEO START／MONTHLY／ANNUALで利用できます",
    "goal.q1": "この目標に近づいていると、何を見れば分かる？",
    "goal.q1_hint": "キャリアの中で、具体的に何が起きている状態ですか？その結果が現実になった姿をイメージしてください。",
    "goal.q2": "達成したら何が可能になる？なぜ、それを望んでいる？",
    "goal.q3": "いつまでに達成したい？",
    "goal.q4": "この目標に、週何時間なら無理なく使える？",
    "goal.q_creating": "私は、どんな結果をつくろうとしている？",
    "goal.q_creating_hint": "最初の一歩や作業ではなく、キャリアで実現したい「結果」を書いてください。",
    "goal.q_possibilities": "この目標を達成すると、何が可能になる？",
    "goal.q_possibilities_hint": "この結果によって、どんな新しい機会が開くか考えてみてください。",
    "goal.q_have": "達成に役立つものを、私はすでに何を持っている？",
    "goal.q_have_hint": "経験、スキル、プロフィール素材、人脈、所属、言語、知識など、すでに自分の力になっているものを考えてみてください。",
    "goal.q_missing": "達成するために、今の自分にまだ足りないものは何？",
    "goal.q_missing_hint": "何を学ぶ、手に入れる、改善する、あるいは築く必要がありますか？",
    "goal.q_stops": "今、俳優として動くことを一番止めているものは何？",
    "goal.q_stops_hint": "本当に自分を止めているものを考えてください。拒絶への恐れ、計画不足、先延ばし、時間不足、不確かさ、それとも別の何か。",
    "goal.q_lose": "何も変えなければ、私は何を失う？",
    "goal.q_lose_hint": "今の場所にとどまり続けることで失うものを考えてみてください。",
    "goal.q4_hint": "LEOはこの時間を基準に、無理のない現実的なプランを組みます。",
    "goal.q5": "この目標の達成は、人生のほかの領域にどう影響する？",
    "goal.q5_hint": "キャリアだけでなく、お金、人間関係、住む場所、安心、自由、満足感への影響も考えてください。",
    "goal.why_title": "なぜ、これをやるのか",
    "goal.why_more_title": "ワークブックの回答一覧",
    "goal.why_hint": "Miniワークブックの残りの回答です。",
    "goal.why_empty": "保存された回答はありません。",
    "goal.why_q4_unit": "時間／週",
    "goal.q_answer_ph": "自分の言葉で自由に書いてください。",
    "goal.save": "目標を保存",
    "goal.saving": "保存中…",
    "goal.save_fail": "目標を保存できませんでした。",
    "step.list_title": "すべてのステップ",
    "step.next_hero": "次のステップ",
    "step.add": "+ ステップを追加",
    "step.name_ph": "例：エージェント3社に連絡する",
    "step.time_min": "分",
    "step.time_est": "目安時間",
    "step.due": "期限",
    "step.mark_done": "完了",
    "step.mark_undone": "元に戻す",
    "step.delete": "ステップを削除",
    "step.confirm_delete": "このステップを削除しますか？",
    "step.saved": "ステップを保存しました。",
    "step.save_fail": "ステップを保存できませんでした。",
    "step.done": "完了",
    "step.progress": "目標の進捗",
    "step.leo_generate": "LEOにプランを作ってもらう",
    "step.leo_generating": "LEOがプランを考えています…",
    "step.reward_title": "今月のご褒美",
    "step.reward_ph": "自分との約束を守れたら、どうやって自分をねぎらいたいですか？",
    "step.reward_save": "ご褒美を保存",
    "step.reward_saved": "ご褒美を保存しました。",
    "step.leo_ask_hours_title": "この目標に、現実的に週何時間使えますか？",
    "step.leo_ask_hours_ph": "例：3",
    "step.leo_ask_hours_unit": "時間／週",
    "step.leo_confirm": "LEOとプランを作成",
    "step.leo_update": "LEOにプランの更新を頼む",
    "step.leo_generating_wait": "LEOがプランを考えています…10〜20秒ほどかかることがあります。",
    "step.leo_banner": "LEOが作成したプラン \\u2726",
    "step.postpone.title": "ステップを延期",
    "step.edit.title": "ステップを編集",
    "goal.no_next_step": "すべてのステップが完了しました。お疲れさまでした！",
    "goal.no_steps_yet_title": "まだステップがありません。",
    "goal.no_steps_yet_body": "自分でステップを組むことも、LEOに現実的なスケジュールで組んでもらうこともできます。",
    "goal.plan_myself": "自分で計画する",
    "goal.plan_leo": "LEOに手伝ってもらう",
    "goal.delete": "目標を削除",
    "goal.confirm_delete": "この目標とすべてのステップを削除しますか？",
    "goal.deleted": "目標を削除しました。",
    "goal.back": "プランに戻る",
    "goal.no_goals": "まだ目標がありません。最初の目標を追加しましょう。",
    "crm.dash_tile_eyebrow": "ワークフロー＆CRM",
    "crm.dash_tile_title": "ワークフロー＆CRM・業界のつながりとオーディション",
    "crm.dash_tile_body": "キャスティングディレクター、監督、プロデューサーとの関係を育てます。オーディションやフィードバックも残しておけば、LEOが次の機会につなげるための材料として活用します。",
    "crm.open": "ワークフロー＆CRMを開く",
    "crm.page_title": "ワークフロー＆CRM",
    "crm.page_subtitle": "業界のつながりとオーディションを管理します。",
    "crm.page_tagline": "キャスティングディレクター、監督、プロデューサーとの関係を育てます。オーディションやフィードバックも記録し、次の機会につなげます。",
    "crm.section.contacts": "連絡先",
    "crm.section.auditions": "オーディション",
    "crm.tab.all": "すべて",
    "crm.tab.casting_director": "キャスティングディレクター",
    "crm.tab.director": "監督",
    "crm.tab.producer": "プロデューサー",
    "crm.tab.casting_assistant": "キャスティングアシスタント",
    "crm.tab.screenwriter": "脚本家",
    "crm.tab.agent": "エージェント",
    "crm.tab.agent_uk": "英国のエージェント",
    "crm.tab.other": "その他",
    "crm.type.casting_director": "キャスティングディレクター",
    "crm.type.director": "監督",
    "crm.type.producer": "プロデューサー",
    "crm.type.casting_assistant": "キャスティングアシスタント",
    "crm.type.screenwriter": "脚本家",
    "crm.type.agent": "エージェント",
    "crm.type.agent_uk": "英国のエージェント",
    "crm.type.other": "その他",
    "crm.dash.upcoming": "今後7日間",
    "crm.dash.later": "それ以降",
    "crm.dash.empty": "この項目には連絡先がありません。",
    "crm.col.person": "相手",
    "crm.col.type": "種別",
    "crm.col.project": "作品／関係した文脈",
    "crm.col.email_phone": "メール／電話",
    "crm.col.last": "前回の連絡",
    "crm.col.followup": "フォローアップ",
    "crm.col.countdown": "次回まで",
    "crm.col.status": "ステータス",
    "crm.col.action": "操作",
    "crm.action.confirm": "連絡を記録",
    "crm.action.new": "連絡先を追加",
    "crm.action.edit": "編集",
    "crm.action.delete": "削除",
    "crm.action.back": "CRMに戻る",
    "crm.status.today": "今日／期限超過",
    "crm.status.soon": "近日",
    "crm.status.active": "有効",
    "crm.countdown.days_left": "あと{n}日",
    "crm.countdown.today": "今日",
    "crm.countdown.overdue": "{n}日超過",
    "crm.no_contacts": "まだ連絡先がありません。最初の一人を追加して、業界とのつながりを育てていきましょう。",
    "crm.confirm.delete": "この連絡先を完全に削除しますか？",
    "crm.deleted": "連絡先を削除しました。",
    "crm.delete_fail": "削除できませんでした。",
    "crm.form.title_new": "連絡先を追加",
    "crm.form.title_edit": "連絡先を編集",
    "crm.form.first_name": "名",
    "crm.form.last_name": "姓",
    "crm.form.type": "連絡先の種別",
    "crm.form.company": "会社／エージェンシー",
    "crm.form.email": "メールアドレス",
    "crm.form.phone": "電話番号",
    "crm.form.project": "作品／関係した文脈",
    "crm.form.project_ph": "例：\\\"Winter War\\\" — main casting",
    "crm.form.notes": "メモ／フィードバック",
    "crm.form.notes_ph": "簡単なプロフィール、話した内容、覚えておきたいこと…",
    "crm.form.last_contact": "前回の連絡日",
    "crm.form.followup_period": "次回フォローアップまで",
    "crm.form.days30": "30日",
    "crm.form.days60": "60日",
    "crm.form.days90": "90日（標準）",
    "crm.form.days120": "120日",
    "crm.form.days180": "180日",
    "crm.form.custom_date": "日付を指定",
    "crm.form.save": "連絡先を保存",
    "crm.form.saving": "保存中…",
    "crm.form.saved": "連絡先を保存しました。",
    "crm.form.fail": "連絡先を保存できませんでした。",
    "crm.form.required": "名と連絡先の種別は必須です。",
    "crm.confirm.title": "連絡を記録",
    "crm.confirm.subtitle": "やり取りの種類を選んでください。確定すると今日の日付が記録され、次のフォローアップ日が再計算されます。",
    "crm.confirm.kind.email": "メールアドレス",
    "crm.confirm.kind.phone": "電話番号",
    "crm.confirm.kind.message": "メッセージ",
    "crm.confirm.kind.meeting": "ミーティング",
    "crm.confirm.kind.casting": "キャスティング",
    "crm.confirm.kind.materials": "資料",
    "crm.confirm.note": "やり取りのメモ（任意）",
    "crm.confirm.note_ph": "話した内容や結果を簡潔に。",
    "crm.confirm.new_followup": "次のフォローアップまで",
    "crm.confirm.yes": "はい、記録する",
    "crm.confirm.ok": "連絡を記録しました。次回フォローアップまでのカウントを更新しました。",
    "crm.confirm.fail": "連絡を記録できませんでした。",
    "crm.profile.overview": "連絡先情報",
    "crm.profile.history": "やり取りの履歴",
    "crm.profile.created": "追加日",
    "crm.profile.auditions": "オーディション履歴",
    "crm.profile.no_auditions": "この相手に紐づくオーディションはまだありません。",
    "pr.eyebrow": "料金プラン",
    "pr.title": "LEOの使い方に合ったプランを選んでください。",
    "pr.subtitle": "登録後は7日間無料で試せます。その後、単発・月額・年額から自分のペースに合うプランを選べます。",
    "pr.expand_details": "すべての機能を表示",
    "pr.collapse_details": "詳細を閉じる",
    "pr.recommended": "おすすめ",
    "pr.launch_badge": "ローンチ価格",
    "pr.best_value": "最もお得",
    "pr.includes": "含まれるもの：",
    "pr.does_not_include": "含まれないもの：",
    "pr.current_section_title": "現在のプラン",
    "pr.current_plan_label": "現在のプラン",
    "pr.current_expires": "終了日",
    "pr.current_next_renewal": "次回更新日",
    "pr.current_valid_until": "有効期限",
    "pr.current_days_left": "残り",
    "pr.current_days_word": "日",
    "pr.current_active": "有効",
    "pr.select": "選択",
    "pr.opening": "Stripeを開いています…",
    "pr.card_hint": "決済はStripeで安全に処理されます。カード情報をLEOが保存することはありません。税込み価格です。",
    "pr.fail": "決済を開始できませんでした。",
    "plan.top_note": "計画を立てる前に、少し落ち着ける環境をつくりましょう。静かな音楽をかける、灯りを整える、深呼吸をひとつ。",
    "plan.intro": "大きな目標は圧倒されやすいもの。でも、小さく具体的なステップに分けると現実的に見えてきます。全部を一度にやろうとせず、まず今週いちばん大切な2つの行動に集中しましょう。遠く見える目標も、実行できる小さな一歩の積み重ねに変わります。今のあなたにとって大切で、次の節目になりそうな目標は何ですか？",
    "plan.add_goal": "新しい目標を追加",
    "plan.suggestions_title": "LEOからの提案",
    "plan.custom_goal": "自分で目標を書く",
    "plan.custom_goal_ph": "例：ロンドンでキャスティングディレクターとのネットワークを築く",
    "plan.next": "次へ",
    "toast.welcome": "おかえりなさい。",
    "toast.login_fail": "ログインできませんでした。",
    "toast.google_fail": "Googleログインに失敗しました。",
    "brand.tagline": "俳優のためのキャリアシステム",
    "brand.name": "LEO — 俳優のためのキャリアシステム",
    "auth.entry": "スタジオへ",
    "auth.login": "ログイン",
    "auth.new": "新規登録",
    "auth.private": "シーンの履歴はあなたのアカウント内に非公開で保存されます。",
    "auth.google": "Googleで続ける",
    "auth.or_email": "またはメールアドレス",
    "auth.name": "名前",
    "auth.email": "メールアドレス",
    "auth.password": "パスワード",
    "auth.password_hint": "6文字以上",
    "auth.enter_btn": "入る",
    "auth.create_btn": "アカウントを作成",
    "auth.wait": "少々お待ちください…",
    "auth.forgot_password": "パスワードをお忘れですか？",
    "auth.forgot_need_email": "まず上の欄にメールアドレスを入力してください。",
    "auth.forgot_sent": "該当するアカウントがある場合、パスワード再設定リンクを送信しました。",
    "auth.reset_title": "新しいパスワードを設定",
    "auth.reset_hint": "新しいパスワードを入力してください。",
    "auth.new_password": "新しいパスワード",
    "auth.reset_submit": "新しいパスワードを保存",
    "auth.reset_bad_token": "このリンクは無効、または有効期限が切れています。",
    "auth.reset_fail": "パスワードを再設定できませんでした。新しいリンクをリクエストしてください。",
    "auth.reset_done": "パスワードを更新しました。ログインできます。",
    "auth.back_to_login": "← ログインに戻る",
    "auth.new_here": "初めてですか？",
    "auth.create_link": "アカウントを作成",
    "auth.have_account": "すでにアカウントをお持ちですか？",
    "auth.login_link": "ログイン",
    "auth.back": "← トップに戻る",
    "tab.analysis": "分析",
    "tab.mirror": "ミラーリング",
    "tab.map": "感情マップ",
    "tab.zapalnik": "トリガー",
    "tab.eight": "8つの質問",
    "tab.vagus": "迷走神経",
    "tab.rehearsal": "リハーサル／セルフテープ",
    "tab.ask": "LEOに相談",
    "tab.notebook": "ノート",
    "tab.history": "履歴",
    "tab.decompression": "グラウンディング",
    "map.eyebrow": "ミラーリング・感情マップ",
    "map.title": "感情マップ。シーンの要素 → あなたのイメージへ。",
    "map.subtitle": "LEOがシーンの要素を、あなたのイメージと一つずつ対応させます。人物ごと、象徴ごとに確認でき、あとから自由に編集できます。",
    "map.regenerate": "もう一度生成",
    "map.generating": "LEOがマップを作っています…",
    "map.in_scene": "シーンの中",
    "map.in_your_life": "あなたのイメージの中",
    "map.add_row": "行を追加",
    "map.save": "マップを保存",
    "map.saved": "マップを保存しました。",
    "map.need_mirror": "まずミラーリングを行ってください。",
    "map.empty": "「マップを作成」を押すと、LEOが対応関係を提案します。",
    "zap.eyebrow": "トリガー・シーン直前",
    "zap.title": "LEOがシーンに入るためのスイッチを整えます。",
    "zap.subtitle": "ミラーリングと目的をもとにした、シーン直前のためのあなた専用テキスト。誰かに見せるためではなく、自分をシーンへ入れるためのものです。",
    "zap.generate": "トリガーを生成",
    "zap.regenerate": "もう一度生成",
    "zap.generating": "LEOが書いています…",
    "zap.saved": "トリガーを保存しました。",
    "zap.need_map": "まず感情マップを作成してください。LEOがそこから材料を受け取れます。",
    "eight.eyebrow": "Craft & Truth・8つの質問",
    "eight.title": "リハーサルの前に、シーンへ着地する。",
    "eight.subtitle": "役があなたを通して問いかける8つの質問。LEOが下書きを作り、あなたが「自分の真実」になるまで書き直します。",
    "eight.generate": "回答を生成",
    "eight.regenerate": "もう一度生成",
    "eight.generating": "LEOが下書きを作っています…",
    "eight.save": "回答を保存",
    "eight.saved": "保存しました。",
    "eight.answer_ph": "— 一人称で答えてください…",
    "vag.eyebrow": "迷走神経・リハーサル前",
    "vag.title": "Craft & Truthの前に、身体を落ち着かせる。",
    "vag.subtitle": "3〜6分の短い呼吸と身体のエクササイズ。評価せず、急がずに。医療行為の代わりになるものではありません。",
    "vag.start": "開始",
    "vag.next": "次へ",
    "vag.done": "完了",
    "vag.step": "エクササイズ",
    "ask.eyebrow": "チャット・LEOと1対1で",
    "ask.title": "このシーンについて、LEOに何でも相談できます。",
    "ask.subtitle": "ここでLEOがするのはリハーサルの進行ではなく、コーチングです。決めつけず、正解ではなく選択肢を返します。",
    "ask.input_ph": "例：「強くやりすぎそうで怖い。どう演じればいい？」",
    "ask.reset": "リセット",
    "ask.confirm_reset": "LEOとの会話をすべて消去しますか？",
    "ask.empty": "最初の質問を書いてみてください。役、セリフ、選択、迷いについて何でも。",
    "ask.leo": "LEO",
    "ask.you": "あなた",
    "an.wait_title": "LEOの分析を始められます。",
    "an.wait_body": "分析ではニーズ・コーデックスから役の目的を見つけ、障害と俳優としての課題を整理します。",
    "an.run": "分析を始める",
    "an.thinking": "LEOが考えています…",
    "an.rerun": "もう一度分析する",
    "an.rerunning": "分析中…",
    "an.goal": "役の目的・ニーズ・コーデックス",
    "an.addressee": "向ける相手",
    "an.obstacles": "障害",
    "an.tasks": "俳優の課題",
    "an.leo_note": "LEOからのメモ",
    "an.task": "課題",
    "an.change_goal": "シーンの目的を変更",
    "an.list_needs": "ニーズ一覧",
    "an.manually_set": "手動で設定",
    "an.done": "分析が完了しました。",
    "an.fail": "分析に失敗しました。",
    "an.relacja": "関係性",
    "an.rel_source": "目的の源・関係性から",
    "an.rel_needs": "相手役の欲求（人として）",
    "an.rel_fears": "相手役が恐れていること",
    "an.rel_dynamic": "関係性",
    "an.subtext": "サブテキスト",
    "an.subtext_intro": "言葉の下に、本当の欲求が隠れているかもしれない瞬間。",
    "an.subtext_surface": "表面上の言葉",
    "an.subtext_real": "本当の欲求",
    "needs.your_library": "自分の目的ライブラリ",
    "needs.your_library_empty": "保存した自分の目的がここに表示されます。",
    "needs.delete_own": "ライブラリから削除",
    "needs.dialog_title": "ニーズ・コーデックス",
    "needs.dialog_desc": "LEOが目的を選ぶために使うニーズの一覧です。ポーランド語または英語で検索できます。",
    "needs.copy": "一覧をコピー",
    "needs.copied": "クリップボードにコピーしました",
    "osadz.eyebrow": "身体と場所へのエンボディメント",
    "osadz.title": "シーンに入る前に、LEOが役の欲求を身体へ落とし込むガイドをします。",
    "osadz.generate": "エンボディメントを生成",
    "osadz.regenerate": "もう一度生成",
    "osadz.generating": "LEOがガイドしています…",
    "osadz.empty": "ミラーリングを保存してから「エンボディメントを生成」を押してください。",
    "takt.eyebrow": "俳優の戦術・主体性",
    "takt.title": "被害者を演じるのではなく、目的のために本気で働きかける。",
    "takt.generate": "戦術を生成",
    "takt.regenerate": "もう一度生成",
    "takt.generating": "LEOが書いています…",
    "takt.empty": "ミラーリングを保存してから「戦術を生成」を押してください。",
    "note.title": "俳優ノート",
    "note.subtitle": "発見、解釈の試み、監督への質問。ここはあなただけのノートです。",
    "note.ph": "— 今日、この役は自分を守ろうとしていないことに気づいた…",
    "note.save": "ノートを保存",
    "note.saved": "ノートを保存しました。",
    "note.fail": "保存できませんでした。",
    "dec.eyebrow": "グラウンディング・リハーサル後",
    "dec.title": "役から離れて、自分自身に戻りましょう。",
    "dec.body": "演じたものは身体に残ります。急がず、落ち着いて4つのステップを進めてください。",
    "dec.step": "ステップ",
    "pay.confirming": "Stripeで決済を確認しています…",
    "pay.wait": "少々お待ちください",
    "pay.done": "決済完了。幕を上げよう。",
    "pay.done_body": "プランが有効になりました。",
    "pay.to_dash": "始めよう！",
    "pay.new_scene": "新しいシーン",
    "pay.fail": "問題が発生しました。",
    "pay.retry": "少し待ってからもう一度お試しください。",
    "pay.choose": "プランを選ぶ",
    "prof.title": "プロフィール",
    "prof.email": "メールアドレス",
    "prof.created": "アカウント作成日",
    "prof.provider": "ログイン方法",
    "prof.plan_limits": "プランと利用上限",
    "prof.change_plan": "プランを変更",
    "prof.manage_sub": "サブスクリプションを管理",
    "prof.manage_sub_hint": "請求書、支払い方法、解約",
    "prof.manage_sub_fail": "Stripeポータルを開けませんでした。",
    "prof.manage_sub_opening": "Stripeポータルを開いています…",
    "prof.used": "無料シーン利用数",
    "prof.credits": "クレジット",
    "prof.expires": "有効期限",
    "prof.language": "アプリとLEOの言語",
    "hdr.plan": "プラン",
    "hdr.free_scenes": "無料シーン",
    "hdr.credits": "クレジット",
    "hdr.expires": "有効期限",
    "loading.stage": "幕が上がります…",
    "loading.scene": "シーンを読み込み中…",
    "loading.callback": "照明を整えています…",
    "quote.list": "リハーサルルームから届いた声",
    "aud.list_title": "オーディション",
    "aud.new": "オーディションを追加",
    "aud.empty": "まだオーディションがありません。最初のオーディションを追加しましょう。",
    "aud.col.project": "作品",
    "aud.col.role": "役",
    "aud.col.type": "種別",
    "aud.col.cd": "キャスティングディレクター",
    "aud.col.next_date": "次の予定日",
    "aud.col.status": "ステータス",
    "aud.form.title_new": "オーディションを追加",
    "aud.form.title_edit": "オーディションを編集",
    "aud.form.project": "作品名 *",
    "aud.form.role": "役",
    "aud.form.production_type": "作品種別",
    "aud.form.production_ph": "例：映画、ドラマ、CM、舞台",
    "aud.form.cd": "キャスティングディレクター *",
    "aud.form.cd_choose": "連絡先から選択…",
    "aud.form.cd_hint": "オーディションは、登録済みのキャスティングディレクターの連絡先に紐づけてください。",
    "aud.form.cd_none": "連絡先にキャスティングディレクターがまだ登録されていません。",
    "aud.form.cd_add": "連絡先を追加",
    "aud.form.source": "オーディション経路",
    "aud.form.source_ph": "例：キャスティングサイト、エージェント、直接オファー",
    "aud.form.audition_type": "オーディション形式",
    "aud.form.status": "ステータス",
    "aud.form.notes": "メモ",
    "aud.form.notes_ph": "背景、監督の意図、トーンなど…",
    "aud.form.feedback": "フィードバック",
    "aud.form.feedback_ph": "オーディション後のフィードバック。",
    "aud.form.save": "オーディションを保存",
    "aud.form.saved": "オーディションを保存しました。",
    "aud.form.fail": "保存できませんでした。",
    "aud.form.required": "作品名とキャスティングディレクターは必須です。",
    "aud.form.no_cd_msg": "オーディションを追加するには、先に「連絡先」でキャスティングディレクターを1名以上登録してください。",
    "aud.type.in_person": "対面",
    "aud.type.self_tape": "セルフテープ",
    "aud.type.online_live": "オンライン／ライブ",
    "aud.type.callback_in_person": "コールバック・対面",
    "aud.type.callback_online": "コールバック・オンライン",
    "aud.type.chemistry_read": "ケミストリーリード",
    "aud.type.screen_test": "スクリーンテスト",
    "aud.type.final_audition": "最終オーディション",
    "aud.type.other": "その他",
    "aud.status.new": "新規",
    "aud.status.in_preparation": "準備中",
    "aud.status.sent": "提出済み",
    "aud.status.callback": "コールバック",
    "aud.status.booked": "決定",
    "aud.status.not_booked": "不採用",
    "stage.title": "オーディションのステージ",
    "stage.subtitle": "オーディションには複数のステージを登録できます。メイン一覧の「次の予定日」は、ここに登録した日程から自動で表示されます。",
    "stage.add": "ステージを追加",
    "stage.edit": "ステージを編集",
    "stage.empty": "まだステージがありません。最初のステージを追加して日程を設定しましょう。",
    "stage.kind": "ステージ種別",
    "stage.date": "日時",
    "stage.deadline": "提出期限",
    "stage.place": "場所",
    "stage.address": "住所",
    "stage.studio": "スタジオ／部屋",
    "stage.link": "リンク",
    "stage.platform": "プラットフォーム",
    "stage.instructions": "指示",
    "stage.notes": "メモ／フィードバック",
    "stage.status": "ステージのステータス",
    "stage.saved": "ステージを保存しました。",
    "stage.save_fail": "ステージを保存できませんでした。",
    "stage.confirm_delete": "このステージを削除しますか？",
    "stage.deleted": "ステージを削除しました。",
    "asc.title": "準備するシーン",
    "asc.add": "シーンを追加",
    "asc.add_first": "最初のシーンを追加",
    "asc.empty": "このオーディションにはまだシーンが追加されていません。",
    "asc.name": "シーン名",
    "asc.description": "シーンの説明",
    "asc.description_ph": "背景、役柄、シーンで何が起きているかなど…",
    "asc.text": "シーン本文",
    "asc.text_ph": "セリフ／シーン説明を貼り付けてください。自動でLEOに渡されます。",
    "asc.file": "シーンファイル（PDF）",
    "asc.file_uploaded": "アップロード済み：",
    "asc.status": "シーンの状態",
    "asc.status.to_prepare": "未準備",
    "asc.status.in_progress": "進行中",
    "asc.status.ready": "準備完了",
    "asc.saved": "保存しました。",
    "asc.save_fail": "シーンを保存できませんでした。",
    "asc.confirm_delete": "このシーンを削除しますか？",
    "asc.deleted": "シーンを削除しました。",
    "asc.work_with_leo": "🤖 LEOとシーンを準備する",
    "asc.open_leo_scene": "LEOで開く",
    "asc.leo_linked": "LEOに連携済み",
    "act.title": "アクティビティ履歴",
    "act.empty": "アクティビティ履歴はありません。",
    "act.kind.created": "オーディションを作成",
    "act.kind.status_changed": "ステータスを変更",
    "act.kind.stage_added": "ステージを追加",
    "act.kind.scene_added": "シーンを追加",
    "act.kind.scene_status": "シーンの状態",
    "act.kind.feedback_added": "フィードバックを追加",
    "act.kind.leo_started": "LEOセッションを開始",
    "brief.title": "オーディションを保存しました！🎬",
    "brief.subtitle": "始める前に、このキャスティングディレクターについて覚えておきたいことを確認しましょう。",
    "brief.prev": "{name}との過去のオーディション",
    "brief.first": "{name}との記録上、今回が最初のオーディションです。まっさらな状態から始められます。LEOがシーンの準備と、意図を持って臨むための整理を手伝います。",
    "brief.cta_leo": "🤖 LEOへ — シーンを準備",
    "brief.cta_back": "オーディション一覧に戻る",
    "brief.no_scenes": "LEOで開くには、シーンを1つ以上追加してください。",
    "aud.back": "オーディション一覧に戻る",
    "aud.next_date_label": "次の予定日",
    "aud.next_date_none": "予定なし",
    "aud.confirm_delete": "このオーディションを完全に削除しますか？",
    "aud.deleted": "オーディションを削除しました。",
    "aud.delete_fail": "削除できませんでした。",
    "planpath.title": "プランはどう作りますか？",
    "planpath.own": "自分で計画する",
    "planpath.leo": "LEOに手伝ってもらう",
    "review.title": "週間レビュー",
    "review.subtitle": "短く、落ち着いて振り返ります。",
    "review.done_n": "{n}件完了",
    "review.in_progress_n": "{n}件進行中",
    "review.postponed_n": "{n}件延期",
    "review.next": "次のステップ：",
    "review.q": "来週のプランで変えたいことはありますか？",
    "ops.title": "実務タスク",
    "ops.subtitle": "フォローアップ、セルフテープ、資料、ネットワーキングなど、日々の実務をまとめて管理します。",
    "ops.new": "+ 新しいタスク",
    "ops.empty": "まだタスクがありません。最初のタスクを追加しましょう。",
    "ops.form.title_new": "新しいタスク",
    "ops.form.title_edit": "タスクを編集",
    "ops.form.name": "タスク名 *",
    "ops.form.name_ph": "例：Martha Carterにフォローアップする",
    "ops.form.category": "カテゴリ",
    "ops.form.due": "期限",
    "ops.form.contact": "関連する連絡先",
    "ops.form.contact_none": "— 関連なし —",
    "ops.form.notes": "メモ",
    "ops.form.save": "タスクを保存",
    "ops.form.saved": "タスクを保存しました。",
    "ops.form.fail": "保存できませんでした。",
    "ops.cat.contact": "連絡先",
    "ops.cat.followup": "フォローアップ",
    "ops.cat.selftape": "セルフテープ",
    "ops.cat.materials": "資料",
    "ops.cat.networking": "ネットワーキング",
    "ops.cat.research": "リサーチ",
    "ops.cat.meeting": "ミーティング",
    "ops.cat.other": "その他",
    "ops.status.todo": "未着手",
    "ops.status.in_progress": "進行中",
    "ops.status.done": "完了",
    "ops.status.postponed": "延期",
    "ops.action.complete": "✓ タスクを完了",
    "ops.action.postpone": "延期",
    "ops.action.delete": "タスクを削除",
    "ops.action.edit": "編集",
    "ops.confirm_delete": "このタスクを削除しますか？",
    "ops.deleted": "タスクを削除しました。",
    "ops.postpone.title": "タスクを延期",
    "ops.postpone.q": "現実的に、いつならこのタスクに取り組めますか？",
    "ops.postpone.still_important": "このタスクは今も目標にとって重要ですか？",
    "ops.postpone.remove": "プランからタスクを外す",
    "ops.postpone.save": "延期",
    "ops.postpone.saved": "タスクを延期しました。",
    "ops.postpone.repeated_note": "このタスクを何度か延期しています。もっと小さなステップに分ける、日付を動かす、あるいは今は重要ではないと判断する——どれがいちばん現実的ですか？",
    "ops.complete.title": "タスク完了",
    "ops.complete.contact_line": "連絡先：{name}",
    "ops.complete.last_set": "前回の連絡日を {date} に更新します",
    "ops.complete.next_q": "次はいつ連絡したいですか？",
    "ops.complete.save": "保存",
    "ops.complete.no_next": "次の連絡予定なし",
    "ops.complete.no_next_q": "次の連絡を予定しない理由は？",
    "ops.complete.saved": "タスクを完了し、CRMを更新しました。",
    "ops.complete.simple": "タスクを完了しました。",
    "cc.goal_title": "現在の目標",
    "cc.no_active_goal": "まだ進行中の目標がありません。",
    "cc.no_active_goal_cta": "キャリアパスで目標を追加してください。",
    "cc.next_step_label": "次のステップ：",
    "cc.open": "開く",
    "cc.tasks_title": "実務タスク",
    "cc.next_task_label": "いちばん近い期限：",
    "cc.no_open_tasks": "未完了のタスクはありません。",
    "cc.tasks_pending_one": "未完了1件",
    "cc.tasks_pending_n": "未完了{n}件",
    "cc.tasks_pending_many": "未完了{n}件",
    "cc.see_all": "すべて見る",
    "cc.command_center": "キャリアの司令塔",
    "ops.sec.upcoming": "今後7日間",
    "ops.sec.later": "それ以降",
    "ops.sec.done": "完了",
    "dash.manifesto_credits_prefix": "Marcin Zarzeczny",
    "dash.manifesto_credits_films": "（The Agency、Out There、Supernova）",
    "tasks.dash_tile_body": "フォローアップ、セルフテープ、資料、ネットワーキング。今やるべき実務をひとつの場所で管理できます。",
    "tasks.open": "タスクを開く",
    "path.paid_lock_badge": "LEO START / MONTHLY / ANNUAL",
    "step.leo_banner_n_one": "使える時間に合わせて、LEOがこの目標を1つのステップに整理しました。",
    "step.leo_banner_n_few": "使える時間に合わせて、LEOがこの目標を{n}個のステップに整理しました。",
    "step.leo_banner_n_many": "使える時間に合わせて、LEOがこの目標を{n}個のステップに整理しました。",
    "step.leo_fail": "今はプランを生成できませんでした。もう一度お試しください。",
    "crm.dash.today": "今日フォローアップ／期限超過",
    "crm.profile.no_history": "まだやり取りの記録がありません。「連絡を記録」から最初のやり取りを追加できます。",
    "map.generate": "マップを作成",
    "zap.empty": "「トリガーを生成」を押すと、LEOがシーン直前のためのあなた専用テキストを書きます。",
    "eight.empty": "「回答を生成」を押すと、LEOが8つの質問の下書きを作ります。",
    "an.missing_extras": "この分析は旧バージョンです。関係性とサブテキストを見るには、もう一度分析してください。",
    "aud.no_next_date": "—",
    "ops.sec.today": "今日フォローアップ／期限超過",
    "ops.sec.empty": "—",
  },
};

export function tr(key, lang) {
  const bag = T[lang] || T.pl;
  return bag[key] ?? T.pl[key] ?? key;
}

export const QUOTES_BY_LANG = {
  pl: [
    { text: "Aktorstwo to nie udawanie. To życie w wyobrażonych okolicznościach.", author: "Konstanty Stanisławski" },
    { text: "Nie graj emocji. Graj cel.", author: "Sanford Meisner" },
    { text: "Postać nie ma znaczenia. Znaczenie ma to, czego postać chce.", author: "Stella Adler" },
    { text: "Prawda w sztuce zaczyna się w momencie, gdy przestajesz kłamać sobie.", author: "Andrzej Wajda" },
    { text: "Reżyseria to zadawanie właściwych pytań aktorowi.", author: "Krzysztof Kieślowski" },
    { text: "Aktor musi mieć w sobie ciszę, żeby usłyszeć drugiego człowieka.", author: "Jerzy Grotowski" },
    { text: "Kamera widzi wszystko. Nawet myśli, których jeszcze nie pomyślałeś.", author: "Ingmar Bergman" },
    { text: "Talent to intensywność uwagi.", author: "Marlon Brando" },
    { text: "Rola nie jest do zagrania. Rola jest do przeżycia.", author: "Anna Magnani" },
    { text: "Kino to prawda dwadzieścia cztery klatki na sekundę.", author: "Jean-Luc Godard" },
    { text: "Kiedy masz do zagrania trudną scenę na planie zdjęciowym i potrzebujesz ciszy i chwili na skupienie, poproś o nie.", author: "Marcin Zarzeczny" },
  ],
  en: [
    { text: "Acting is not pretending. It is living under imaginary circumstances.", author: "Konstantin Stanislavski" },
    { text: "Don't play emotions. Play the objective.", author: "Sanford Meisner" },
    { text: "The character doesn't matter. What matters is what the character wants.", author: "Stella Adler" },
    { text: "Truth in art begins the moment you stop lying to yourself.", author: "Andrzej Wajda" },
    { text: "Directing is asking the actor the right questions.", author: "Krzysztof Kieślowski" },
    { text: "The actor must carry silence inside, to hear the other person.", author: "Jerzy Grotowski" },
    { text: "The camera sees everything. Even thoughts you have not thought yet.", author: "Ingmar Bergman" },
    { text: "Talent is the intensity of attention.", author: "Marlon Brando" },
    { text: "A role is not to be played. A role is to be lived.", author: "Anna Magnani" },
    { text: "Cinema is truth twenty-four frames per second.", author: "Jean-Luc Godard" },
    { text: "When you have a difficult scene to play on set and you need silence and a moment to focus — ask for it.", author: "Marcin Zarzeczny" },
  ],
  ja: [
    { text: "演技とは、ふりをすることではない。想像上の状況の中で生きることだ。", author: "Konstantin Stanislavski" },
    { text: "感情を演じるな。目的を演じろ。", author: "Sanford Meisner" },
    { text: "人物そのものが重要なのではない。その人物が何を求めているかが重要だ。", author: "Stella Adler" },
    { text: "芸術における真実は、自分自身に嘘をつくのをやめた瞬間から始まる。", author: "Andrzej Wajda" },
    { text: "演出とは、俳優に正しい問いを投げかけることだ。", author: "Krzysztof Kieślowski" },
    { text: "俳優は、相手の声を聞くために、自分の内側に沈黙を持たなければならない。", author: "Jerzy Grotowski" },
    { text: "カメラはすべてを見る。まだ自分でも考えていない思考さえも。", author: "Ingmar Bergman" },
    { text: "才能とは、注意を向ける強さである。", author: "Marlon Brando" },
    { text: "役は「演じる」ものではない。生きるものだ。", author: "Anna Magnani" },
    { text: "映画とは、1秒24コマの真実である。", author: "Jean-Luc Godard" },
    { text: "現場で難しいシーンを演じるとき、静けさや集中する時間が必要なら——求めていい。", author: "Marcin Zarzeczny" },
  ],
};;

export const DECOMPRESSION_BY_LANG = {
  pl: [
    { title: "Oddech 4-7-8", body: "Wdech przez nos przez 4 sekundy. Zatrzymaj oddech na 7 sekund. Wydech ustami na 8 sekund. Powtórz cztery razy. Pozwól postaci opuścić Twoje ciało z każdym wydechem." },
    { title: "Nazwij pięć rzeczy", body: "Rozejrzyj się. Wymień na głos pięć przedmiotów, które widzisz. Cztery, które słyszysz. Trzy, których możesz dotknąć. Wracasz do siebie, do swojego imienia, do teraz." },
    { title: "Zdejmij kostium", body: "Powiedz na głos: „Ta postać zostaje tutaj. Ja idę dalej.” Otrzep dłonie, jakby zdejmowałeś kurz. Jesteś sobą." },
    { title: "Notatka wdzięczności", body: "Zapisz w Notatniku aktorskim jedną rzecz, którą dziś odkryłeś o swojej postaci — i jedną rzecz, którą doceniasz w sobie za tę próbę." },
  ],
  en: [
    { title: "4-7-8 breath", body: "Inhale through the nose for 4 seconds. Hold the breath for 7. Exhale through the mouth for 8. Repeat four times. Let the character leave your body with each exhale." },
    { title: "Name five things", body: "Look around. Name aloud five things you see. Four you hear. Three you can touch. You return to yourself, to your name, to now." },
    { title: "Take off the costume", body: "Say out loud: \"This character stays here. I go on.\" Dust off your hands as if brushing off dust. You are yourself." },
    { title: "Gratitude note", body: "Write in the Actor's Notebook one thing you discovered today about your character — and one thing you appreciate in yourself for this rehearsal." },
  ],
  ja: [
    "4-7-8呼吸法",
    "鼻から4秒吸い、7秒息を止め、口から8秒かけて吐きます。4回繰り返してください。吐くたびに、役を身体の外へ手放していくイメージで。",
    "5つのものを言葉にする",
    "周りを見て、見えるものを5つ声に出します。聞こえるものを4つ。触れられるものを3つ。自分の名前、自分の身体、「今」に戻ってきます。",
    "衣装を脱ぐ",
    "声に出して言います。「この役はここに置いていく。私は先へ進む」。手についた埃を払うように手を軽く払ってください。あなたはあなたです。",
    "感謝をひとつ書く",
    "俳優ノートに、今日役について発見したことをひとつ。そして、このリハーサルをした自分自身に感謝できることをひとつ書いてください。",
  ],
};;


export const VAGUS_BY_LANG = {
  pl: [
    { title: "Oddech rezonansowy 5-5", duration: 90,
      body: "Usiądź wygodnie. Wdech nosem przez 5 sekund — powoli, głęboko do brzucha. Wydech ustami przez 5 sekund. Powtarzaj przez półtorej minuty. Spokojny, wydłużony wydech może wspierać wyciszenie i pomóc wyjść z trybu walki." },
    { title: "Humming — nucenie", duration: 60,
      body: "Zamknij usta. Wydychając, delikatnie nuć na jednym niskim tonie „mmm” — poczuj wibrację w gardle i piersi. Powtórz przez minutę. Nie chodzi o piękno dźwięku — chodzi o wibrację, która może pomóc obniżyć napięcie." },
    { title: "Chłód na twarz", duration: 30,
      body: "Wypełnij dłonie chłodną wodą (albo weź kostkę lodu owiniętą chusteczką) i przyłóż na 15-30 sekund do obszaru wokół oczu i skroni. Chłód może pomóc szybko zwolnić rytm i wrócić do spokojniejszego oddechu." },
    { title: "Pół-uśmiech + rozluźniona żuchwa", duration: 45,
      body: "Rozluźnij żuchwę tak, żeby zęby się nie stykały. Pozwól językowi opaść na dolne podniebienie. Delikatnie unieś kąciki ust — tylko trochę, wewnętrznie. Utrzymaj 45 sekund, oddychając nosem. To małe rozluźnienie w twarzy może pomóc ciału zwolnić." },
  ],
  en: [
    { title: "Resonant breath 5-5", duration: 90,
      body: "Sit comfortably. Inhale through the nose for 5 seconds — slow, deep into the belly. Exhale through the mouth for 5 seconds. Repeat for a minute and a half. A slow, extended exhale can support calm and help you shift out of fight mode." },
    { title: "Humming", duration: 60,
      body: "Close your mouth. On the exhale, softly hum a low \"mmm\" — feel the vibration in your throat and chest. Repeat for one minute. It's not about how it sounds — the gentle vibration can help lower tension." },
    { title: "Cold on the face", duration: 30,
      body: "Cup cold water in your hands (or wrap an ice cube in a tissue) and press it against the area around your eyes and temples for 15-30 seconds. Cold contact can help slow your rhythm and bring the breath back to a calmer pace." },
    { title: "Half-smile + soft jaw", duration: 45,
      body: "Let your jaw relax so the teeth don't touch. Let your tongue rest on the lower palate. Gently lift the corners of your mouth — just a little, inwardly. Hold for 45 seconds, breathing through the nose. This small softening in the face can help the body settle." },
  ],
  ja: [
    "5-5の共鳴呼吸",
    "楽な姿勢で座ります。鼻から5秒かけて、お腹までゆっくり深く吸います。口から5秒かけて吐きます。1分半ほど繰り返してください。ゆっくり長く吐くことで、身体が落ち着く方向へ切り替わりやすくなります。",
    "ハミング",
    "口を閉じ、息を吐きながら低く柔らかく「mmm」とハミングします。喉や胸の振動を感じてください。1分ほど繰り返します。上手に響かせる必要はありません。やさしい振動を感じることが目的です。",
    "顔を冷やす",
    "手に冷たい水をすくうか、氷をティッシュで包み、目の周りやこめかみに15〜30秒ほど当てます。冷たさに触れることで、呼吸や身体のリズムが落ち着くことがあります。",
    "半分の微笑み＋顎をゆるめる",
    "歯が触れないように顎をゆるめ、舌を下あご側に自然に休ませます。口角をほんの少しだけ上げ、鼻で呼吸しながら45秒ほど保ちます。顔の小さな緩みが、身体全体の落ち着きにつながることがあります。",
  ],
};;


// Plan catalog for the Pricing page.
// - Prices are FINAL (VAT/tax already included in Stripe configuration).
// - PL branch shows PLN; EN branch shows USD.
// - `id` matches the backend `lookup_key` and is used to trigger Stripe Checkout.
// - `free_trial: true` is a pseudo-plan; the checkout button is hidden for it.
export const PLANS_BY_LANG = {
  pl: [
    { id: "free_trial", free_trial: true, name: "7 DAY FREE", price: "0 PLN", priceSuffix: "/ 7 dni",
      tag: "Poznaj LEO i zobacz, jak może pomóc Ci pracować nad sceną i organizować karierę.", launch_badge: false,
      features: [
        "Przygotuj 1 pełną scenę z LEO — od analizy do konkretnych decyzji aktorskich",
        "Sprawdź 1 alternatywny wariant i zobacz, jak zmienia się scena przy innym podejściu",
        "AI Reader — przećwicz scenę i przygotuj self-tape z partnerem AI",
        "Wybierz 1 głos partnera AI do pracy nad sceną",
        "Podejrzyj Career Paths i zobacz, jakie ścieżki rozwoju możesz realizować z LEO",
        "10 wiadomości w Leo Career — zacznij pracować nad swoją karierą z asystentem AI",
        "Zacznij budować sieć kontaktów — 3 kontakty w CRM",
        "Dodaj i prowadź 2 aktywne castingi",
        "Zamieniaj decyzje w konkretne zadania i kolejne kroki",
        "„Halo, tu Twoja kariera” — LEO przypomina Ci o tym, co warto zrobić dalej",
      ],
      excludes: [],
      footer_line: "7 dni na poznanie LEO. Bez zobowiązań.",
      highlight: false,
    },
    { id: "leo_single_scene", name: "SINGLE SCENE", price: "19,90 PLN", priceSuffix: "/ jednorazowo",
      tag: "Masz scenę? Rozpracuj ją naprawdę porządnie.",
      launch_badge: true,
      features: [
        "1 pełna analiza sceny — zrozum, co naprawdę dzieje się między postaciami",
        "3 alternatywne warianty tej samej sceny — sprawdź różne cele, taktyki i sposoby grania",
        "AI Reader — ćwicz tekst i przygotuj self-tape z partnerem AI przez maksymalnie 45 minut",
        "Wybierz do 2 głosów partnera AI do pracy nad sceną",
        "Określ cel postaci, relację, okoliczności i stawkę",
        "Przejdź przez Odzwierciedlenie i Osadzenie",
        "Znajdź taktykę i konkretne przygotowanie do grania",
        "Przećwicz tekst i zachowaj własne notatki",
        "Korzystaj ze wszystkich narzędzi Scene Prep dla tej sceny",
      ],
      excludes: [],
      footer_line: "Jedna scena. Trzy podejścia. Pełne przygotowanie. Bez abonamentu.",
      highlight: false,
    },
    { id: "leo_start", name: "LEO START", price: "69 PLN", priceSuffix: "/ pierwszy miesiąc",
      save_line: "Potem 149 PLN / miesiąc",
      tag: "CENA PREMIEROWA ZA PIERWSZY MIESIĄC",
      launch_badge: "CENA PREMIEROWA",
      description: "Cena regularna 149zł naliczana od drugiego miesiąca.",
      features: [
        "Przygotuj do 10 pełnych scen miesięcznie — od analizy do konkretnych decyzji aktorskich",
        "Sprawdź do 10 dodatkowych wariantów — szukaj innych celów, taktyk i sposobów grania",
        "AI Reader — przećwicz do 20 scen miesięcznie i korzystaj z partnera AI przez maksymalnie 3 godziny miesięcznie",
        "Do każdej sceny wybierz do 2 głosów partnerów AI",
        "Wybierz 2 gotowe Career Paths miesięcznie i zamień je w konkretny plan działania",
        "Stwórz 1 indywidualny Career Path miesięcznie — LEO dopasuje ścieżkę do Twojego celu i zaplanuje ją nawet na 12 miesięcy",
        "LEO Radar — śledź filmy i seriale w przygotowaniu, żeby wiedzieć, co powstaje i gdzie możesz szukać swojej szansy",
        "30 wiadomości miesięcznie w Leo Career — pracuj z LEO nad agentami, rynkami, networkingiem i kolejnymi decyzjami",
        "Buduj swoją sieć — do 20 kontaktów w CRM",
        "Prowadź do 10 aktywnych castingów — trzymaj statusy, terminy i feedback w jednym miejscu",
        "Zamieniaj plany w konkretne Steps i działania",
        "„Halo, tu Twoja kariera” — LEO przypomina Ci o działaniach, które naprawdę warto zrobić",
      ],
      excludes: [],
      footer_line: "Sceny. Castingi. Kontakty. Strategia. LEO pomaga Ci zamienić karierę w pracę, którą wykonujesz każdego dnia.",
      highlight: false,
    },
    { id: "leo_sprint_48h", name: "48H CASTING SPRINT", price: "69 PLN", priceSuffix: "/ jednorazowo / 48 godzin",
      tag: "Casting za chwilę? Masz 48 godzin, żeby zrobić robotę. LEO pracuje z Tobą.",
      launch_badge: true,
      features: [
        "Przygotuj do 3 pełnych scen castingowych",
        "Sprawdź dodatkowy wariant każdej sceny i przetestuj inne podejście",
        "AI Reader — ćwicz tekst i przygotowuj self-tape bez szukania partnera — do 3 godzin w ciągu 48 godzin",
        "Do każdej sceny wybierz do 2 głosów partnerów AI",
        "Przejdź przez pełny proces: analiza, Cel, Odzwierciedlenie, Osadzenie i Taktyka",
        "Korzystaj ze wszystkich narzędzi Scene Prep",
        "Wybierz 1 gotowy Career Path i zaplanuj kolejne działania",
        "Stwórz 1 indywidualny Career Path z AI — nawet na 12 miesięcy",
        "Masz 20 wiadomości w Leo Career na decyzje związane z castingiem i tym, co zrobić dalej",
        "Po castingu zamień wnioski w konkretne Steps i działania",
      ],
      excludes: [],
      footer_line: "48 godzin. Maksymalne skupienie. Bez abonamentu.",
      highlight: false,
    },
    { id: "leo_monthly", name: "LEO MONTHLY", price: "149 PLN", priceSuffix: "/ pierwszy miesiąc",
      save_line: "Potem 199 PLN / miesiąc",
      launch_badge: "CENA PREMIEROWA",
      description: "Twoje biuro kariery aktorskiej. W jednym miejscu.",
      features: [
        "Przygotuj do 20 pełnych scen miesięcznie — na casting, self-tape, próbę albo własny materiał",
        "Twórz do 20 dodatkowych wariantów i sprawdzaj inne cele, taktyki i podejścia",
        "AI Reader — pracuj nad maksymalnie 40 scenami miesięcznie z partnerem AI — do 4 godzin miesięcznie",
        "Do każdej sceny wybierz do 2 głosów partnerów AI",
        "Korzystaj z biblioteki gotowych Career Paths i wybieraj kierunki, nad którymi chcesz pracować",
        "Twórz do 5 indywidualnych Career Paths miesięcznie — od najbliższych 90 dni po strategię na maksymalnie 24 miesiące",
        "LEO Radar — śledź filmy i seriale w przygotowaniu, żeby wcześniej wiedzieć, co powstaje",
        "100 wiadomości miesięcznie w Leo Career — pracuj nad agentami, rynkami, networkingiem, materiałami i decyzjami zawodowymi",
        "CRM bez limitu — buduj i rozwijaj swoją sieć relacji branżowych",
        "Castingi bez limitu — trzymaj role, etapy, terminy i feedback w jednym miejscu",
        "Zamieniaj Career Paths w konkretne Steps i działania",
        "„Halo, tu Twoja kariera” — LEO pilnuje, żeby plan nie został tylko planem",
      ],
      excludes: [],
      footer_line: "Sceny. Castingi. Kontakty. Strategia. Codzienne działania. Twoja kariera w jednym systemie.",
      highlight: false,
    },
    { id: "leo_light", name: "LEO LIGHT", price: "79 PLN", priceSuffix: "/ miesiąc",
      description_first: true,
      description: "Pełny system LEO dla aktora, który chce regularnie rozwijać karierę, przygotowywać sceny i działać krok po kroku — przy mniejszych miesięcznych limitach.",
      features: [
        "Przygotuj do 5 pełnych scen miesięcznie — od analizy do konkretnych decyzji aktorskich",
        "AI Reader — przećwicz do 5 scen miesięcznie i pracuj z partnerem AI do 60 minut miesięcznie",
        "Wybierz 1 gotową Career Path miesięcznie i stwórz 1 indywidualną Career Path z LEO — maksymalnie na 120 dni",
        "LEO Radar — śledź filmy i seriale w przygotowaniu, żeby wcześniej wiedzieć, co powstaje i gdzie mogą pojawić się szanse",
        "Prowadź do 5 aktywnych castingów i buduj swoją sieć w CRM do 20 kontaktów",
        "1 wariant analizy / scena",
        "30 wiadomości Career Chat / miesiąc",
        "Pełny Profil Aktora, 3 generacje",
        "2 Mastermind / miesiąc",
        "1 głos AI Reader / scena",
        "Momentum",
        "Inspirations",
        "Przypomnienia",
        "Spersonalizowane wiadomości i podpowiedzi",
        "Przypomnienia o zadaniach",
        "Miesięczne podsumowanie kariery",
      ],
      excludes: [],
      footer_line: "Sceny. Castingi. Relacje. Strategia. LEO pomaga zamienić rozwój kariery w konkretną pracę, którą możesz wykonywać każdego dnia.",
      bottom_price_line: "79 PLN / miesiąc.",
      highlight: false,
    },
    { id: "leo_annual", name: "LEO ANNUAL", price: "1989 PLN", priceSuffix: "/ rok",
      tag: "LEO z Tobą przez cały rok.",
      launch_badge: "CENA PREMIEROWA",
      best_value: true, save_line: "Oszczędzasz 349 PLN w pierwszym roku",
      features: [
        "Wszystko, co otrzymujesz w LEO Monthly",
        "Do 20 pełnych scen miesięcznie",
        "Do 20 dodatkowych wariantów miesięcznie",
        "AI Reader — do 40 scen i 4 godzin miesięcznie, z możliwością wyboru do 2 głosów partnerów AI na scenę",
        "Biblioteka gotowych Career Paths",
        "Do 5 indywidualnych Career Paths miesięcznie — nawet na 24 miesiące",
        "100 wiadomości Leo Career miesięcznie",
        "LEO Radar",
        "CRM i Manager castingów bez limitu",
        "Steps i „Halo, tu Twoja kariera”",
        "Wszystkie miesięczne limity odnawiają się co miesiąc",
        "Jedna płatność za 12 miesięcy dostępu",
      ],
      excludes: [],
      footer_line: "12 miesięcy konsekwentnej pracy nad scenami, castingami, relacjami i kierunkiem Twojej kariery.",
      highlight: true,
    },
  ],
  en: [
    { id: "free_trial", free_trial: true, name: "7 DAY FREE", price: "$0", priceSuffix: "/ 7 days",
      tag: "Meet LEO and see how it can help you work on your scenes and organize your acting career.",
      launch_badge: false,
      features: [
        "Prepare 1 complete scene with LEO — from analysis to playable acting choices",
        "Explore 1 alternative version and see how a different approach changes the scene",
        "AI Reader — rehearse your scene and prepare your self-tape with an AI scene partner",
        "Choose 1 AI partner voice for your scene",
        "Preview Career Paths and discover possible directions for your acting career",
        "10 Leo Career messages to start working on your career with your AI career assistant",
        "Start building your network with 3 CRM contacts",
        "Track 2 active auditions",
        "Turn decisions into concrete tasks and next steps",
        "“Hey, this is your career” — LEO reminds you what's worth doing next",
      ],
      excludes: [],
      footer_line: "7 days to discover LEO. No commitment.",
      highlight: false,
    },
    { id: "leo_single_scene", name: "SINGLE SCENE", price: "$4.90", priceSuffix: "/ one-time",
      tag: "Got a scene? Work it properly.",
      launch_badge: true,
      features: [
        "1 complete scene analysis — understand what's really happening between the characters",
        "3 alternative versions of the same scene — explore different objectives, tactics and ways to play it",
        "AI Reader — rehearse your lines and prepare your self-tape with an AI scene partner for up to 45 minutes",
        "Choose up to 2 AI partner voices for your scene",
        "Define your character's objective, relationship, circumstances and stakes",
        "Work through Reflection and Grounding",
        "Find playable tactics and prepare for performance",
        "Rehearse the text and keep your own notes",
        "Access every Scene Prep tool for this scene",
      ],
      excludes: [],
      footer_line: "One scene. Three approaches. Complete preparation. No subscription.",
      highlight: false,
    },
    { id: "leo_start", name: "LEO START", price: "$14.99", regular_price: "$39.99", priceSuffix: "/ month",
      tag: "For the first 50 users.",
      launch_badge: "LAUNCH PRICE\nFOR THE FIRST 50 USERS.",
      features: [
        "Prepare up to 10 complete scenes per month — from analysis to playable acting choices",
        "Explore up to 10 alternative versions and test different objectives, tactics and approaches",
        "AI Reader — rehearse up to 20 scenes per month and work with an AI scene partner for up to 3 hours per month",
        "Choose up to 2 AI partner voices for each scene",
        "Choose 2 ready-made Career Paths per month and turn them into a concrete action plan",
        "Create 1 personalized Career Path per month — LEO adapts it to your goal and can plan up to 12 months ahead",
        "LEO Radar — follow films and series in development so you know what's coming and where opportunities may emerge",
        "30 Leo Career messages per month for agents, markets, networking and your next career decisions",
        "Build your network with up to 20 CRM contacts",
        "Track up to 10 active auditions, including status, deadlines and feedback",
        "Turn your plans into concrete Steps and actions",
        "“Hey, this is your career” — LEO reminds you about the actions worth taking",
      ],
      excludes: [],
      footer_line: "Scenes. Auditions. Relationships. Strategy. LEO helps turn your career into work you can actually do every day.",
      highlight: false,
    },
    { id: "leo_sprint_48h", name: "48H CASTING SPRINT", price: "$17.90", priceSuffix: "/ one-time / 48 hours",
      tag: "Audition coming up fast? You have 48 hours to focus on doing your best work. LEO works with you.",
      launch_badge: true,
      features: [
        "Prepare up to 3 complete audition scenes",
        "Explore 1 additional version of each scene",
        "AI Reader — rehearse your lines and prepare your self-tape without looking for a scene partner — up to 3 hours within 48 hours",
        "Choose up to 2 AI partner voices for each scene",
        "Work through the full process: analysis, Objective, Reflection, Grounding and Tactics",
        "Access all Scene Prep tools",
        "Choose 1 ready-made Career Path and plan your next actions",
        "Create 1 personalized AI Career Path — up to 12 months",
        "Get 20 Leo Career messages for audition decisions and what to do next",
        "Turn what you learn from the audition into concrete Steps and actions",
      ],
      excludes: [],
      footer_line: "48 hours. Total focus. No subscription.",
      highlight: false,
    },
    { id: "leo_monthly", name: "LEO MONTHLY", price: "$31.90", regular_price: "$69.99", priceSuffix: "/ month",
      tag: "Your acting career office. All in one place.",
      launch_badge: "LAUNCH PRICE\nFOR THE FIRST 50 USERS.",
      features: [
        "Prepare up to 20 complete scenes per month — for auditions, self-tapes, rehearsals or your own material",
        "Create up to 20 alternative versions and explore different objectives, tactics and approaches",
        "AI Reader — work on up to 40 scenes per month with an AI scene partner — up to 4 hours per month",
        "Choose up to 2 AI partner voices for each scene",
        "Explore the library of ready-made Career Paths and choose the directions you want to work on",
        "Create up to 5 personalized Career Paths per month — from your next 90 days to a strategy of up to 24 months",
        "LEO Radar — follow films and series in development so you can see what's coming",
        "100 Leo Career messages per month for agents, markets, networking, materials and career decisions",
        "Unlimited CRM — build and develop real industry relationships",
        "Unlimited audition tracking — keep roles, stages, deadlines and feedback in one place",
        "Turn Career Paths into concrete Steps and actions",
        "“Hey, this is your career” — LEO keeps your plan moving into action",
      ],
      excludes: [],
      footer_line: "Scenes. Auditions. Relationships. Strategy. Daily action. Your career in one system.",
      highlight: false,
    },
    { id: "leo_light", name: "LEO LIGHT", price: "$19.99", priceSuffix: "/ month",
      description_first: true,
      description: "LEO’s complete career system for actors who want to keep moving forward, prepare scenes, and work consistently on their career — with lighter monthly limits.",
      features: [
        "Prepare up to 5 complete scenes per month — from analysis to playable acting choices",
        "AI Reader — rehearse up to 5 scenes per month and work with an AI scene partner for up to 60 minutes per month",
        "Choose 1 ready-made Career Path per month and create 1 personalized Career Path with LEO — up to 120 days",
        "LEO Radar — follow films and series in development so you can see what’s coming and where opportunities may emerge",
        "Track up to 5 active auditions and build your network with up to 20 CRM contacts",
        "1 analysis version per scene",
        "30 Career Chat messages / month",
        "Full Actor Profile, up to 3 generations",
        "2 Mastermind sessions / month",
        "1 AI Reader voice / scene",
        "Momentum",
        "Inspirations",
        "Reminders",
        "Personalized messages and nudges",
        "Task reminders",
        "Monthly career review",
      ],
      excludes: [],
      footer_line: "Scenes. Auditions. Relationships. Strategy. LEO helps turn your career into work you can actually do every day.",
      bottom_price_line: "$19.99 / month.",
      highlight: false,
    },
    { id: "leo_annual", name: "LEO ANNUAL", price: "$349", regular_price: "$699", priceSuffix: "/ year",
      tag: "LEO with you for the entire year.",
      launch_badge: "LAUNCH PRICE\nFOR THE FIRST 10 USERS.",
      best_value: true, save_line: "Save $33 per year",
      features: [
        "Everything included in LEO Monthly",
        "Up to 20 complete scenes every month",
        "Up to 20 alternative versions per month",
        "AI Reader — up to 40 scenes and 4 hours per month, with a choice of up to 2 AI scene partner voices per scene",
        "Access to the ready-made Career Path library",
        "Up to 5 personalized Career Paths per month — up to 24 months",
        "100 Leo Career messages per month",
        "LEO Radar",
        "Unlimited CRM and audition tracking",
        "Steps and “Hey, this is your career”",
        "All monthly limits refresh every month",
        "One payment for 12 months of access",
      ],
      excludes: [],
      footer_line: "12 months of consistent work on your scenes, auditions, relationships and the direction of your career.",
      highlight: true,
    },
  ],
  ja: [
    { id: "free_trial",
      name: "7日間無料",
      price: "0 PLN",
      priceSuffix: "／7日間",
      tag: "まずはLEOを試して、シーン準備と俳優としてのキャリア整理にどう役立つか体験してください。",
      footer_line: "7日間、気軽にLEOを試せます。継続の義務はありません。",
      features: [
      "LEOで1シーンを完全準備。分析から、実際に演じられる選択まで",
      "別アプローチを1案試し、選択によってシーンがどう変わるか比較",
      "AIリーダーで相手役とリハーサルし、セルフテープを準備",
      "シーンのAI相手役ボイスを1つ選択",
      "キャリアパスを試し、今後の方向性を探る",
      "AIキャリアアシスタントLEO Careerで10メッセージ利用",
      "CRMに3件まで連絡先を登録し、人脈づくりを開始",
      "進行中のオーディションを2件まで管理",
      "決めたことを具体的なタスクと次の一歩に変える",
      "「これはあなたのキャリア」— 次に動くべきことをLEOが整理"
    ],
      excludes: [] },
    { id: "leo_single_scene",
      name: "1シーン",
      price: "19.90 PLN",
      priceSuffix: "／1回",
      tag: "準備したいシーンがあるなら、きちんと向き合う。",
      footer_line: "1シーン、3つのアプローチ、完全な準備。サブスク不要。",
      features: [
      "1シーンを完全分析し、人物間で本当に起きていることを整理",
      "同じシーンを3つの別アプローチで検討。目的、戦術、演じ方の違いを試す",
      "AIリーダーでセリフをリハーサルし、AI相手役とセルフテープを準備",
      "AI相手役ボイスを最大2つ選択",
      "役の目的、関係性、状況、何が懸かっているかを整理",
      "振り返りとグラウンディングまで実施",
      "実際に演じられる戦術を見つけ、本番に備える",
      "セリフをリハーサルし、自分のノートを残す",
      "このシーンでScene Prepの全ツールを利用"
    ],
      excludes: [] },
    { id: "leo_start",
      name: "LEO START",
      price: "49 PLN",
      priceSuffix: "／月",
      tag: "先着50名。",
      footer_line: "シーン、オーディション、人とのつながり、戦略。LEOがキャリアを「毎日できる行動」に変えます。",
      features: [
      "月10シーンまで、分析から演じられる選択まで完全準備",
      "月10案まで別アプローチを試し、目的・戦術・演じ方を比較",
      "AIリーダーで月20シーンまでリハーサル。相手役を探さずセルフテープ準備",
      "各シーンでAI相手役ボイスを最大2つ選択",
      "月2つの既成キャリアパスを選び、具体的な行動プランに変える",
      "月1つの個別キャリアパスを作成。目標に合わせて最大12か月先まで計画",
      "エージェント、市場、人脈、次の判断についてLEO Careerを月30メッセージ利用",
      "CRMに20件まで連絡先を登録",
      "進行中のオーディションを10件まで、ステータス・期限・フィードバック込みで管理",
      "プランを具体的なステップと行動に変える",
      "「これはあなたのキャリア」— 今やる価値のある行動をLEOが整理"
    ],
      excludes: [] },
    { id: "leo_sprint_48h",
      name: "48時間 CASTING SPRINT",
      price: "69 PLN",
      priceSuffix: "／1回・48時間",
      tag: "オーディションまで時間がない？48時間、最高の準備に集中するためにLEOが伴走します。",
      footer_line: "48時間、完全集中。サブスク不要。",
      features: [
      "オーディション用シーンを最大3つ完全準備",
      "各シーンで別アプローチを1案追加",
      "AIリーダーで、相手役を探さずリハーサルとセルフテープ準備",
      "各シーンでAI相手役ボイスを最大2つ選択",
      "分析、目的、振り返り、グラウンディング、戦術まで一連の流れを実施",
      "Scene Prepの全ツールを利用",
      "既成キャリアパスを1つ選び、次の行動を計画",
      "個別AIキャリアパスを1つ作成・最大12か月",
      "オーディションの判断や次の行動についてLEO Careerを20メッセージ利用",
      "オーディションで得た学びを具体的なステップと行動に変える"
    ],
      excludes: [] },
    { id: "leo_monthly",
      name: "LEO MONTHLY",
      price: "119 PLN",
      priceSuffix: "／月",
      tag: "俳優としてのキャリアオフィスを、ひとつの場所に。",
      footer_line: "シーン、オーディション、人とのつながり、戦略、毎日の行動。キャリアをひとつのシステムで。",
      features: [
      "月20シーンまで完全準備。オーディション、セルフテープ、リハーサル、自主作品に",
      "月20案まで別アプローチを作成し、目的・戦術・演じ方を比較",
      "AIリーダーで月40シーンまでAI相手役と練習",
      "各シーンでAI相手役ボイスを最大2つ選択",
      "既成キャリアパスのライブラリから、取り組みたい方向を選択",
      "月5つまで個別キャリアパスを作成。次の90日から最大24か月の戦略まで",
      "エージェント、市場、人脈、資料、キャリア判断についてLEO Careerを月100メッセージ利用",
      "CRM無制限。業界での実際のつながりを築き、育てる",
      "オーディション管理無制限。役、ステージ、期限、フィードバックを一か所に",
      "キャリアパスを具体的なステップと行動に変える",
      "「これはあなたのキャリア」— プランが行動につながるようLEOが支える"
    ],
      excludes: [] },
    { id: "leo_annual",
      name: "LEO ANNUAL",
      price: "1299 PLN",
      priceSuffix: "／年",
      tag: "1年間、LEOと一緒にキャリアを動かす。",
      save_line: "年間129 PLNお得",
      footer_line: "シーン、オーディション、人とのつながり、キャリアの方向性に12か月継続して取り組めます。",
      features: [
      "LEO Monthlyの全機能",
      "毎月20シーンまで完全準備",
      "月20案まで別アプローチ",
      "AIリーダーは月40シーンまで。各シーンでAI相手役ボイスを最大2つ選択",
      "既成キャリアパスのライブラリを利用",
      "個別キャリアパスを月5つまで・最大24か月",
      "LEO Careerを月100メッセージ利用",
      "CRMとオーディション管理が無制限",
      "Stepsと「これはあなたのキャリア」",
      "各月の利用上限は毎月リセット",
      "1回の支払いで12か月利用"
    ],
      excludes: [] },
  ],
};;
